/// <reference path="Constants.js"/>
/// <reference path="HighchartsWrapper.js"/>
/// <reference path="LayoutDesigner.js"/>
/// <reference path="LayoutDesignerAdmin.js"/>
/// <reference path="ChartSetup\ChartSetupDataCom.js"/>
/// <reference path="ChartSetup\ChartSetupUIObj.js"/>
/// <reference path="DataGroupLogic.js"/>
/// <reference path="ChartSetup\LinkedChartSetup.js"/>
/// <reference path="RespondentTableSetup\RespondentTableSetup.js"/>
/// <reference path="DynamicImageSetup\DynamicImageSetup.js"/>
/// <reference path="WordCloudSetup\WordCloudSetup.js"/>
/// <reference path="EventCreatorSetup.js"/>
/// <reference path="DataFieldSetup.js"/>
/// <reference path="heatmap/HeatMapRenderer.js"/>
/// <reference path="MyStory\MyStory.js"/>
/// <reference path="IconShape\IconShapeSetup.js"/>
/// <reference path="IconShape\DynamicIconShapeSetup.js"/>
/// <reference path="IconShape\IconShapeUI.js"/>
/// <reference path="SummarySetup\SummarySetup.js"/>
/// <reference path="AdvancedAnalyticsSetup\AdvancedAnalyticsSetup.js"/>

/* gui intensive stuff */
(function (sb) {
	sb.GuiEvents = {};

	var boxMinSize = Storyboard.Constants.boxMinSize;
	var dTable;
	var zIndexBase = Storyboard.Constants.zIndexBase;	
	var currentMouseCoords = { posX: null, posY: null };

	var uiBorders = '<div class="ui-border ui-border-n"></div>'+
					'<div class="ui-border ui-border-e"></div>'+
					'<div class="ui-border ui-border-s"></div>'+
					'<div class="ui-border ui-border-w"></div>';
	var dragHandle = '<div class="drag-handle">'+
						'<div class="drag-handle-default" data-tooltip="'+ locale.get('Drag from here to swap positions of objects') +'" data-position="right"><svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><g fill="#838D93" fill-rule="nonzero"><path d="M12.625 7.375H3v-1.75h9.625V3L17 6.5 12.625 10zM7.375 13.625H17v1.75H7.375V18L3 14.5 7.375 11z"/></g></svg></div>'+
					'</div>';

    var createElementItem = Storyboard.LayoutDesigner.createElementItem;
    var itemTypes = Storyboard.Constants.itemTypes;

    function redrawLayoutSlide(layoutSlide) {
        var isChartCreator = Storyboard.Constants.itemTypes.CHART === window.ContentType;
        var ls = $("#" + layoutSlide.guid);

        if (ls.length < 1) {
            ls = $("#layoutSlideTemplate").clone().removeClass("layoutSlideTemplate").detach();
            ls.attr("id", layoutSlide.guid);
            ls.attr("guid", layoutSlide.guid);
            ls.addClass("layoutSlide");
            if (layoutSlide.isBackground)
                ls.addClass("bgSlide");
            ls.addClass("hidden");

            if (!window.IsFormReport && self != top && window.name == 'print-frame' && !layoutSlide.isBackground) {
                $("#layoutArea").append("<div class='pageBreakAfter' style='height: " + (layoutSlide.height + 20) +
                    "px; position:relative;' id='slideWrapper_" + layoutSlide.slideIndex + "'></div>");
                $("#slideWrapper_" + layoutSlide.slideIndex).append("<div class='pageLabel'><span>Page " + layoutSlide.slideIndex + "</span><div></div></div>");
                ls.appendTo("#slideWrapper_" + layoutSlide.slideIndex);
            } else
                ls.appendTo("#layoutArea");
        }

        ls.width(layoutSlide.width);
        ls.height(layoutSlide.height);
        ls.attr("slideId", layoutSlide.slideId);

        if (isChartCreator) {
            if (layoutSlide.layoutTemplateId && ChartCreatorSetup.getLayoutTemplateEnabledType() === 'enableMasterSlideLayout') {
                ls.css('background-image', 'url(FileHandler.ashx?masterSlideLayoutId=' + layoutSlide.layoutTemplateId + '&background=true&v='+ ChartCreatorSetup.getSlideMasterLayoutsVersion() +')');
            } else {
                ls.css('background-image', '');
            }
        }

        if (Storyboard.LayoutDesigner.slideShowMode && layoutSlide.slideIndex === Storyboard.LayoutDesigner.getCurrentPageNo()) {
            $('#StorytellerPagesizeViewport').css('height', layoutSlide.height);
            $("#layoutArea").height(layoutSlide.height);
            $("#layoutArea").width(layoutSlide.width);
        }
    }

    function redrawLayoutElement(layoutElement) {
        var type = Storyboard.LayoutDesigner.getLayoutElementType(layoutElement);
        var le = $('#' + layoutElement.guid);
        var layoutSlide = Storyboard.LayoutDesigner.getSlideByLayoutElement(layoutElement);
        var container = layoutElement.slideWrapper || ("#" + layoutSlide.guid);
        var isChartCreator = window.ContentType == Storyboard.Constants.itemTypes.CHART;

        //create new representation if none found
        if (le.length === 0) {
            le = $("#layoutElementTemplate").clone().removeClass("layoutElementTemplate").detach();
            le.attr("id", layoutElement.guid);
            le.attr("guid", layoutElement.guid);
            le.attr("tabindex", 0);
            le.addClass("layoutElement hidden");
            le.css("display", "block");
            le.css("z-index", layoutElement.zIndex || Storyboard.LayoutDesigner.getNewZIndex());
            le.appendTo(container);

			//also, append event handlers if in admin mode
			if ((sb.LayoutDesigner.isAdmin && !Helpers.isPreview()) || isChartCreator) {
                addEventsToLayoutElement(layoutElement);
                if (layoutElement.animate)
                    le.addClass("animated zoomIn");
            }

            // add borders if in admin mode
			if ((sb.LayoutDesigner.isAdmin && !Helpers.isPreview() && !window.IsMyStories) || isChartCreator) {
                le.append(uiBorders);
            }

			if (isChartCreator && !layoutElement.isSlideTitle && !layoutElement.isSlideSubtitle && !layoutElement.isSlideFooter) {
				le.append(dragHandle);
			}
        }

        alignElementToGrid(layoutElement);

        //apply properties, regardless of it's a new or existing element
        le.width(layoutElement.width);
        le.height(layoutElement.height);
        le.css("left", layoutElement.xCoord);
        // if element has yCoord < 0 (1st slide), it's not exported to ppt - set yCoord to 0
        layoutElement.yCoord = layoutElement.yCoord < 0 ? 0 : layoutElement.yCoord;
        le.css("top", layoutElement.yCoord);
        le.css("z-index", layoutElement.zIndex);
        le.attr("layoutElementId", layoutElement.layoutElementId);

        if (layoutElement.tags != null)
            le.attr("tags", layoutElement.tags);
        
        if (sb.LayoutDesigner.isAdmin && !Helpers.isPreview()) {
            le.toggleClass('ui-invalid', layoutElement.isValid === false && type !== itemTypes.IMAGE);
            le.toggleClass('ui-selected', layoutElement.isSelected === true);
            le.toggleClass('layoutElementXS', layoutElement.width < 140 || layoutElement.height < 20);

            if (layoutSlide.isBackground && $(".bgSlideActive").length === 0) {
                le
                    .css('pointer-events', 'none')
                    .removeClass('ui-selected').addClass('ui-locked')
                    .unbind().draggable('destroy').resizable('destroy');
            }

            if (layoutElement.groupId) {
                var layoutElementsGroup = Storyboard.LayoutDesigner.getLayoutElementsGroup(layoutElement.groupId);
                le.toggleClass('ui-group-selected', Boolean(layoutElementsGroup && layoutElementsGroup.isSelected === true));
            }

            if (!isChartCreator && (type === itemTypes.CHART || type === itemTypes.SIMPLETABLE || type === itemTypes.STATICTEXT || type === itemTypes.ICONSHAPE)) {
                le.toggleClass('ui-valid', layoutElement.isValid === true && type !== itemTypes.IMAGE);
                if(!layoutElement.isValid && type !== itemTypes.IMAGE)
                    le.addClass('ui-valid');
                else
                    le.removeClass('ui-valid');
                
            }
		}

		if (isChartCreator && (type === itemTypes.CHART || type === itemTypes.SIMPLETABLE || type === itemTypes.STATICTEXT || type === itemTypes.ICONSHAPE)) {
			le.toggleClass('ui-valid', layoutElement.isValid === true && type !== itemTypes.IMAGE);
		}

        if (isChartCreator && (type === itemTypes.CHART || type === itemTypes.SIMPLETABLE)) {
            le.next('.layoutElementShortcutsMenu').css({
                top: layoutElement.yCoord,
                left: layoutElement.xCoord + layoutElement.width + 10
            });
        }

        //redraw elements after they are shown, so we know their dom props has been set
        redrawInnerElementItems(le, layoutElement);
		if (type == itemTypes.CHART)
			updateChart(layoutElement, {});
		else if (type == itemTypes.TEXT)
			updateHtml(layoutElement);
		else if (type == itemTypes.TABLE)
			updateTable(layoutElement);
		else if (type == itemTypes.STATICTEXT)
			updateText(layoutElement);
		else if (type == itemTypes.RESPONDENTTABLE)
			updateRespondentTable(layoutElement);
		else if (type == itemTypes.DYNAMICIMAGE)
			updateDynamicImage(layoutElement);
		else if (type == itemTypes.WORDCLOUD)
			updateWordCloud(layoutElement);
		else if (type == itemTypes.SIMPLETABLE)
			updateSimpleTable(layoutElement);
		else if (type == itemTypes.DATAFIELD)
			updateDataField(layoutElement);
		else if (type == itemTypes.HEATMAP)
			updateHeatMap(layoutElement);
		else if (type == itemTypes.EVENTCREATOR)
			updateEventCreator(layoutElement);
		else if (type == itemTypes.ICONSHAPE)
			updateIconShape(layoutElement);
		else if (type == itemTypes.DYNAMICICONSHAPE)
            updateDynamicIconShape(layoutElement);
        else if (type == itemTypes.SUMMARY)
            updateSummary(layoutElement);
        else if (type == itemTypes.ADVANCEDANALYTICS)
            updateAdvancedAnalytics(layoutElement);
        else if (Storyboard.LayoutDesigner.isAdmin && type == itemTypes.EMPTYCHARTCREATOR && !(window.ContentType == Storyboard.Constants.itemTypes.CHART)){
                Storyboard.LayoutDesigner.createObjectTypeControls(le)
        }
	}

    function DeleteDOMElement(layoutElement) {
        $('#' + layoutElement.guid, $("#layoutArea")).next('.layoutElementShortcutsMenu').remove();
        $('#' + layoutElement.guid, $("#layoutArea")).remove();
    }

	function createHtmlElement(tagname, classes, layoutElementItem) {
		var elem = $(document.createElement(tagname));
		elem.addClass("layoutElementItem");
		elem.addClass(classes);
		elem.attr("id", layoutElementItem.guid);
		elem.attr("guid", layoutElementItem.guid);

		if (layoutElementItem.itemType == itemTypes.IMAGE) {
			createImageLayoutElement(layoutElementItem, elem);
		}
		else if (layoutElementItem.itemType == itemTypes.STATICTEXT) {
			elem.html(layoutElementItem.content || "");
		}
		else if (layoutElementItem.itemType == itemTypes.ICONSHAPE ||
				layoutElementItem.itemType == itemTypes.DYNAMICICONSHAPE) {
					elem.html(layoutElementItem.content ? layoutElementItem.content.split("<script")[0] : "");
		}
		else if (layoutElementItem.itemType == itemTypes.EMPTYCHARTCREATOR && window.ContentType == Storyboard.Constants.itemTypes.CHART) {
            createObjectTypeControls(elem);
		}
		else {
			elem.html(layoutElementItem.content || "");
		}

		return elem;
	}

	function createObjectTypeControls(elem) {
		if (elem) {
			var enabledTypes = ChartCreatorSetup.getEnabledObjectTypes();
			var chartButton = enabledTypes.useChart ? '<button type="button" data-tooltip="Chart" data-position="top" class="linkButton btnSetupAsChart"><img src="icons/bar_chart.png" alt="Chart"></button>' : '';
			var tableButton = enabledTypes.useTable ? '<button type="button" data-tooltip="Table" data-position="top" class="linkButton btnSetupAsTable"><img src="icons/table.png" alt="Table"></button>' : '';
			var imageButton = enabledTypes.useImage ? '<button type="button" data-tooltip="Image" data-position="top" class="linkButton btnSetupAsImage"><img src="icons/image.png" alt="Image"></button>' : '';
			var shapeButton = enabledTypes.useImage ? '<button type="button" data-tooltip="Icon/Shape" data-position="top" class="linkButton btnSetupAsShape"><img src="icons/iconshape.png" alt="Shape"></button>' : '';
			var textButton = enabledTypes.useText ? '<button type="button" data-tooltip="Text" data-position="top" class="linkButton btnSetupAsText"><img src="icons/insert-text.png" alt="Text"></button>' : '';

			var message = '';
			if (enabledTypes.useChart) message = 'chart';
			if (enabledTypes.useTable) message += (message.length > 0 ? (enabledTypes.useImage || enabledTypes.useText ? ', ' : ' or ') : '') + 'table';
			if (enabledTypes.useImage) message += (message.length > 0 ? (enabledTypes.useText ? ', ' : ' or ') : '') + 'image';
			if (enabledTypes.useIconShape) message += (message.length > 0 ? (enabledTypes.useIconShape ? ', ' : ' or ') : '') + 'shape';
			if (enabledTypes.useText) message += (message.length > 0 ? ' or ' : '') + 'text';

			var objectIcons = chartButton + tableButton + imageButton + shapeButton + textButton;
			if (window.useNewStoryTellerLayout) {
				objectIcons = objectIcons.replace(/.png/g, '.svg');
			}
			var newChartControls = '<div class="layoutElementEmptyObjectContainer"><div><p>Click the ' + message + ' to start setup</p>' + objectIcons + '</div></div>';

			$(elem)
				.html(newChartControls)
				.find('.btnSetupAsChart').bind('click', function (evt) {
					var layoutElementDiv = $(this).closest('.layoutElement');
					var layoutElement = Storyboard.LayoutDesigner.getLayoutElementByGuid(layoutElementDiv.attr('guid'));
					ChartCreatorSetup.convertToItemType(layoutElementDiv, Storyboard.Constants.itemTypes.CHART);

					deselectAllBoxes();
					selectBox(layoutElementDiv, layoutElement);
					ChartCreatorSetup.selectChartCreatorBox(layoutElementDiv, layoutElement);

					$('a[href="#variableSelection_cc"]').attr('selectAfterBind', "true");
					evt.stopPropagation();
				}).end()
				.find('.btnSetupAsTable').bind('click', function (evt) {
					var layoutElementDiv = $(this).closest('.layoutElement');
					var layoutElement = Storyboard.LayoutDesigner.getLayoutElementByGuid(layoutElementDiv.attr('guid'));
					ChartCreatorSetup.convertToItemType(layoutElementDiv, Storyboard.Constants.itemTypes.SIMPLETABLE);

					deselectAllBoxes();
					selectBox(layoutElementDiv, layoutElement);
					ChartCreatorSetup.selectChartCreatorBox(layoutElementDiv, layoutElement);

					$('a[href="#variableSelection_cc"]').attr('selectAfterBind', "true");
					evt.stopPropagation();
				}).end()
				.find('.btnSetupAsImage').bind('click', function (evt) {
					var layoutElementDiv = $(this).closest('.layoutElement');
					var guid = layoutElementDiv.attr('guid')

					$('#imageUpload').data({guid: guid, event: null, position: null}).click();

					evt.stopPropagation();
				}).end()
				.find('.btnSetupAsShape').bind('click', function (evt) {
					var layoutElementDiv = $(this).closest('.layoutElement');

					ChartCreatorSetup.convertToItemType(layoutElementDiv, Storyboard.Constants.itemTypes.ICONSHAPE);

					evt.stopPropagation();
				}).end()
				.find('.btnSetupAsText').bind('click', function (evt) {
					var layoutElementDiv = $(this).closest('.layoutElement');
					var layoutElement = Storyboard.LayoutDesigner.getLayoutElementByGuid(layoutElementDiv.attr('guid'));
					ChartCreatorSetup.convertToItemType(layoutElementDiv, Storyboard.Constants.itemTypes.STATICTEXT);

					deselectAllBoxes();
					selectBox(layoutElementDiv, layoutElement);

					$('.editContent', layoutElementDiv).trigger('click');
					evt.stopPropagation();
				});
		}
	}

	function createShapeTypeControls(elem) {
		if (elem) {
			var shapesSelectorEl = $('#shapesSelector').clone().attr('id', 'shapesSelector_cc');
			var newShapeTypeSelector = '<div class="layoutElementEmptyObjectContainer layoutElementShapeTypeSelector"><div><p>Select shape</p>' + shapesSelectorEl.html() + '</div></div>';

			$(elem)
				.css('background-image', 'none')
				.html(newShapeTypeSelector)
				.find('.iconSelect').bind('click', function (evt) {
					var layoutElementDiv = $(this).closest('.layoutElement');
					var layoutElement = Storyboard.LayoutDesigner.getLayoutElementByGuid(layoutElementDiv.attr('guid'));
					var layoutElementItem = Storyboard.LayoutDesigner.getLayoutElementItem(layoutElement);
					
					var iconShapeKey = $(this).find('use').attr('xlink:href') || '#shapeRectangle';
					iconShapeKey = iconShapeKey.replace('#shape', '');

					deselectAllBoxes();

					var settings = ChartCreatorUIObj.GetDefaultIconShapeSettings(layoutElement);

					settings.iconShapeKey = iconShapeKey;
					layoutElementItem.iconShapeKey = iconShapeKey;
					layoutElementItem.hasUnstoredChanges = true;
					layoutElement.isValid = true;

					ChartCreatorDataBinding.BindIconShapeSettings(settings, layoutElement);
					Storyboard.IconShapeCache.setIconShapeSettingsToCache(settings, layoutElementItem.guid);
					ChartCreatorSetup.setUnsaved(true);

					selectBox(layoutElementDiv, layoutElement);
					ChartCreatorSetup.selectChartCreatorBox(layoutElementDiv, layoutElement, false, true);
                    ChartCreatorUI.enableDisableExportButton();
				    ChartCreatorUI.enableDisableShareButton();
					evt.stopPropagation();
				});
		}
	}

    function createImageLayoutElement(layoutElementItem, elem) {
        var layoutElement = Storyboard.LayoutDesigner.getLayoutElementByElementItem(layoutElementItem);
        var slide = Storyboard.LayoutDesigner.getSlideByLayoutElement(layoutElement);
        
        $('.editContent', '#' + layoutElement.guid).hide();
        $('#' + layoutElement.guid).css('background-color', 'transparent');
        
        if (layoutElement.resize) {
            var reportID, img;

            if (window.IsMyStories) {
                reportID = slide.sourceReportId;
            } else if (Storyboard.LayoutDesigner.isMyStoryMode()) {
                reportID = layoutElement.reportId;
            } else {
                reportID = Helpers.getReportID();
            }

            if (!layoutElementItem.layoutElementId)
                img = $("<img src='FileHandler.ashx?layoutImage=true&Rpid=" + reportID + "&ProjId=" + encodeURIComponent(Helpers.getURLParameter("Pid")) + "&guid=" + layoutElementItem.guid + "' />");
            else
                img = $("<img src='FileHandler.ashx?layoutImage=true&Rpid=" + reportID + "&ProjId=" + encodeURIComponent(Helpers.getURLParameter("Pid")) + "&lid=" + layoutElementItem.layoutElementId + "' />");
            
            $(img).load(function () {
                resizeLayoutElementToFitImage(layoutElement, this.naturalWidth, this.naturalHeight);
            });

            $(elem).append(img);
        }
    }

    function resizeLayoutElementToFitImage(layoutElement, width, height) {
        var isChartCreator = window.ContentType == Storyboard.Constants.itemTypes.CHART;
        var pageSize = Storyboard.LayoutDesigner.getPageSize();
        var scale = 1;

        // check page width and scale image
        if (width > pageSize.width) {
            scale = pageSize.width / width;
            width *= scale;
            height *= scale;
        }

        // then check page height and scale again
        if (height > pageSize.height) {
            scale = pageSize.height / height;
            height *= scale;
            width *= scale;
        }

        if (isChartCreator) {
            // check layout element width and scale image
            if (width > layoutElement.width) {
                scale = layoutElement.width / width;
                width *= scale;
                height *= scale;
            }

            // then check layout element height and scale again
            if (height > layoutElement.height) {
                scale = layoutElement.height / height;
                height *= scale;
                width *= scale;
            }

            if (layoutElement.alignCenter !== false) {
                if (height < layoutElement.height)
                    layoutElement.yCoord += Math.round((layoutElement.height - height) / 2);
                if (width < layoutElement.width)
                    layoutElement.xCoord += Math.round((layoutElement.width - width) / 2);
            }
        }

        layoutElement.width = Math.round(width);
        layoutElement.height = Math.round(height);

        delete layoutElement.resize;
        delete layoutElement.alignCenter;

        sb.LayoutDesigner.eventRedrawLayoutElement(layoutElement);
    }

    function redrawInnerElementItems(divLayoutElement, layoutElement) {
        $(".layoutElementItem", divLayoutElement).remove();
        var i, elem, action;
        var typeActions = [
            { cType: itemTypes.HEADER, nType: 'span', nClass: 'layoutElementTitle header' },
            { cType: itemTypes.CHART, nType: 'div', nClass: 'layoutElementChart' },
            { cType: itemTypes.TEXT, nType: 'div', nClass: 'layoutElementTextMedia layoutElementTextMediaSubFormatting' },
            { cType: itemTypes.TABLE, nType: 'div', nClass: 'layoutElementTable' },
            { cType: itemTypes.LINKEDCHART, nType: 'div', nClass: 'layoutElementLinkedChart' },
            { cType: itemTypes.RESPONDENTTABLE, nType: 'div', nClass: 'layoutElementRespondentTable' },
            { cType: itemTypes.STATICTEXT, nType: 'div', nClass: 'layoutElementStaticText' },
            { cType: itemTypes.IMAGE, nType: 'div', nClass: 'layoutElementImage' },
            { cType: itemTypes.SIMPLETABLE, nType: 'div', nClass: 'layoutElementSimpleTable' },
            { cType: itemTypes.DYNAMICIMAGE, nType: 'div', nClass: 'layoutElementDynamicImage' },
            { cType: itemTypes.WORDCLOUD, nType: 'div', nClass: 'layoutElementWordCloud' },
            { cType: itemTypes.SUMMARY, nType: 'div', nClass: 'layoutElementSummary' },
            { cType: itemTypes.ADVANCEDANALYTICS, nType: 'div', nClass: 'layoutElementAdvancedAnalytics' },
            { cType: itemTypes.DATAFIELD, nType: 'div', nClass: 'layoutElementDataField' },
            { cType: itemTypes.HEATMAP, nType: 'div', nClass: 'layoutElementHeatMap' },
            { cType: itemTypes.EVENTCREATOR, nType: 'div', nClass: 'layoutElementEventCreator' },
            { cType: itemTypes.ICONSHAPE, nType: 'div', nClass: 'layoutElementIconShape' },
            { cType: itemTypes.DYNAMICICONSHAPE, nType: 'div', nClass: 'layoutElementDynamicIconShape' },
            { cType: itemTypes.EMPTYCHARTCREATOR, nType: 'div', nClass: 'layoutElementEmptyChartCreator' },
            { cType: itemTypes.FOOTER, nType: 'span', nClass: 'layoutElementTitle footer' }
        ];

        for (i = 0; i < typeActions.length; i++) {
            action = typeActions[i];
            if ((elem = Storyboard.LayoutDesigner.getElementItemByType(action.cType, layoutElement))) {
                $(divLayoutElement).append(createHtmlElement(action.nType, action.nClass, elem));
            }
        }

        measureInnerElementItems(layoutElement, divLayoutElement);
    }

    function measureInnerElementItems(layoutElement, divLayoutElement) {
        var availableHeight = layoutElement.height;
        var availableWidth = layoutElement.width;
        var domRepr, dim, elem;

        /* spans automatically gets size from browser, we just need to grab the measurements
        and update the underlying element item object */

        $.each(layoutElement.layoutElementItems, function () {
            if (this.itemType == Storyboard.Constants.itemTypes.FOOTER ||
                this.itemType == Storyboard.Constants.itemTypes.HEADER) {

                var div = $('#' + this.guid);

                if (div.length > 0) {
                    dim = getElementDimensions(div);
                    availableHeight -= dim.height;
                    Storyboard.LayoutDesigner.setElementItemProperties(this, dim);
                }
            }
        });

        //finally, give free space to chart/text element
        if ((elem = Storyboard.LayoutDesigner.getElementItemByType(itemTypes.CHART, itemTypes.TABLE, itemTypes.RESPONDENTTABLE,
            itemTypes.LINKEDCHART, itemTypes.STATICTEXT, itemTypes.TEXT, itemTypes.IMAGE,
            itemTypes.SIMPLETABLE, itemTypes.DYNAMICIMAGE, itemTypes.WORDCLOUD, itemTypes.SUMMARY, itemTypes.ADVANCEDANALYTICS,
            itemTypes.HEATMAP, itemTypes.EVENTCREATOR, itemTypes.ICONSHAPE, itemTypes.DYNAMICICONSHAPE, layoutElement))) {
            var props = {
                height: availableHeight,
                renderHeight: availableHeight,
                renderWidth: availableWidth,
                width: availableWidth
            };

            Storyboard.LayoutDesigner.setElementItemProperties(elem, props);
            domRepr = $("#" + elem.guid);
            domRepr.height(elem.renderHeight || elem.height);
            domRepr.width(elem.renderWidth || elem.width);

            if (elem.itemType == itemTypes.IMAGE && !layoutElement.resize) {
                var imageElem = domRepr;
                var reportID;
                if (window.IsMyStories) {
                    var slide = Storyboard.LayoutDesigner.getSlideByLayoutElement(layoutElement);
                    reportID = slide.sourceReportId;
                } else if (Storyboard.LayoutDesigner.isMyStoryMode()) {
                    reportID = layoutElement.reportId;
                } else {
                    reportID = Helpers.getReportID();
                }
                
                if (elem.layoutElementId) {
                    $(imageElem).html("<img " +
                        "width='" + availableWidth + "px' height='" + availableHeight + "' " +
                        "src='FileHandler.ashx?layoutImage=true&Rpid=" + reportID + "&ProjId=" + encodeURIComponent(Helpers.getURLParameter("Pid")) + "&lid=" + elem.layoutElementId + "&width=" + availableWidth + "&height=" + availableHeight + "' />");
                } else {
                    if (layoutElement.layoutTemplateId) {
                        if (layoutElement.isValid) {
                            $(imageElem).html("<img " +
                                "width='" + availableWidth + "' height='" + availableHeight + "' " +
                                "src='FileHandler.ashx?layoutImage=true&Rpid=" + reportID + "&ProjId=" + encodeURIComponent(Helpers.getURLParameter("Pid")) + "&guid=" + elem.guid + "&width=" + availableWidth + "&height=" + availableHeight + "' />");
                            $(imageElem).css("background", "");
                        } else {
                            $(imageElem).css("background", "url('images/contenttype_image_bg.png') no-repeat center center");
                        }
                    } else {
                        $(imageElem).html("<img " +
                            "width='" + availableWidth + "' height='" + availableHeight + "' " +
                            "src='FileHandler.ashx?layoutImage=true&Rpid=" + reportID + "&ProjId=" + encodeURIComponent(Helpers.getURLParameter("Pid")) + "&guid=" + elem.guid + "&width=" + availableWidth + "&height=" + availableHeight + "' />");
                    }
                }

                $(imageElem).find('img').load(function() {
                    if (Storyboard.SlidesPanel && Storyboard.SlidesPanel.isOpen()) {
                        var slide = Storyboard.LayoutDesigner.getSlideByLayoutElement(layoutElement);
                        Storyboard.SlidesPanel.renderThumbnailFromSVGs(slide.isBackground ? undefined : [slide]);
                    }
                });
            }
            if (elem.itemType == itemTypes.STATICTEXT) {
				if (!elem.layoutElementId) {
					var isChartCreator = window.ContentType > 0 && window.ContentType === Storyboard.Constants.itemTypes.CHART;
					var textElem = domRepr;
					var textElemHTML = $(textElem).html().trim();
					var textElemText = $(textElem).text().trim();
					var slideTitleText = "<div class='wrappertext slidetitletext' data-align-vertical='middle'><p style='text-align: center;'><span class='welcomeTextForEditor' style='font-family: Arial; font-size: 20px;'><strong>" +
											locale.get('Double click to add title') +
										"</strong></span></p></div>";
					var slideSubtitleText = "<div class='wrappertext slidesubtitletext' data-align-vertical='middle'><p style='text-align: center;'><span class='welcomeTextForEditor' style='font-family: Arial; font-size: 16px;'>" +
											locale.get('Double click to add subtitle') +
										"</span></p></div>";
					var slideFooterText = "<div class='wrappertext slidefootertext' data-align-vertical='middle'><p style='text-align: center;'><span class='welcomeTextForEditor' style='font-family: Arial; font-size: 12px;'>" +
											locale.get('Double click to add footer') +
										"</span></p></div>";
					var welcomeText = "<div class='wrappertext' "+ (isChartCreator ? "data-autoresize='true'" : "") +"><p><span class='welcomeTextForEditor' style='font-family: Arial; font-size: 14px;'>" +
											locale.get('Click Edit or double click box to add a text') +
										"</span></p></div>";

					if (layoutElement.isSlideTitle && textElemText.length == 0) {
						$(textElem).html(slideTitleText);
					} else if (layoutElement.isSlideSubtitle && textElemText.length == 0) {
						$(textElem).html(slideSubtitleText);
					} else if (layoutElement.isSlideFooter && textElemText.length == 0) {
						$(textElem).html(slideFooterText);
					} else if (textElemHTML.length == 0) {
						$(textElem).html(welcomeText);
					}
				}

				var dif;

				fastdom.measure(() => {
					dif = layoutElement.height - $('.wrappertext', domRepr).height();
				});

				fastdom.mutate(() => {
					if (dif < 13 && !layoutElement.diffCompensated) {
						layoutElement.height = (layoutElement.height < 10) ? 10 : layoutElement.height;
						layoutElement.diffCompensated = true;
						redrawLayoutElement(layoutElement);
					} else {
						layoutElement.diffCompensated = false;
					}
				});
			}
        }
    }

    function alignElementToGrid(layoutElement) {
        if (!Storyboard.LayoutDesigner.showGridlines || !Storyboard.LayoutDesigner.snapToGrid) return false;
        var type = Storyboard.LayoutDesigner.getLayoutElementType(layoutElement);
        var gridSize = Storyboard.LayoutDesigner.gridSize;
        var props;

        /* round coords and dimensions to match the grid snap variable */
        // don't round image's dimensions, it might make an image blurry
        if (type === itemTypes.IMAGE) {
            props = { xCoord: '', yCoord: '' };
        } else {
            props = { xCoord: '', yCoord: '', width: '', height: '' };
        }
        
        for (var prop in props)
            if (props.hasOwnProperty(prop)) {
                if (type === itemTypes.STATICTEXT && prop === 'height' && layoutElement.autoresize) {
                    layoutElement[prop] = Math.floor(Math.ceil(layoutElement[prop] / gridSize) * gridSize);
                } else {
                    layoutElement[prop] = Math.floor(Math.round(layoutElement[prop] / gridSize) * gridSize);
                }
            }
    }

    function arrangeElements(layoutElementsToArrange, direction) {
        var layoutElements = Storyboard.LayoutDesigner.getLayoutElements();
        var arrangePartitions = getPartitions(layoutElementsToArrange.sort(Helpers.sortZIndex));

        function isGrouped(layoutElement) {
            return typeof layoutElement.groupId === 'number';
        }

        function move(array, from, to) {
            array.splice(to, 0, array.splice(from, 1)[0]);
        }

        function movePartition(partition, to) {
            partition.forEach(function(layoutElement) {
                move(layoutElements, layoutElements.indexOf(layoutElement), to);
            });
        }

        // produce patitions of layout elements that needs to be moved together
        // each partition is array of one element or group of elements
        function getPartitions(layoutElementsToArrange) {
            var partitions = [];
            var groupIndexes = {};

            layoutElementsToArrange.forEach(function(layoutElement) {
                if (isGrouped(layoutElement)) {
                    if (typeof groupIndexes[layoutElement.groupId] === 'number') {
                        partitions[groupIndexes[layoutElement.groupId]].push(layoutElement);
                    } else {
                        partitions.push([layoutElement]);
                        groupIndexes[layoutElement.groupId] = partitions.length - 1;
                    }
                } else {
                    partitions.push([layoutElement]);
                }
            });

            partitions.forEach(function(partition, index, array) {
                if (partition.length > 0) {
                    var groupId = partition[0].groupId;
                    var groupLayoutElements = Storyboard.LayoutDesigner.getLayoutElementsByGroup(groupId);
                    if (partition.length > 1 && partition.length < groupLayoutElements.length) {
                        partition.reverse().forEach(function(layoutElement) {
                            array.splice(index + 1, 0, [layoutElement]);
                        })
                        array.splice(index, 1);
                    }
                }
            });

            return partitions;
        }

        // calculate final position where each patition should be moved
        // based on specified arrange direction
        function getTargetIndex(partition) {
            var lastElement = partition[partition.length - 1];
            var nextElement, prevElement, pivotIndex, skipGroupId, i;

            switch (direction) {
                case Storyboard.Constants.arrangeDirections.FRONT:
                    if (isGrouped(lastElement) && partition.length === 1) {
                        pivotIndex = layoutElements.indexOf(lastElement);
                        skipGroupId = lastElement.groupId;
                        for (i = pivotIndex + 1; i < layoutElements.length; i++) {
                            if (layoutElements[i].groupId !== skipGroupId)
                                return i - 1;
                        }
                        return i - 1;
                    } else {
                        return layoutElements.length - 1;
                    }
                case Storyboard.Constants.arrangeDirections.FORWARD:
                    pivotIndex = layoutElements.indexOf(lastElement);
                    nextElement = layoutElements[pivotIndex + 1];
                    if (!nextElement || ~layoutElementsToArrange.indexOf(nextElement))
                        return pivotIndex;
                    if (isGrouped(lastElement) && partition.length === 1) {
                        if (nextElement.groupId === lastElement.groupId)
                            return pivotIndex + 1;
                        else
                            return pivotIndex;
                    }
                    if (isGrouped(nextElement)) {
                        skipGroupId = nextElement.groupId;
                        for (i = pivotIndex + 1; i < layoutElements.length; i++) {
                            if (layoutElements[i].groupId !== skipGroupId)
                                return i - 1;
                        }
                        return i - 1;
                    } else {
                        return pivotIndex + 1;
                    }
                case Storyboard.Constants.arrangeDirections.BACKWARD:
                    pivotIndex = layoutElements.indexOf(lastElement);
                    prevElement = layoutElements[pivotIndex - 1];
                    if (!prevElement || ~layoutElementsToArrange.indexOf(prevElement))
                        return pivotIndex;
                    if (isGrouped(lastElement) && partition.length === 1) {
                        if (prevElement.groupId === lastElement.groupId)
                            return pivotIndex - 1;
                        else
                            return pivotIndex;
                    }
                    if (isGrouped(prevElement)) {
                        skipGroupId = prevElement.groupId;
                        for (i = pivotIndex - 1; i >= 0; i--) {
                            if (layoutElements[i].groupId !== skipGroupId)
                                return i + 1;
                        }
                        return i + 1;
                    } else {
                        return pivotIndex - 1;
                    }
                case Storyboard.Constants.arrangeDirections.BACK:
                    if (isGrouped(lastElement) && partition.length === 1) {
                        pivotIndex = layoutElements.indexOf(lastElement);
                        skipGroupId = lastElement.groupId;
                        for (i = pivotIndex - 1; i >= 0; i--) {
                            if (layoutElements[i].groupId !== skipGroupId)
                                return i + 1;
                        }
                        return i + 1;
                    } else {
                        return 0;
                    }
                default:
                    return null;
            }
        }

        switch (direction) {
            case Storyboard.Constants.arrangeDirections.FRONT:
                arrangePartitions.forEach(function(partition) {
                    movePartition(partition, getTargetIndex(partition));
                });
                break;
            case Storyboard.Constants.arrangeDirections.FORWARD:
                arrangePartitions.reverse().forEach(function(partition) {
                    movePartition(partition, getTargetIndex(partition));
                });
                break;
            case Storyboard.Constants.arrangeDirections.BACKWARD:
                arrangePartitions.forEach(function(partition) {
                    movePartition(partition.reverse(), getTargetIndex(partition));
                });
                break;
            case Storyboard.Constants.arrangeDirections.BACK:
                arrangePartitions.reverse().forEach(function(partition) {
                    movePartition(partition.reverse(), getTargetIndex(partition));
                });
                break;
            default:
                layoutElements.forEach(function(le, index) {
                    le.zIndex = zIndexBase + index + 1;
                });
        }

        layoutElements.forEach(function(le, index) {
            le.zIndex = zIndexBase + index + 1;
            Storyboard.LayoutDesigner.updateLayoutElement(le);
        });
    }

    function arrangeElementToIndex(layoutElement, newZIndex) {
        var frontZIndex = Storyboard.LayoutDesigner.getNewZIndex();
        var layoutElements = Storyboard.LayoutDesigner.getLayoutElements();
        layoutElements.sort(Helpers.sortZIndex);
        
        if ((+newZIndex) < (+frontZIndex) && (+newZIndex) > (+zIndexBase)) {
            var currentZIndex = layoutElement.zIndex;
            
            for (var i in layoutElements) {
                if ((newZIndex > currentZIndex) &&
                    (layoutElements[i].zIndex > currentZIndex && layoutElements[i].zIndex <= newZIndex)) {
                        layoutElements[i].zIndex = layoutElements[i].zIndex - 1;
                        Storyboard.LayoutDesigner.updateLayoutElement(layoutElements[i]);
                } else if ((newZIndex < currentZIndex) && 
                        (layoutElements[i].zIndex >= newZIndex && layoutElements[i].zIndex < currentZIndex)) {
                            layoutElements[i].zIndex = layoutElements[i].zIndex + 1;
                            Storyboard.LayoutDesigner.updateLayoutElement(layoutElements[i]);
                } else if (layoutElements[i].zIndex == currentZIndex) {
                    layoutElements[i].zIndex = newZIndex;
                    Storyboard.LayoutDesigner.updateLayoutElement(layoutElements[i]);
                }
            }
        }
    }


    /**
     * Set selected layout elements and groups coordinates
     * 
     * @param {string} coordName The name of coordinate: 'xCoord' or 'yCoord'
     * @param {number|string} coordValue New position value as number or percentage string
     * @param {any} coordOrigin The origin of positioning: 'left', 'right', 'center', 'top' 'bottom'
     * @returns {void}
     */
    function setElementsCoord(coordName, coordValue, coordOrigin) {
        var pageSize = Storyboard.LayoutDesigner.getPageSize(),
            newValue = parseInt(coordValue, 10),
            stateObj = {eventName: "move", eventElements : []},
            pageSizeProp;

        if (isNaN(newValue)) return false;

        if (coordName === 'xCoord') pageSizeProp = 'width';
        else if (coordName === 'yCoord') pageSizeProp = 'height';
        else return false;
        
        if (typeof coordValue === 'string' && coordValue.substring(coordValue.length, coordValue.length - 1) === '%')
            newValue = newValue/100 * pageSize[pageSizeProp];

        if (coordOrigin === 'right' || coordOrigin === 'bottom')
            newValue = pageSize[pageSizeProp] - newValue;

        // Move layout elements
        $('.ui-selected', '#layoutArea').each(function (index) {
            var curLayoutElement = Storyboard.LayoutDesigner.getLayoutElementByGuid($(this).attr('guid'));
            var oldStateValues = {}, newStateValues = {};

            oldStateValues[coordName] = curLayoutElement[coordName];
            
            if (coordOrigin === 'right' || coordOrigin === 'bottom')
                curLayoutElement[coordName] = newStateValues[coordName] = newValue - curLayoutElement[pageSizeProp];
            else if (coordOrigin === 'center')
                curLayoutElement[coordName] = newStateValues[coordName] = newValue - Math.round((curLayoutElement[pageSizeProp] / 2));
            else
                curLayoutElement[coordName] = newStateValues[coordName] = newValue;

            Storyboard.LayoutDesigner.updateLayoutElement(curLayoutElement);

            if (oldStateValues[coordName] !== newStateValues[coordName])
                stateObj.eventElements.push({
                    guid: curLayoutElement.guid,
                    oldValues: oldStateValues,
                    newValues: newStateValues
                });
        });

        // Move groups
        $('.layoutElementsGroup', '#layoutArea').each(function (index) {
            var groupId = parseInt($(this).attr('layoutelementsgroupid'));
            var groupPosition = $(this).position();
            var curLayoutElements = Storyboard.LayoutDesigner.getLayoutElementsByGroup(groupId);
            var groupDiff = 0;

            if (coordName === 'xCoord')
                if (coordOrigin === 'right') groupDiff = (newValue - $(this).outerWidth()) - groupPosition.left;
                else if (coordOrigin === 'center') groupDiff = (newValue - Math.round($(this).outerWidth() / 2)) - groupPosition.left;
                else groupDiff = newValue - groupPosition.left;
            else if (coordName === 'yCoord')
                if (coordOrigin === 'bottom') groupDiff = (newValue - $(this).outerHeight()) - groupPosition.top;
                else if (coordOrigin === 'center') groupDiff = (newValue - Math.round($(this).outerHeight() / 2)) - groupPosition.top;
                else groupDiff = newValue - groupPosition.top;

            groupDiff = Math.round(groupDiff);

            curLayoutElements.forEach(function(curLayoutElement){
                var oldStateValues = {}, newStateValues = {};
                var newLayoutElementValue = curLayoutElement[coordName] + groupDiff;

                oldStateValues[coordName] = curLayoutElement[coordName];
                curLayoutElement[coordName] = newStateValues[coordName] = newLayoutElementValue;
                Storyboard.LayoutDesigner.updateLayoutElement(curLayoutElement);
    
                if (oldStateValues[coordName] !== newStateValues[coordName])
                    stateObj.eventElements.push({
                        guid: curLayoutElement.guid,
                        oldValues: oldStateValues,
                        newValues: newStateValues
                    });
            });
        });

        Storyboard.LayoutDesigner.layoutElementsSizeOrCoordChanged(stateObj);
    }
    
    /**
     * Set selected layout elements and groups size
     * 
     * @param {string} sizeName The size name: 'width' or 'height'
     * @param {string|number} sizeValue New size value as number or percentage string
     * @param {boolean} maintainAspectRatio 
     * @returns {void}
     */
    function setElementsSize(sizeName, sizeValue, maintainAspectRatio) {
        var slideSize = $(".bgSlideActive").length > 0 ?
                $.extend({}, Storyboard.LayoutDesigner.getPageSize()) :
                Storyboard.LayoutDesigner.getCurrentSlideSize();
        
        var newValue = parseInt(sizeValue, 10);
        var stateObj = {eventName: "resize", eventElements : []};
        
        var minMax = function(newValue, sizeName) {
            if (newValue < boxMinSize[sizeName]) newValue = boxMinSize[sizeName];
            //if (newValue > slideSize[sizeName]) newValue = slideSize[sizeName];
            
            return newValue;
        };
        
        if (isNaN(newValue)) return false;
        
        if (typeof sizeValue === 'string' && sizeValue.substring(sizeValue.length, sizeValue.length - 1) === '%')
            newValue = newValue/100 * slideSize[sizeName];
        
        newValue = minMax(newValue, sizeName);
        
        // Resize layout elements
        $('.ui-selected', '#layoutArea').each(function (index) {
            var curLayoutElement = Storyboard.LayoutDesigner.getLayoutElementByGuid($(this).attr('guid')),
                newWidth, newHeight, oldStateValues = {}, newStateValues = {};
            
            oldStateValues.width = curLayoutElement.width;
            oldStateValues.height = curLayoutElement.height;

            if (sizeName === 'width') {
                newWidth = newValue;
                if (maintainAspectRatio) {
                    newHeight = minMax(((curLayoutElement.height * newWidth) / curLayoutElement.width), 'height');
                }
            } else if (sizeName === 'height') {
                newHeight = newValue;
                if (maintainAspectRatio) {
                    newWidth = minMax(((curLayoutElement.width * newHeight) / curLayoutElement.height), 'width');
                }
            }

            if (typeof(newWidth) === 'number') curLayoutElement.width = newStateValues.width = Math.round(newWidth);
            if (typeof(newHeight) === 'number') curLayoutElement.height = newStateValues.height = Math.round(newHeight);

            Storyboard.LayoutDesigner.updateLayoutElement(curLayoutElement);
            Storyboard.GuiEvents.layoutElementResized(curLayoutElement);

            if (oldStateValues.width !== newStateValues.width && oldStateValues.height !== newStateValues.height)
                stateObj.eventElements.push({
                    guid: curLayoutElement.guid,
                    oldValues: oldStateValues,
                    newValues: newStateValues
                });
        });

        // Resize groups
        $('.layoutElementsGroup', '#layoutArea').each(function (index) {
            var groupId = parseInt($(this).attr('layoutelementsgroupid'));
            var curLayoutElements = Storyboard.LayoutDesigner.getLayoutElementsByGroup(groupId);
            var groupWidth = $(this).outerWidth();
            var groupHeight = $(this).outerHeight();
            var groupPosition = $(this).position();
            var newGroupWidth = sizeName === 'width' ? newValue : (groupWidth * newValue) / groupHeight;
            var newGroupHeight = sizeName === 'height' ? newValue : (groupHeight * newValue) / groupWidth;

            curLayoutElements.forEach(function(curLayoutElement) {
                var newWidth, newHeight, newTop, newLeft,
                    oldStateValues = {}, newStateValues = {};

                oldStateValues.width = curLayoutElement.width;
                oldStateValues.height = curLayoutElement.height;
                oldStateValues.xCoord = curLayoutElement.xCoord;
                oldStateValues.yCoord = curLayoutElement.yCoord;

                if (sizeName === 'width') {
                    newWidth = (curLayoutElement.width * newGroupWidth) / groupWidth;
                    newLeft = Math.round(((curLayoutElement.xCoord - groupPosition.left) * newGroupWidth) / groupWidth + groupPosition.left);
                    if (maintainAspectRatio) {
                        newHeight = (curLayoutElement.height * newWidth) / curLayoutElement.width;
                        newTop = Math.round(((curLayoutElement.yCoord - groupPosition.top) * newGroupHeight) / groupHeight + groupPosition.top);
                    }
                } else if (sizeName === 'height') {
                    newHeight = (curLayoutElement.height * newGroupHeight) / groupHeight;
                    newTop = Math.round(((curLayoutElement.yCoord - groupPosition.top) * newGroupHeight) / groupHeight + groupPosition.top);
                    if (maintainAspectRatio) {
                        newWidth = (curLayoutElement.width * newHeight) / curLayoutElement.height;
                        newLeft = Math.round(((curLayoutElement.xCoord - groupPosition.left) * newGroupWidth) / groupWidth + groupPosition.left);
                    }
                }

                if (typeof(newWidth) === 'number') curLayoutElement.width = newStateValues.width = Math.round(newWidth);
                if (typeof(newHeight) === 'number') curLayoutElement.height = newStateValues.height = Math.round(newHeight);
                if (typeof(newLeft) === 'number') curLayoutElement.xCoord = newStateValues.xCoord = Math.round(newLeft);
                if (typeof(newTop) === 'number') curLayoutElement.yCoord = newStateValues.yCoord = Math.round(newTop);
    
                Storyboard.LayoutDesigner.updateLayoutElement(curLayoutElement);
                Storyboard.GuiEvents.layoutElementResized(curLayoutElement);
    
                if (oldStateValues.width !== newStateValues.width && oldStateValues.height !== newStateValues.height)
                    stateObj.eventElements.push({
                        guid: curLayoutElement.guid,
                        oldValues: oldStateValues,
                        newValues: newStateValues
                    });
            });
        });

        Storyboard.LayoutDesigner.layoutElementsSizeOrCoordChanged(stateObj);
    }

    function setElementsFullSize() {
        var slideSize = Storyboard.LayoutDesigner.getCurrentSlideSize(),
            stateObj = {eventName: "resize", eventElements : []};

        $('.ui-selected', '#layoutArea').each(function (index) {
            var curLayoutElement = Storyboard.LayoutDesigner.getLayoutElementByGuid($(this).attr('guid')),
                oldStateValues = {}, newStateValues = {};
            
            oldStateValues.width = curLayoutElement.width;
            oldStateValues.height = curLayoutElement.height;
            oldStateValues.xCoord = curLayoutElement.xCoord;
            oldStateValues.yCoord = curLayoutElement.yCoord;
                                            
            curLayoutElement.width = newStateValues.width = slideSize.width;
            curLayoutElement.height = newStateValues.height = slideSize.height;
            curLayoutElement.xCoord = newStateValues.xCoord = 0;
            curLayoutElement.yCoord = newStateValues.yCoord = 0;

            Storyboard.LayoutDesigner.updateLayoutElement(curLayoutElement);
            Storyboard.GuiEvents.layoutElementResized(curLayoutElement);

            if (oldStateValues.width === newStateValues.width && oldStateValues.height === newStateValues.height &&
                oldStateValues.xCoord === newStateValues.xCoord && oldStateValues.yCoord === newStateValues.yCoord)
                return;
            else
                stateObj.eventElements.push({
                    guid: curLayoutElement.guid,
                    oldValues: oldStateValues,
                    newValues: newStateValues
                });
        });

        Storyboard.LayoutDesigner.layoutElementsSizeOrCoordChanged(stateObj);
    }

	function layoutElementResized(layoutElement) {
		var layoutElementItem = Storyboard.LayoutDesigner.getLayoutElementItem(layoutElement);

		if (layoutElementItem.itemType == itemTypes.SIMPLETABLE &&
			($("#" + layoutElement.guid + " .layoutElementNoData").length > 0 || $("#" + layoutElement.guid + "  .layoutElementSimpleTable table").length > 0)) {
			ChartSetupProxy.GetSimpleTable({ layoutElement: layoutElement },
				function (result) {
					Storyboard.LayoutDesigner.getChartForLayoutElementCompleted(result);
				});
		} else {
			Storyboard.LayoutDesigner.eventUpdateSimpleTable(layoutElementItem);
		}

		if (layoutElementItem.itemType == itemTypes.ICONSHAPE) {
			IconShapeUI.updateIconShapeElementSize(layoutElementItem);

			if (window.ContentType === Storyboard.Constants.itemTypes.CHART) {
				var iconShapeSettings = Storyboard.IconShapeCache.getIconShapeSettingsFromCache(layoutElementItem.guid);

				if (iconShapeSettings) {
					layoutElementItem.hasUnstoredChanges = true;
					iconShapeSettings.content = layoutElementItem.content;
					Storyboard.IconShapeCache.setIconShapeSettingsToCache(iconShapeSettings, layoutElementItem.guid);
				}
			}
		}

		if (Storyboard.SlidesPanel && Storyboard.SlidesPanel.isOpen()) {
			var slide = Storyboard.LayoutDesigner.getSlideByLayoutElement(layoutElement);
			Storyboard.SlidesPanel.renderThumbnailFromSVGs([slide]);
		}
	}

    function setLayoutElementHidden(layoutElement, hidden) {
        layoutElement.isHidden = hidden;
        $("#" + layoutElement.guid).toggleClass('ui-hidden', hidden).toggle(!hidden);
        $("#" + layoutElement.guid).next('.layoutElementAdminUnlock').toggle(!hidden);
        
        if (hidden === true) {
            layoutElement.isSelected = false;
            $("#" + layoutElement.guid).removeClass('ui-selected');
        }
    }
    
    function setLayoutElementLocked(layoutElement, locked) {
        layoutElement.isLocked = locked;
        $("#" + layoutElement.guid).toggleClass('ui-locked', locked);
        
        if (locked === true) {
            layoutElement.isSelected = false;
            $("#" + layoutElement.guid).removeClass('ui-selected').css('pointer-events', 'none')
                                       .unbind().draggable('destroy').resizable('destroy');

            if ($("#" + layoutElement.guid + ' + .layoutElementAdminUnlock').length === 0) {
                $('<button/>', {
                    'type':         'button', 
                    'className':    'layoutElementAdminUnlock',
                    'title':        locale.get('Unlock'),
                    html: '<i class="DUI-icon DUI-icon-access"></i>',
                    css: {
                        left:   layoutElement.xCoord + layoutElement.width - 30,
                        top:    layoutElement.yCoord,
                        zIndex: layoutElement.zIndex
                    },
                    click: function() {
                        Storyboard.GuiEvents.setLayoutElementLocked(layoutElement, false);
                        $("#" + layoutElement.guid).trigger('mouseenter');
                    }
                }).insertAfter("#" + layoutElement.guid);
            }
        } else {
            $("#" + layoutElement.guid).css('pointer-events', '').next('.layoutElementAdminUnlock').remove();
            Storyboard.GuiEvents.addEventsToLayoutElement(layoutElement);
        }
    }

	function updateSimpleTable(layoutElement) {
        var chartResult, customMessage, cachedItem = Storyboard.LayoutDesigner.getCachedContent(layoutElement);
        if (cachedItem) {
            chartResult = ChartSetupDataCom.GetChartData(cachedItem);
            customMessage = chartResult.customMessage;
        }

		var tableInfo = '<div class="layoutElementTableInfo">'+ locale.get('Click to setup table') +'</div>';
		var div = $('#' + layoutElement.guid).find(".layoutElementSimpleTable, .layoutElementNoDataText, .layoutElementNoData")[0];

		$(div).empty();

		if (!chartResult || !cachedItem) {
			if (window.ContentType === Storyboard.Constants.itemTypes.CHART && !layoutElement.isValid) {
				if (layoutElement.isLoadingFavorite === true) {
					delete layoutElement.isLoadingFavorite;
				} else if (layoutElement.width > 200 && layoutElement.height > 150) {
					$(div).html(tableInfo);
				}
			}
			return;
		}

		if (customMessage && customMessage.length > 0) {
			$(div).removeClass("layoutElementSimpleTable").addClass("layoutElementCustomMessage")
					.html($('<span/>', { class: 'customMessage', text: locale.get(customMessage) }));
        } else if (chartResult.chartOptions == 'nodata' || chartResult.tableHtml == "") {
			if (window.ContentType === Storyboard.Constants.itemTypes.CHART && !layoutElement.isValid) {
				// chart creator objects that were not set up
				layoutElement.GUILoaded = false;
				$(div).parent().removeClass('ui-valid');
				if (layoutElement.width > 200 && layoutElement.height > 150) {
					$(div).html(tableInfo);
				}
			} else if (Storyboard.LayoutDesigner.useNewNoDataLayout) {
				$(div).removeClass("layoutElementSimpleTable").addClass("layoutElementNoDataText")
					.html($('<span/>', { 'class': 'noData', html: locale.get('no data') }))
					.css({ 'background-image': '' });
			} else {
				$(div).removeClass("layoutElementSimpleTable").addClass("layoutElementNoData").css({ 'background-image': '' });
			}
		} else {
			$(div).removeClass("layoutElementNoData layoutElementNoDataText layoutElementCustomMessage").addClass("layoutElementSimpleTable");

			$(div).css({ 'background-image': 'none', 'background-color': 'transparent' });
			$('<style>' + chartResult.tableCss + '</style>').appendTo(div);
			$(div).append(chartResult.tableHtml);
			
			if (window.ContentType !== Storyboard.Constants.itemTypes.CHART && (chartResult.allowExcelExport || chartResult.allowCsvExport)) {
                renderExcelExportOption(layoutElement, div, chartResult);
            }

			if (chartResult.userEvents) {
				Storyboard.LayoutDesigner.UserEvents.addEventsToTable($('#' + layoutElement.guid)[0], chartResult.userEvents);
			}

			// sortable table
			if ($("table td[sortKey]", div).length > 0) {
				$("table td[sortKey]", div).addClass("stSortableColumn");

				$(".stSortableColumn", div).unbind("click").bind("click", function () {
					layoutElement.columnToSortBy = $(this).attr("sortKey");
					layoutElement.sortDirection = $(this).attr("sortDirection") == "desc" ? 8 : 9 // 8 - ascending, 9 - descending

					Storyboard.LayoutControls.showLoadingBar("Loading simple table");

					ChartSetupProxy.GetSimpleTable({
							layoutElement: layoutElement,
							storyId: $("#ddlMyStories").val() || 0,
							slideId: Storyboard.LayoutDesigner.getCurrentSlide().slideId
						},
						function (result) {
							Storyboard.LayoutDesigner.getChartForLayoutElementCompleted(result);
							Storyboard.LayoutControls.hideLoadingBar();
						});
				});
			}

			// IE doesn't handle the scaling of SVGs correctly when the size is unspecified
			var ua = window.navigator.userAgent;
			var isIE = /MSIE|Trident|Edge/.test(ua);
			if (isIE) {
				$(div).find('table td > img[src$=".svg"]').each(function() {
					$(this).css('display', 'none');
					$(this).css({
						'display': 'block',
						'max-width': $(this).parent().innerWidth() || '100%'
					});
				});
			}

			if (window.ContentType === Storyboard.Constants.itemTypes.CHART) {
				Storyboard.LayoutDesigner.UserEvents.removeTooltipFromElement(div);

				var elementItem = Storyboard.LayoutDesigner.getLayoutElementItem(layoutElement);
				var tableWidth = 0;
				var tableHeight = 0;
				$('table', div).each(function () {
					tableWidth = Math.max(tableWidth, $(this).width());
					tableHeight += $(this).height();
				});

				var leDiv = $(div).parent().first();
				var tableOverflowX = tableWidth > elementItem.width;
				var tableOverflowY = tableHeight > elementItem.height;
				leDiv.css('border-right', tableOverflowX ? '2px dashed #E7415D' : '')
					.find('.ui-border.ui-border-e').toggle(tableWidth <= elementItem.width);
				leDiv.css('border-bottom', tableOverflowY ? '2px dashed #E7415D' : '')
					.find('.ui-border.ui-border-s').toggle(tableHeight <= elementItem.height);

				if (tableOverflowX || tableOverflowY) {
					var position = tableOverflowX ? "top right" : "bottom left";
					var message = "The table is not completely visible as the table is bigger than the object box. \nTo see the whole table you can: \n - increase the size of the object by dragging the border\n - update the formatting of the table like for example applying a smaller font size or smaller cell margins\n - update the selections so less rows/columns are displayed";
					Storyboard.LayoutDesigner.UserEvents.addTooltipToElement(div, message, position);
				}
			}
		}

        if (Storyboard.SlidesPanel && Storyboard.SlidesPanel.isOpen()) {
            var slide = Storyboard.LayoutDesigner.getSlideByLayoutElement(layoutElement);
            Storyboard.SlidesPanel.renderThumbnailFromSVGs([slide]);
        }

		$(document).trigger('DAPI.simpleTableLoaded', [layoutElement]);
	}

	function renderExcelExportOption(layoutElement, div, chartResult) {
        var elementType = Storyboard.LayoutDesigner.getLayoutElementType(layoutElement);
        var layoutElementDiv = $(div).parent();
        var right = 0;

        if (elementType === itemTypes.SIMPLETABLE) {
            right = Math.max(layoutElement.width - $(div).find('table').first().width(), 0);
        }

		if (sb.LayoutDesigner.isAdmin && !Helpers.isPreview() && window.ContentType !== Storyboard.Constants.itemTypes.CHART) {
            if (layoutElementDiv.find(".stExportToExcel").length === 0 && chartResult.allowExcelExport) {
                $(div).siblings('.DUIToolbar').append($('<span/>', {
                    class: 'DUIButton standardButton stExportToExcel',
                    text: locale.get('Export to Excel')
                }));
            } else if (!chartResult.allowExcelExport)
                $(div).siblings('.DUIToolbar').find("span.stExportToExcel").remove();

            if (layoutElementDiv.find(".stExportToCSV").length === 0 && chartResult.allowCsvExport) {
                $(div).siblings('.DUIToolbar').append($('<span/>', {
                    class: 'DUIButton standardButton stExportToCSV',
                    text: locale.get('Export to CSV')
                }));
            } else if (!chartResult.allowCsvExport)
                $(div).siblings('.DUIToolbar').find("span.stExportToCSV").remove();
        } else {
            if (chartResult.allowCsvExport)
                $(div).append($('<span/>', {
                    class: 'DUIButton standardButton previewExport stExportToCSV',
                    text: locale.get('Export to CSV'),
                    css: {
                        display: 'none',
                        right: right
                    }
                }));

            if (chartResult.allowExcelExport)
                $(div).append($('<span/>', {
                    class: 'DUIButton standardButton previewExport stExportToExcel',
                    text: locale.get('Export to Excel'),
                    css: {
                        display: 'none',
                        right: right + (chartResult.allowCsvExport ? $(div).find(".stExportToCSV").outerWidth() : 0)
                    }
                }));

			$(layoutElementDiv).mouseenter(function () {
				layoutElementDiv.find(".stExportToExcel, .stExportToCSV").show();
			});
			$(layoutElementDiv).mouseleave(function () {
				layoutElementDiv.find(".stExportToExcel, .stExportToCSV").hide();
			});
        }

        layoutElementDiv.find(".stExportToExcel, .stExportToCSV").unbind('click').bind("click", function (evt) {
            var exportType = $(this).hasClass('stExportToExcel') ? 4 : 5;
            exportObjectToExcel(layoutElement, exportType);
            evt.stopPropagation();
        });
    }

    function exportObjectToExcel(layoutElement, exportType) {
        var data = {
            layoutElement: layoutElement,
            storyId: $("#ddlMyStories").val() || 0,
            sortFilter: null,
            exportType: exportType
        };

        // do not store chart creator exports for now
        if (Storyboard.GeneralSettings.storeSingleObjectExports) {
            var params = {
                data: data,
                method: "QueueObjectExport",
                message: locale.get("Preparing " + (exportType === 4 ? "Excel" : "CSV") + " download")
            };

            if ($(".downloadcontainer:visible").length < 1)
                $("#btnOpenExportPanel").click();
            Storyboard.LayoutDesigner.queueExport(params);
        } else {
            ChartSetupProxy.ExportObject(data, function (res) {
                var downloadKey = res;
                var frame = document.getElementById('fileFrame');
                if (frame === null) {
                    frame = document.createElement("iframe");
                    frame.name = "fileFrame";
                    frame.id = "fileFrame";

                    document.body.appendChild(frame);
                    frame.style.width = "0px";
                    frame.style.height = "0px";
                    frame.style.border = "0px";
                }
                frame.src = "DownloadFile.aspx?downloadKey=" + downloadKey;
            });
        }
    }

    function exportObjectToImage(layoutElement) {
        var data = {
            layout: Storyboard.LayoutDesigner.getLayoutGrid(),
            layoutElement: layoutElement
        };

        ChartCreatorDataCom.GetChartImage(data, function (res) {
            var downloadKey = res;
            var frame = document.getElementById('fileFrame');
            if (frame === null) {
                frame = document.createElement("iframe");
                frame.name = "fileFrame";
                frame.id = "fileFrame";

                document.body.appendChild(frame);
                frame.style.width = "0px";
                frame.style.height = "0px";
                frame.style.border = "0px";
            }
            frame.src = "DownloadFile.aspx?downloadKey=" + downloadKey;
        });
    }

    function updateHeatMap(layoutElement) {
        var heatMapElem = Storyboard.LayoutDesigner.getElementItemByType(itemTypes.HEATMAP, layoutElement);
        HeatMapRenderer.redrawHeatMap(heatMapElem);
    }

    function updateEventCreator(layoutElement) {
        var eventCreatorElem = Storyboard.LayoutDesigner.getElementItemByType(itemTypes.EVENTCREATOR, layoutElement);
        EventCreatorSetup.redrawEventCreator(eventCreatorElem);
    }

    function updateDataField(layoutElement) {
        var dataFieldElem = Storyboard.LayoutDesigner.getElementItemByType(itemTypes.DATAFIELD, layoutElement);
        DataFieldSetup.redrawDataField(dataFieldElem);
    }

    function updateChart(layoutElement, detailTables) {
        var chartData, chartOptions, customMessage, chartDiv, cachedItem = Storyboard.LayoutDesigner.getCachedContent(layoutElement);
        if (cachedItem) {
            chartData = ChartSetupDataCom.GetChartData(cachedItem);
            chartOptions = chartData.chartOptions;
            customMessage = chartData.customMessage;
        }

        var islinked = 0;
        var chartElem = Storyboard.LayoutDesigner.getElementItemByType(itemTypes.CHART, layoutElement);
        if (!chartElem) {
            islinked = 1;
            chartElem = Storyboard.LayoutDesigner.getElementItemByType(itemTypes.LINKEDCHART, layoutElement);
        }
        if (chartElem) {
            var chartInfo = '<div class="layoutElementChartInfo">'+ locale.get('Click to setup chart') +'</div>';
            if (islinked == 0)
                chartDiv = getChartDivForLayoutElement(layoutElement);
            else
                chartDiv = getLinkedChartDivForLayoutElement(layoutElement);

            if (customMessage && customMessage.length > 0) {
                $(chartDiv).removeClass("layoutElementChart").addClass("layoutElementCustomMessage")
                        .html($('<span/>', { class: 'customMessage', text: locale.get(customMessage) }));
            } else if (chartOptions && (chartOptions == 'nodata' || chartOptions == 'notpreloaded')) {
                if (window.ContentType === Storyboard.Constants.itemTypes.CHART && !layoutElement.isValid) {
                    // chart creator objects that were not set up
                    layoutElement.GUILoaded = false;
                    $(chartDiv).parent().removeClass('ui-valid');
                    if (layoutElement.width > 200 && layoutElement.height > 150) {
                        $(chartDiv).html(chartInfo);
                    }
                } else if (Storyboard.LayoutDesigner.useNewNoDataLayout) {
                    $(chartDiv).removeClass("layoutElementChart").addClass("layoutElementNoDataText")
                        .html($('<span/>', { 'class': 'noData', html: locale.get('no data') }));
                } else {
                    $(chartDiv).removeClass("layoutElementChart").addClass("layoutElementNoData").empty();
                }

                $(chartDiv).css({ 'background-image': '' });
                Storyboard.HighchartsWrapper.destroyCharts(chartElem.guid);
            } else if (chartOptions) {
                $(chartDiv).removeClass("layoutElementNoData layoutElementNoDataText layoutElementCustomMessage").addClass("layoutElementChart");
                $(chartDiv).css({ 'background-image': 'none', 'background-color': 'transparent' });
				if (window.ContentType === Storyboard.Constants.itemTypes.CHART) {
					$(chartDiv).find('.wrappertitle').each(function () { $(this).parent().css('background-color', $(this).css('background-color')); });
                    $(chartDiv).parent().addClass('ui-valid');
				}

				chartOptions.chart.guid = chartElem.guid;
				var cachedChartData = ChartSetupDataCom.GetChartData(cachedItem);
				var styles = cachedChartData.chartStyles;
				var userEvents = cachedChartData.userEvents;

				Storyboard.HighchartsWrapper.produceChart(chartDiv, chartOptions, chartElem.guid, true, detailTables, styles, userEvents);

				if (window.ContentType !== Storyboard.Constants.itemTypes.CHART) {
                    renderExcelExportOption(layoutElement, chartDiv, chartData);
                }
			} else {
				$(chartDiv).empty();

				if (window.ContentType === Storyboard.Constants.itemTypes.CHART) {
					if (layoutElement.isLoadingFavorite === true) {
						delete layoutElement.isLoadingFavorite;
					} else if (layoutElement.width > 200 && layoutElement.height > 150) {
						$(chartDiv).html(chartInfo);
					}
				}
			}
		} else {
			chartDiv = getChartDivForLayoutElement(layoutElement);
			$(chartDiv).css({ 'background-image': 'none', 'background-color': 'transparent' });
		}

        if (Storyboard.SlidesPanel && Storyboard.SlidesPanel.isOpen()) {
            var slide = Storyboard.LayoutDesigner.getSlideByLayoutElement(layoutElement);
            Storyboard.SlidesPanel.renderThumbnailFromSVGs([slide]);
        }
    }
    function updateHtml(layoutElement) {
        var htmlElem = Storyboard.LayoutDesigner.getElementItemByType(itemTypes.TEXT, layoutElement);
        var el;

        if (htmlElem) {
            if (htmlElem.content != null && htmlElem.content.replace(/ /gi, '').length > 0) {
                el = $("#" + htmlElem.guid);
                //Execute scripts in the text component
                //Because of all the re-renderings, execute only on third iteration
                var parRenderIter = el.parent().attr('data-rendered');
                if (parRenderIter !== undefined && parseInt(parRenderIter, 10) > 1) {
                    el.removeClass("layoutElementTextMedia");
                    el.empty();
                    el[0].innerHTML = (htmlElem.content !== null) ? HTMLHelpers.executeScript(htmlElem.content) : "";
                }
                var renderIterVal = (parRenderIter !== undefined) ? parRenderIter : 0;
                el.parent().attr('data-rendered', parseInt(renderIterVal, 10) + 1);
            } else {
                el = $("#" + htmlElem.guid);
                if (!el.hasClass('layoutElementTextMedia')) el.addClass("layoutElementTextMedia");
            }
        }

        if (Storyboard.SlidesPanel && Storyboard.SlidesPanel.isOpen()) {
            var slide = Storyboard.LayoutDesigner.getSlideByLayoutElement(layoutElement);
            Storyboard.SlidesPanel.renderThumbnailFromSVGs([slide]);
        }
    }

    function updateIconShape(layoutElement) {
        var layoutElementItem = Storyboard.LayoutDesigner.getElementItemByType(itemTypes.ICONSHAPE, layoutElement);
        var slide

        IconShapeSetup.redrawIconShape(layoutElementItem);

        if (window.ContentType === Storyboard.Constants.itemTypes.CHART) {
            if (!layoutElementItem.content) {
                var layoutElementItemDiv = document.getElementById(layoutElementItem.guid);
                if (layoutElementItemDiv) {
                    createShapeTypeControls(layoutElementItemDiv);
                }
            }

            if (Storyboard.SlidesPanel.isOpen()) {
                slide = Storyboard.LayoutDesigner.getSlideByLayoutElement(layoutElement);
                Storyboard.SlidesPanel.renderThumbnailFromSVGs([slide]);
            }
        }

        if (Storyboard.SlidesPanel && Storyboard.SlidesPanel.isOpen()) {
            slide = Storyboard.LayoutDesigner.getSlideByLayoutElement(layoutElement);
            Storyboard.SlidesPanel.renderThumbnailFromSVGs([slide]);
        }
    }

	function updateDynamicIconShape(layoutElement) {
		var dynIconShapeElem = Storyboard.LayoutDesigner.getElementItemByType(itemTypes.DYNAMICICONSHAPE, layoutElement);
		DynamicIconShapeSetup.redrawDynamicIconShape(dynIconShapeElem);

		if (Storyboard.SlidesPanel && Storyboard.SlidesPanel.isOpen()) {
            var slide = Storyboard.LayoutDesigner.getSlideByLayoutElement(layoutElement);
            Storyboard.SlidesPanel.renderThumbnailFromSVGs([slide]);
        }
    }

    function updVerAlignMasterSlides(textlayoutElement) {
        var alignAtr = textlayoutElement.find('.wrappertext').find('p');
        if (typeof alignAtr !== 'undefined' && alignAtr !== false) {
            alignAtr.each(function () { $(this).parent().attr('data-align-vertical', $(this).attr('data-align-vertical')); });
            alignAtr.removeAttr('data-align-vertical');
        }
    }

	function updateText(layoutElement) {
		var textLayoutElement = $("#" + layoutElement.guid);
		var wrapperTextElement = $(textLayoutElement).find('.wrappertext');
		var backgroundColor = wrapperTextElement.length ? wrapperTextElement.get(0).style.backgroundColor : '';
		
		if (backgroundColor && backgroundColor !== 'rgba(0, 0, 0, 0)') {
			wrapperTextElement.parent().css('background-color', backgroundColor);
		}

		textLayoutElement.find('.SBLink').each(function() { setSBLink(this); });

        updVerAlignMasterSlides(textLayoutElement);
		var isChartCreator = window.ContentType > 0 && window.ContentType === Storyboard.Constants.itemTypes.CHART;
		if (isChartCreator) {
			if (!layoutElement.isSlideTitle && !layoutElement.isSlideSubtitle && !layoutElement.isSlideFooter) {
				var div = textLayoutElement.find('.layoutElementStaticText').get(0);
				var textElemText = $(div).text().trim();
				if (textElemText.length == 0) {
					$(div).css("background", "url('images/contenttype_text_bg.png') no-repeat center center");
				} else {
					$(div).css("background-image", "none");

					Storyboard.LayoutDesigner.UserEvents.removeTooltipFromElement(div);

					var elementItem = Storyboard.LayoutDesigner.getLayoutElementItem(layoutElement);
					var textWidth = $('.wrappertext', div).width();
					var textHeight = $('.wrappertext', div).height();

					var leDiv = $(div).parent().first();
					var textOverflowX = textWidth > elementItem.width;
					var textOverflowY = textHeight > elementItem.height;
					leDiv.css('border-right', textOverflowX ? '2px dashed #E7415D' : '')
						.find('.ui-border.ui-border-e').toggle(textWidth <= elementItem.width);
					leDiv.css('border-bottom', textOverflowY ? '2px dashed #E7415D' : '')
						.find('.ui-border.ui-border-s').toggle(textHeight <= elementItem.height);

					if (textOverflowX || textOverflowY) {
						var position = textOverflowX ? "top right" : "bottom left";
						var message = "The text is not completely visible as the text is longer than the object box. \nTo see the whole text you can: \n - increase the size of the object by dragging the border\n - update the formatting of the text like for example applying a smaller font size";
						Storyboard.LayoutDesigner.UserEvents.addTooltipToElement(div, message, position);
					}
				}
			}
		}

		Storyboard.LayoutDesigner.UserEvents.addEventsToElement(textLayoutElement.find('.layoutElementStaticText').get(0));

		if (Storyboard.SlidesPanel && Storyboard.SlidesPanel.isOpen()) {
			var slide = Storyboard.LayoutDesigner.getSlideByLayoutElement(layoutElement);
			Storyboard.SlidesPanel.renderThumbnailFromSVGs([slide]);
		}
	}

    function updateDynamicText(layoutElement) {
        var htmlElem = Storyboard.LayoutDesigner.getElementItemByType(itemTypes.STATICTEXT, layoutElement);

        if (htmlElem) {
			var tokensPattern = new RegExp("([\\[](Q[0-9]+|INT|TP|MA|VS|RD|HFILTER)[:][LO][:\\d:]*[\\]])");
            if (tokensPattern.test(htmlElem.content)) {
                Tokens.replaceTokens(htmlElem);
            }
        }
    }

    function updateTable(layoutElement) {
        var tableElem = Storyboard.LayoutDesigner.getElementItemByType(itemTypes.TABLE, layoutElement);

        if (tableElem) {
            var el = $("#" + tableElem.guid);
            if (tableElem.content) {
                el.removeClass("layoutElementTable");
            } else if (!el.hasClass('layoutElementTable'))
                el.addClass('layoutElementTable');
        }
    }

    function updateRespondentTable(layoutElement) {
        var tableElem = Storyboard.LayoutDesigner.getElementItemByType(itemTypes.RESPONDENTTABLE, layoutElement);
        RespondentTableSetup.redrawRespondentTable(tableElem);

        if (Storyboard.SlidesPanel && Storyboard.SlidesPanel.isOpen()) {
            var slide = Storyboard.LayoutDesigner.getSlideByLayoutElement(layoutElement);
            Storyboard.SlidesPanel.renderThumbnailFromSVGs([slide]);
        }
    }

    function updateDynamicImage(layoutElement) {
        var dynImageElem = Storyboard.LayoutDesigner.getElementItemByType(itemTypes.DYNAMICIMAGE, layoutElement);
        DynamicImageSetup.redrawDynamicImage(dynImageElem);

        if (Storyboard.SlidesPanel && Storyboard.SlidesPanel.isOpen()) {
            var slide = Storyboard.LayoutDesigner.getSlideByLayoutElement(layoutElement);
            Storyboard.SlidesPanel.renderThumbnailFromSVGs([slide]);
        }
    }

    function updateWordCloud(layoutElement) {
        var wordCloudElem = Storyboard.LayoutDesigner.getElementItemByType(itemTypes.WORDCLOUD, layoutElement);
        WordCloudSetup.redrawWordCloud(wordCloudElem);

        if (Storyboard.SlidesPanel && Storyboard.SlidesPanel.isOpen()) {
            var slide = Storyboard.LayoutDesigner.getSlideByLayoutElement(layoutElement);
            Storyboard.SlidesPanel.renderThumbnailFromSVGs([slide]);
        }
    }

    function updateSummary(layoutElement) {
        var summaryElem = Storyboard.LayoutDesigner.getElementItemByType(itemTypes.SUMMARY, layoutElement);
        SummarySetup.redrawSummary(summaryElem);

        if (Storyboard.SlidesPanel && Storyboard.SlidesPanel.isOpen()) {
            var slide = Storyboard.LayoutDesigner.getSlideByLayoutElement(layoutElement);
            Storyboard.SlidesPanel.renderThumbnailFromSVGs([slide]);
        }
    }

    function updateAdvancedAnalytics(layoutElement) {
        var advancedAnalyticsElementItem = Storyboard.LayoutDesigner.getElementItemByType(itemTypes.ADVANCEDANALYTICS, layoutElement);
        AdvancedAnalyticsSetup.redrawAdvancedAnalytics(advancedAnalyticsElementItem);

        if (Storyboard.SlidesPanel && Storyboard.SlidesPanel.isOpen()) {
            var slide = Storyboard.LayoutDesigner.getSlideByLayoutElement(layoutElement);
            Storyboard.SlidesPanel.renderThumbnailFromSVGs([slide]);
        }
    }

    function getHeaderDivForLayoutElement(layoutElement) {
        return $("#" + layoutElement.guid + " > .header")[0];
    }

    function getFooterDivForLayoutElement(layoutElement) {
        return $("#" + layoutElement.guid + " > .footer")[0];
    }

    function getChartDivForLayoutElement(layoutElement) {
        return $("#" + layoutElement.guid).find(".layoutElementChart, .layoutElementNoDataText, .layoutElementNoData")[0];
    }

    function getLinkedChartDivForLayoutElement(layoutElement) {
        return $("#" + layoutElement.guid).find(".layoutElementLinkedChart, .layoutElementNoDataText, .layoutElementNoData")[0];
    }

	function updateLayoutTitles(layoutElement) {
		var header, footer;
		var headerBody, footerBody, headerBackground, footerBackground;

		if (window.ContentType == Storyboard.Constants.itemTypes.CHART) {
			header = tinymce.get('txtHeader_cc').getContent();
			footer = tinymce.get('txtFooter_cc').getContent();
			headerBody = tinymce.get('txtHeader_cc').getBody();
			footerBody = tinymce.get('txtFooter_cc').getBody();
			headerBackground = headerBody.style.backgroundColor;
			footerBackground = footerBody.style.backgroundColor;
			
			if (headerBackground)
				header = '<div class="wrappertitle" style="background-color: ' + headerBackground + '">' + header + '</div>';			
			header = $("<div></div>").append(header).html();

			if (footerBackground)
				footer = '<div class="wrappertitle" style="background-color: ' + footerBackground + '">' + footer + '</div>';			
			footer = $("<div></div>").append(footer).html();
		} else {
			header = HTMLHelpers.htmlEncode($("#txtHeader", "#layoutElementEditor").val());
			footer = HTMLHelpers.htmlEncode($("#txtFooter", "#layoutElementEditor").val());
		}

		Storyboard.LayoutDesigner.addOrReplaceElementItem(createElementItem(itemTypes.HEADER, { content: header }), layoutElement);
		Storyboard.LayoutDesigner.addOrReplaceElementItem(createElementItem(itemTypes.FOOTER, { content: footer }), layoutElement);

		Storyboard.LayoutDesigner.updateLayoutElement(layoutElement);
		Storyboard.LayoutDesigner.setState(true); //unsaved state
    }

    function setSBLink(SBLinkElement) {
        var linkRef     = $(SBLinkElement).attr('data-link');
        var reportRef   = $(SBLinkElement).attr('data-report');
        var LE = $(SBLinkElement).closest('.layoutElement');
        var lei = $(SBLinkElement).closest('.layoutElementItem');

        // if object has a llink with new implementation, remove this old one
        var eventsData = $(lei).data("userEvents") || $(LE).find("[data-user-events]").data("user-events");
        if (eventsData && typeof eventsData === 'object') {
            var hasLinkEvent = eventsData.filter(function (layoutElementEvent) {
                return layoutElementEvent.name === 'Link';
            }
            ).length > 0;

            if (hasLinkEvent) {
                $(SBLinkElement).remove();
                return;
            }
        }

        if (!LE.hasClass('SBLinkLayoutElement') && (!Storyboard.LayoutDesigner.isAdmin || Helpers.isPreview())) {
            LE.addClass('SBLinkLayoutElement').unbind('click');

            if (LE.contents().text().replace(/\s+/g, '').replace(/(\r\n|\n|\r)/gm,"").length < 1){
                //Provide hasLayout
                LE.children().css({'background-color':'#fff','opacity':'0.001'});
            }

            if (reportRef == Storyboard.LayoutDesigner.getLayoutGrid().reportId) {
                LE.bind('click', function () { 
                    Storyboard.LayoutDesigner.setPageNoByLayoutElementId(linkRef); 
                });
            } else {
                LE.bind('click', function () {
                    $.cookie('SBLink', 'elementId:' + linkRef + '|reportId:' + reportRef);
                    window.location.href = window.location.href.replace("RpId=" + Storyboard.LayoutDesigner.getLayoutGrid().reportId, "RpId=" + reportRef);
                });
            }
        }
    }

    function addEventsToLayoutElement(layoutElement) {
        if (window.IsMyStories)
            return;

        var layoutGrid = $('#layoutArea');
        var el = $("#" + layoutElement.guid);

        $(el).unbind();
        $(".designTable, .editContent, .tableOptions, .menu", el).unbind("click");

        $(".layoutElementTitle", el).addClass("layoutElementTitleAdmin");
        el.addClass("layoutElementAdmin");

        addDragableAndResizable(el);

        $(el)
            .bind("mousedown", function (evt) {
                mousedownInContentbox(evt);
            })
            .bind("click", function (evt) {
                evt.preventDefault();
                evt.stopPropagation();

                if (!evt.target.type || evt.target.type !== 'text') {
                    if (window.IsFormReport && (!Storyboard.LayoutDesigner.isAdmin || Helpers.isPreview()) && $(this).find(".layoutElementDataField").length > 0) {
                        $(this).addClass("layoutElementAdminSelected");
                    } else {
                        $(this).focus().addClass("layoutElementAdminSelected");
                    }
                }

                clickInContentbox(evt);
            })

            .bind("dblclick", function (evt) {
                var itemType = Storyboard.LayoutDesigner.getLayoutElementType(layoutElement);

                evt.preventDefault();
                evt.stopPropagation();
				deselectAndHideAll(evt);

				if (window.ContentType === itemTypes.CHART) {
					if (itemType === itemTypes.CHART) {
						if ($(evt.target).closest('.layoutElementTitle').length > 0) {
							ChartCreatorUI.openOptionsPopup('stylesHeaderAndFooter');
						} else {
							ChartCreatorUI.closeAllMenus();
							ChartCreatorUI.showContextMenu(evt);
						}
					} else if (itemType === itemTypes.STATICTEXT) {
						$(".editContent", this).trigger("click");
					} else if (itemType === itemTypes.ICONSHAPE) {
						selectBox(evt.currentTarget, layoutElement);
						ChartCreatorUI.openShapeSetup(layoutElement);
					}
				} else {
					if (itemType !== itemTypes.IMAGE && itemType !== itemTypes.EMPTYCHARTCREATOR) {
						$(".editContent", this).trigger("click");
					}
				}
			})

			.bind("contextmenu", function (evt) {
				evt.preventDefault();
				evt.stopPropagation();

				hideAllMenusAndPanels(evt);

				if (!$(evt.currentTarget).hasClass('ui-selected')) {
					//this element is not selected. Unselect all and select it.
					deselectAndHideAll(evt);
					selectBox(evt.currentTarget, layoutElement);
					if (window.ContentType === itemTypes.CHART) {
						ChartCreatorSetup.selectChartCreatorBox(el, layoutElement);
					}
					updateTemplatesMenu();
					Storyboard.LayoutDesigner.LayoutElementsToolbar.updateToolbarState();
				}

				if (window.ContentType === itemTypes.CHART) {
					ChartCreatorUI.closeAllMenus();
					ChartCreatorUI.showContextMenu(evt);
				} else {
					showContextMenu(evt);
				}
			})

			.hover(
				function (evt) {
					if (!evt.ctrlKey && !evt.metaKey) {
						if (!layoutElement.groupId || layoutElement.sizePositionUnlocked)
							Storyboard.GuiEvents.updateElementCoordsAndSizes($(this), null);
					} else {
						$(this).children('.DUIToolbar').css('display', 'none');
					}
					$(this).addClass('ui-hover');

					if (window.ContentType === itemTypes.CHART) {
						ChartCreatorUI.renderShortcutsMenuHover();
					}
				},
				function (evt) {
					$(this).children('.DUIToolbar').css('display', '');
					$(this).removeClass('ui-hover').children('.DUI-ST-EL-DIMENSION').remove();
					$(this).next('.layoutElementShortcutsMenuHover:not(.ui-hover)').remove();
				}
			)

			.bind("dragstart", function (evt, ui) {
				if (!$(this).hasClass('ui-selected')) {
					deselectAllBoxes();
					deselectAllGroups();
					selectBox(this, layoutElement);
				}

				$('.ui-selected, .ui-group-selected, .layoutElementsGroup', layoutGrid).each(setOriginalSizeAndPosition);

				if (Storyboard.LayoutDesigner.showSmartGuideLines)
					smartGuidesPrepare(layoutElement);

				if (window.ContentType === itemTypes.CHART &&
					!layoutElement.isSlideTitle && !layoutElement.isSlideSubtitle && !layoutElement.isSlideFooter &&
					$.contains(this.querySelector('.drag-handle'), evt.originalEvent.target)) {
						addDroppableToChartCreatorLayoutElements();
				}

				if (evt.ctrlKey || evt.altKey) {
					createDraggingCloneElements();
				}

				if (ui) {
					bindCopyCursorEvents(evt);
				}
				
				hideAllMenusAndPanels(evt);
			})

			.bind("drag", function (evt, ui) {
				dragHandler(evt, ui);

				Storyboard.GuiEvents.updateElementCoordsAndSizes(el, ui);
				if (Storyboard.LayoutDesigner.showSmartGuideLines)
					smartGuidesCheck(layoutElement, ui);
			})

			.bind("dragstop", function (evt, ui) {
				var stateObj = ui.stateObj || {eventName: "move", eventElements : []};

				if (Storyboard.LayoutDesigner.showSmartGuideLines)
					$('.smartguide', layoutGrid).remove();

				if ($(this).hasClass('ui-draggable-dropped')) {
					$(this).removeClass('ui-draggable-dropped');
					return;
				}

                unbindCopyCursorEvents(evt);
                removeDraggingCloneElements();

                moveOrDuplicate(evt, ui, stateObj);

                if (window.ContentType === itemTypes.CHART &&
                    !layoutElement.isSlideTitle && !layoutElement.isSlideSubtitle && !layoutElement.isSlideFooter &&
                    $.contains(this.querySelector('.drag-handle'), evt.originalEvent.target)) {
                        removeDroppableFromChartCreatorLayoutElements();
                }

				Storyboard.GuiEvents.updateElementCoordsAndSizes(el, ui);
				Storyboard.LayoutDesigner.layoutElementsSizeOrCoordChanged(stateObj);
			})

			.bind("resizestart", function (evt, ui) {
                var itemType = Storyboard.LayoutDesigner.getLayoutElementType(layoutElement);
                var maintainAspectRatio = $('#DUI-ST-TB-ASPECT-RATIO').hasClass('locked');

                if (itemType === itemTypes.IMAGE) {
                    var axis = ['ne', 'se', 'sw', 'nw'];
                    var handle = evt.originalEvent.target.className.slice(-2);
                    if (axis.includes(handle)) {
                        maintainAspectRatio = true;
                    }
                }

				if (!$(evt.target).hasClass('ui-selected')) {
					deselectAllBoxes();
					selectBox(this, layoutElement);
				}

				$('.ui-selected, .ui-group-selected, .layoutElementsGroup', layoutGrid).each(setOriginalSizeAndPosition);

				if (Storyboard.LayoutDesigner.showSmartGuideLines)
					smartGuidesPrepare(layoutElement);

				$(this).resizable('option', 'aspectRatio', maintainAspectRatio);
				hideAllMenusAndPanels(evt);
			})

			.bind("resize", function (evt, ui) {
				if (typeof ui !== 'object') return;

				resizeHandler(evt, ui);

				Storyboard.GuiEvents.updateElementCoordsAndSizes(el, ui);
				if (Storyboard.LayoutDesigner.showSmartGuideLines)
					smartGuidesCheck(layoutElement, ui);
			})

			.bind("resizestop", function (evt, ui) {
				var stateObj = {eventName: "resize", eventElements : []};

				resizeStopHandler(evt, ui, stateObj);

				if (Storyboard.LayoutDesigner.showSmartGuideLines)
					$('.smartguide', layoutGrid).remove();

				Storyboard.GuiEvents.updateElementCoordsAndSizes(el, ui);
				Storyboard.LayoutDesigner.layoutElementsSizeOrCoordChanged(stateObj);
			})

			.bind("keydown", function(evt) {
				if ($(evt.target).hasClass('layoutElement') && 
					(evt.keyCode >= 37 && evt.keyCode <= 40 || evt.which >= 37 &&
					evt.which <= 40 || evt.keyCode === 9 || evt.which === 9)) {
						evt.preventDefault();
				}
				if (evt.ctrlKey || evt.metaKey || evt.altKey) return;
				if (layoutElement.groupId && !layoutElement.sizePositionUnlocked) return;

				if (evt.target && evt.target.tagName === 'DIV')
					layoutElementItemManipulation.move(evt);
			});

            var animationEnd = Helpers.animationEnd();
            if (animationEnd) {
                $(el).bind(animationEnd, function() {
                    delete layoutElement.animate;
                    $(this).removeClass('animated zoomIn');
                    $(this).unbind(animationEnd);
                });
            }

		if (layoutElement.groupId && !layoutElement.sizePositionUnlocked)
            $(el).draggable('disable').resizable('disable');

        if (Storyboard.LayoutDesigner.lockPositions)    $(el).draggable('disable');
        if (Storyboard.LayoutDesigner.lockSizes)        $(el).resizable('disable');

        $(".designTable", el).bind("click", function (evt) {
            if (Storyboard.LayoutDesigner.getElementItemByType(itemTypes.TABLE, layoutElement)) {
                if (!el.hasClass('table-design')) {
                    getCachedStoryboardTable(layoutElement, Storyboard.Constants.CTRenderType.NO_FORMATTING_RULES);
                }
            }

            this.blur();
            evt.preventDefault();
        });

        $(".editContent", el).bind("click", function (evt) {
            Storyboard.LayoutDesigner.UserEvents.closeAllTooltips();
            Storyboard.LayoutControls.hideLoadingBar();
            hideAllMenusAndPanels(evt);
            hideEditPanels(evt);

            evt.preventDefault();

            var contentElement = Storyboard.LayoutDesigner.getLayoutElementItem(layoutElement);
            var elementType = Storyboard.LayoutDesigner.getLayoutElementType(layoutElement);

            if (elementType == itemTypes.EMPTYCHARTCREATOR) {
                return;
            }

            if (Storyboard.Elements && 
                Storyboard.Elements.ReportEditorSidebar && 
                (elementType === itemTypes.CHART || elementType === itemTypes.SIMPLETABLE)) {
                    Storyboard.EventBus.emit(Storyboard.Constants.Events.ITEM_SIDEPANEL_OPEN, {guid: layoutElement.guid});
                return;
            }

            if (elementType == itemTypes.CHART || elementType == itemTypes.SIMPLETABLE || elementType == itemTypes.HEATMAP) {
                Storyboard.ChartLab.loadChartSettings(function () {

                    function chartTableSettingsLoader() {
                        var message = elementType === itemTypes.SIMPLETABLE ? "Loading simple table settings" : "Loading chart settings";
                        Storyboard.LayoutControls.showLoadingBar(locale.get(message) + "...");
                        Storyboard.DataGroupLogic.setupDataGroupEditing(contentElement, layoutElement, elementType);

                        if (elementType == itemTypes.CHART) {
                            $('label[for="ddlTrimType"], label[for="ddlTrimLowResultType"]').html(locale.get('Axis/Legend text'));
                            ChartSetupProxy.GetChartStyles(layoutElement,
                            function (styles) {
                                ChartSetupUI.bindChartStylesSelectElements();
                                Storyboard.GuiEvents.DataGroupEdit.setChartStyleCacheWithGuid(styles, layoutElement.guid);
                                Storyboard.GuiEvents.DataGroupEdit.loadDataGroups(layoutElement);
                            });
                        }
                        else if (elementType == itemTypes.SIMPLETABLE) {
                            RespondentTableSetup.loadStylesForLayoutElement(layoutElement, function () {
                                setupRTStyling(false);
                                $('label[for="ddlTrimType"]').html(locale.get('Row/column headers'));
                                $("label[for=\"ddlTrimLowResultType\"]").html(locale.get("Row/column headers"));
                            });
                            Storyboard.GuiEvents.DataGroupEdit.loadDataGroups(layoutElement);
                        }
                        else {
                            Storyboard.GuiEvents.DataGroupEdit.loadDataGroups(layoutElement);
                        }
                    }

                    if (!ChartSetupDataBinding.FiltersLoaded) {
                        ChartSetupProxy.GetFilters(function(filters) {
                            ChartSetupDataBinding.FiltersLoaded = true;
                            ChartSetupDataBinding.BindFilters(filters);
                            ChartSetupDataBinding.BindHFilters();
                            chartTableSettingsLoader();
                        });
                    } else
                        chartTableSettingsLoader();
                });
            }
            else if (elementType == itemTypes.DATAFIELD) {
                DataFieldSetup.setupEditPanel(contentElement);
            }
            else if (elementType == itemTypes.EVENTCREATOR) {
                EventCreatorSetup.setupEditPanel(contentElement);
            }
            else if (elementType == itemTypes.ICONSHAPE) {
                IconShapeSetup.setupEditPanel(contentElement);
            }
            else if (elementType == itemTypes.DYNAMICICONSHAPE) {
                DynamicIconShapeSetup.setupEditPanel(contentElement);
            }
            else if (elementType == itemTypes.TEXT) {
                var htmlEditor = $("#txtTextMediaContent");
                htmlEditor.empty();
                var content = (contentElement.content !== null) ? contentElement.content : "";
                initTextMediaEdit(content);
                htmlEditor.parent().addClass("htmlEditor");
                $("#DUI-ST-SAVESETTINGS").removeAttr("disabled");
            }
            else if (elementType == itemTypes.TABLE) {
                elementType = itemTypes.TABLE;
            }
            else if (elementType == itemTypes.RESPONDENTTABLE) {
                $("#rtDivPreview").css('height', '0px').empty();
                $("#chbInvertRespTablePreview").removeAttr("checked").trigger("change");
                elementType = itemTypes.RESPONDENTTABLE;
                contentElement.templateId = layoutElement.templateId;
                RespondentTableSetup.setupEditPanel(contentElement);
                setupRTStyling(true);
            }
            else if (elementType == itemTypes.DYNAMICIMAGE) {
                elementType = itemTypes.DYNAMICIMAGE;
                DynamicImageSetup.setupEditPanel(contentElement);
            }
            else if (elementType == itemTypes.LINKEDCHART) {
                elementType = itemTypes.LINKEDCHART;
                LinkedChartSetup.setupEditPanel(contentElement);
            }
            else if (elementType == itemTypes.WORDCLOUD) {
                elementType = itemTypes.WORDCLOUD;
                contentElement.templateId = layoutElement.templateId;
                WordCloudSetup.setupEditPanel(contentElement);
            }
            else if (elementType == itemTypes.SUMMARY) {
                elementType = itemTypes.SUMMARY;
                contentElement.templateId = layoutElement.templateId;
                SummarySetup.setupEditPanel(contentElement);
            }
            else if (elementType == itemTypes.ADVANCEDANALYTICS) {
                elementType = itemTypes.ADVANCEDANALYTICS;
                contentElement.templateId = layoutElement.templateId;
                AdvancedAnalyticsSetup.setupEditPanel(contentElement);
            }
            else if (elementType == itemTypes.STATICTEXT) {
                elementType = itemTypes.STATICTEXT;
                el.draggable("destroy");
                el.resizable("destroy");

                var htmlElem = Storyboard.LayoutDesigner.getElementItemByType(itemTypes.STATICTEXT, layoutElement);

                if (htmlElem) {
                    var domRepr = $("#" + htmlElem.guid);
                    $(domRepr).find(".hidToken").each(function () {
                        var textNode = $(this).contents();
                        textNode.insertBefore($(this));
                    });
                    $(domRepr).find(".hidToken").remove();
                    $(domRepr).find(".tokenValue").remove();
                }

                var domLayoutElement = $('.layoutElementAdmin[guid="' + layoutElement.guid + '"]', layoutGrid);
                var domElementItem = $('.layoutElementItem[guid="' + contentElement.guid + '"]', layoutGrid);
                var selectedLanguage = $("#ddlLng").val();
                var mainLanguageName = $('#ddlLng option[value="1"]').text();
                var multilanguageMessage;

				var afterTextEdit = function() {
					showStandardDUIButtons(layoutElement);
					domLayoutElement.find('.designTable').css('display', 'none');
					addDragableAndResizable(el);
					Storyboard.GuiEvents.hideEditPanels();
					Storyboard.LayoutDesigner.updateLayoutElement(layoutElement);
					DUImessage.hide(multilanguageMessage);

					if (window.ContentType === Storyboard.Constants.itemTypes.CHART) {
						var dataGroup = ChartCreatorDataBinding.GetBoundDataGroup();
						if (dataGroup && dataGroup.guid) {
							$('#' + dataGroup.guid).parent('.layoutElementAdmin').addClass('layoutElementAdminFocused');
						}

						var isSlideText = layoutElement.isSlideTitle || layoutElement.isSlideSubtitle || layoutElement.isSlideFooter;
						var textElemText = domElementItem.text().trim();

						if (textElemText.length == 0) {
							domLayoutElement.removeClass('ui-valid');
							if (!isSlideText) domElementItem.css("background", "url('images/contenttype_text_bg.png') no-repeat center center");
						} else {
							domLayoutElement.addClass('ui-valid');
							if (!isSlideText) domElementItem.css("background-image", "none");
						}
					}

					if (Storyboard.SlidesPanel && Storyboard.SlidesPanel.isOpen()) {
						var slide = Storyboard.LayoutDesigner.getSlideByLayoutElement(layoutElement);
						Storyboard.SlidesPanel.renderThumbnailFromSVGs([slide]);
					}
				}

				Storyboard.LayoutDesigner.UserEvents.removeEventsFromElement(document.getElementById(layoutElement.guid));

				domElementItem.LightTextBox();
				showContextDUIButtons(layoutElement);

				domLayoutElement.find('.saveEdit').unbind("click").bind("click", function (evt2) {
					domElementItem.LightTextBox('destroy');

					if ($('.wrappertext', domElementItem).attr('data-autoresize') === 'true') {
						var autoResizedHeight = parseInt($('.wrappertext', domElementItem).css('height'));
						if (autoResizedHeight) {
							if (autoResizedHeight !== layoutElement.height) {
								Storyboard.LayoutDesigner.setState(true); //unsaved state
							}
							contentElement.height = autoResizedHeight;
							layoutElement.height = autoResizedHeight;
						}
						layoutElement.autoresize = true;
					} else {
						layoutElement.autoresize = false;
					}

					if (window.ContentType === Storyboard.Constants.itemTypes.CHART) {
						var textElemText = domElementItem.text().trim();
						layoutElement.isValid = textElemText.length > 0;
					} else {
						layoutElement.isValid = true;
					}

					domLayoutElement.toggleClass('ui-valid', layoutElement.isValid);
					sb.LayoutDesigner.saveLayoutElementState(layoutElement);

					Storyboard.Html.saveHtml(domElementItem.html(), contentElement.layoutElementId, contentElement.guid, contentElement, '');
					afterTextEdit();
				});

                domLayoutElement.find('.cancelEdit').unbind("click").bind("click", function (evt2) {
                    domElementItem.LightTextBox('destroy');
                    afterTextEdit();
                });

                // Multilanguage message
                if (layoutElement.layoutElementId > 0 && selectedLanguage) {
                    if (selectedLanguage === "1") {
                        multilanguageMessage = DUImessage.show('The text/style update will be applied to all languages that have the same text as the main language ' + mainLanguageName, "Message-info", 10000);
                    } else {
                        multilanguageMessage = DUImessage.show('The text/style update will only be applied to the selected languages as the main language ' + mainLanguageName + ' is not selected', "Message-info", 10000);
                    }
                }
            }

            if (elementType == itemTypes.WORDCLOUD || elementType == itemTypes.DYNAMICIMAGE || 
                elementType == itemTypes.HEATMAP || elementType == itemTypes.ICONSHAPE || 
                elementType == itemTypes.DYNAMICICONSHAPE || elementType == itemTypes.SIMPLETABLE ||
                elementType == itemTypes.SUMMARY || elementType == itemTypes.ADVANCEDANALYTICS)
                $('#DUI-ST-MULTIEDIT').css('display', 'none');
            else
                $('#DUI-ST-MULTIEDIT').css('display', '');

            if (elementType != itemTypes.CHART && elementType != itemTypes.SIMPLETABLE && elementType != itemTypes.HEATMAP)
                showEditPanel(contentElement, layoutElement);
        });

        $(".tableOptions", el).bind("click", function (evt) {
            var contentElement;
            if ((contentElement = Storyboard.LayoutDesigner.getElementItemByType(itemTypes.RESPONDENTTABLE, layoutElement))) {
                RespondentTableSetup.showOptions(evt, contentElement);
            }
        });

        $(".menu", el).click(function (evt) {
            evt.stopPropagation();
            if (!$(el).hasClass('ui-selected')) {
                //this element is not selected. Unselect all and select it.
                deselectAllBoxes();
                selectBox(el, layoutElement);
            }
            hideAllMenusAndPanels(evt);
            showContextMenu(evt);
        });
    }

    function addDroppableToChartCreatorLayoutElements(layoutElement) {
        var currentSlide = Storyboard.LayoutDesigner.getCurrentSlide();
        var slideLayoutElements = Storyboard.LayoutDesigner.getLayoutElementsBySlide(currentSlide);

        slideLayoutElements
            .filter(function(le) { 
                return le !== layoutElement && !le.isLocked && !le.isSlideTitle &&  !le.isSlideSubtitle && !le.isSlideFooter;
            })
            .forEach(function(le) {
                var el = $('#' + le.guid);

                el.droppable({
                    greedy: true,
                    accept: '.layoutElement',
                    tolerance: 'pointer',
                    activeClass: 'ui-droppable-highlight',
                    hoverClass: "ui-droppable-hover",
                    over: function(event, ui) {
                        el.siblings('.layoutElement.ui-droppable').droppable('disable');
                    },
                    out: function(event, ui) {
                        el.siblings('.layoutElement.ui-droppable').droppable('enable');
                    },
                    drop: function(event, ui) {
                        if ($('#layoutArea .ui-selected').length !== 1)
                            return;

                        var guid = ui.draggable.attr('guid');
                        var layoutElement1 = Storyboard.LayoutDesigner.getLayoutElementByIdOrGuid(guid);
                        var layoutElement2 = le;

                        $(ui.draggable).addClass('ui-draggable-dropped');

                        $('#layoutArea .ui-droppable-hover').removeClass('ui-droppable-hover');
                        $('#layoutArea .ui-droppable-highlight').removeClass('ui-droppable-highlight');

                        el.siblings('.layoutElement.ui-droppable').droppable('enable');

                        switchPlacesBetweenLayoutElements(layoutElement1, layoutElement2);
                        removeDroppableFromChartCreatorLayoutElements();
                    }
                });
            });
    }

    function removeDroppableFromChartCreatorLayoutElements() {
        var currentSlide = Storyboard.LayoutDesigner.getCurrentSlide();
        var slideLayoutElements = Storyboard.LayoutDesigner.getLayoutElementsBySlide(currentSlide);

        slideLayoutElements.forEach(function(le) {
            $('#' + le.guid).filter('.ui-droppable').droppable('destroy');
        });
    }

    function bindCopyCursorEvents(event) {
        var pressedKey = false;

        $(document.body)
            .bind('keydown.cursor', function(event) {
                // ignore events caused by the same key repeats
                if (pressedKey === event.keyCode) return;
                else pressedKey = event.keyCode;

                if (event.which === 17 || event.which === 18) {
                    document.getElementById('layoutArea').style.cursor = 'copy';
                    createDraggingCloneElements();
                }
            })
            .bind('keyup.cursor', function(event) {
                pressedKey = false;

                if (event.which === 17 || event.which === 18) {
                    document.getElementById('layoutArea').style.cursor = '';
                    removeDraggingCloneElements();
                }
            });

        if (event.ctrlKey || event.metaKey) {
            document.getElementById('layoutArea').style.cursor = 'copy';
        }
    }

    function unbindCopyCursorEvents(event) {
        $(document.body).unbind('keydown.cursor').unbind('keyup.cursor');
        document.getElementById('layoutArea').style.cursor = '';
    }

    function createDraggingCloneElements() {
        $('.ui-selected, .ui-group-selected, .layoutElementsGroup', '#layoutArea')
            .each(function(i, element) {
                var guid = $(this).attr('guid');
                var layoutElement = Storyboard.LayoutDesigner.getLayoutElementByGuid(guid);

                if ($(this).prev().hasClass('ui-dragging-clone')) return;

                var cloneEl = $(this).clone();
                cloneEl.css('top', layoutElement ? layoutElement.yCoord : $(this).data('originalPositionTop'));
                cloneEl.css('left', layoutElement ? layoutElement.xCoord : $(this).data('originalPositionLeft'));
                cloneEl.addClass('ui-dragging-clone');

                $(this).before(cloneEl);
            });
    }

    function removeDraggingCloneElements() {
        $('#layoutArea .ui-dragging-clone').remove();
    }

	function switchPlacesBetweenLayoutElements(layoutElement1, layoutElement2) {
		var scaleRatio = 0;
		var layoutElement1Properties = getLayoutElementSizeAndPosition(layoutElement1);
		var layoutElement2Properties = getLayoutElementSizeAndPosition(layoutElement2);

		layoutElement1Properties.zIndex = layoutElement1.zIndex;
		layoutElement2Properties.zIndex = layoutElement2.zIndex;

        var widthElement1,heightElement1,widthElement2,heightElement2 = -1;

        //Check if one of the elements is image, if yes, apply the original width/height
        if(layoutElement1.layoutElementItems && layoutElement1.layoutElementItems.length){
            if(layoutElement1.layoutElementItems[0].itemType==itemTypes.IMAGE){
                scaleRatio = parseFloat(layoutElement2Properties.width/layoutElement1Properties.width);
                widthElement1 = parseInt(layoutElement1Properties.width*scaleRatio);
                heightElement1 = parseInt(layoutElement1Properties.height*scaleRatio);
            }
        }
        if(layoutElement2.layoutElementItems && layoutElement2.layoutElementItems.length){
            if(layoutElement2.layoutElementItems[0].itemType==itemTypes.IMAGE){
                scaleRatio = parseFloat(layoutElement1Properties.width/layoutElement2Properties.width);
                widthElement2 = parseInt(layoutElement2Properties.width*scaleRatio);
                heightElement2 = parseInt(layoutElement2Properties.height*scaleRatio);
            }
        }
        (widthElement1 != -1)?layoutElement2Properties.width = widthElement1:'';
        (heightElement1 != -1)?layoutElement2Properties.height = heightElement1:'';

        (widthElement2 != -1)?layoutElement1Properties.width = widthElement2:'';
        (heightElement2 != -1)?layoutElement1Properties.height = heightElement2:'';
        
		$.extend(layoutElement1, layoutElement2Properties);
        $.extend(layoutElement2, layoutElement1Properties);

		Storyboard.LayoutDesigner.updateLayoutElement(layoutElement1);
		Storyboard.LayoutDesigner.updateLayoutElement(layoutElement2);
	}

	function getLayoutElementSizeAndPosition(layoutElement) {
		return {
			xCoord: layoutElement.xCoord,
			yCoord: layoutElement.yCoord,
			width: layoutElement.width,
			height: layoutElement.height
		};
	}

	function setOriginalSizeAndPosition() {
		$(this).data({
			originalSizeWidth: parseInt(this.style.width, 10),
			originalSizeHeight: parseInt(this.style.height, 10),
			originalPositionLeft: parseInt(this.style.left, 10),
			originalPositionTop: parseInt(this.style.top, 10),
		})
	}

	function getOriginalSizeAndPosition(el) {
		var data = $(el).data();
		return {
			width: data.originalSizeWidth,
			height: data.originalSizeHeight,
			left: data.originalPositionLeft,
			top: data.originalPositionTop,
		}
	}

	function moveOrDuplicate(evt, ui, stateObj) {
		if (evt.ctrlKey || evt.altKey) {
			var diffLeft = parseInt(ui.position.left - ui.originalPosition.left, 10);
			var diffTop	= parseInt(ui.position.top - ui.originalPosition.top, 10);
			
			$('.ui-selected, .ui-group-selected, .layoutElementsGroup', '#layoutArea').each(function () {
				$(this).css('top', $(this).data('originalPositionTop'));
				$(this).css('left', $(this).data('originalPositionLeft'));
			});

			Storyboard.LayoutDesigner.duplicateHandler(evt, { left: diffLeft, top: diffTop });
		} else {
			dragStopHandler(evt, ui, stateObj);
		}
	}

	function dragHandler(evt, ui) {
		var diffLeft = parseInt(ui.position.left - ui.originalPosition.left, 10);
		var diffTop = parseInt(ui.position.top - ui.originalPosition.top, 10);
		
		$('.ui-selected, .ui-group-selected, .layoutElementsGroup', '#layoutArea').each(function () {
			var newTop 	= parseInt($(this).data('originalPositionTop') + diffTop, 10);
			var newLeft	= parseInt($(this).data('originalPositionLeft') + diffLeft, 10);
			$(this).css('top', newTop);
			$(this).css('left', newLeft);
		});
	}

	function dragStopHandler(evt, ui, stateObj) {
		var diffLeft = parseInt(ui.position.left - ui.originalPosition.left, 10);
		var diffTop	= parseInt(ui.position.top - ui.originalPosition.top, 10);

		$('.ui-selected, .ui-group-selected', '#layoutArea').each(function () {
			var oldTop	= $(this).data('originalPositionTop');
			var oldLeft = $(this).data('originalPositionLeft');
			var newTop 	= parseInt(oldTop + diffTop, 10);
			var newLeft	= parseInt(oldLeft + diffLeft, 10);
			$(this).css('top', newTop);
			$(this).css('left', newLeft);
			var curLayoutElement = Storyboard.LayoutDesigner.getLayoutElementByGuid($(this).attr('guid'));
			curLayoutElement.xCoord = newLeft;
			curLayoutElement.yCoord = newTop;
			// jQuery.draggable don't seem to be able to align properly, use our own
			alignElementToGrid(curLayoutElement);

			// Update this box's layoutElement with new properties
			Storyboard.LayoutDesigner.updateLayoutElement(curLayoutElement);

			if (Storyboard.SlidesPanel && Storyboard.SlidesPanel.isOpen()) {
				var slide = Storyboard.LayoutDesigner.getSlideByLayoutElement(curLayoutElement);
				Storyboard.SlidesPanel.renderThumbnailFromSVGs([slide]);
			}
			
			stateObj.eventElements.push({
				guid: curLayoutElement.guid,
				oldValues: { xCoord: oldLeft, yCoord: oldTop },
				newValues: { xCoord: curLayoutElement.xCoord, yCoord: curLayoutElement.yCoord }
			});
		});
	}

	function resizeHandler(evt, ui) {
		var diffWidth   = parseInt(ui.size.width - ui.originalSize.width, 10);
		var diffHeight  = parseInt(ui.size.height - ui.originalSize.height, 10);
		var diffLeft    = parseInt(ui.position.left - ui.originalPosition.left, 10);
		var diffTop     = parseInt(ui.position.top - ui.originalPosition.top, 10);

		if ($(evt.target).resizable('option', 'aspectRatio') === true) {
			if (diffWidth !== 0)
				diffHeight = (ui.originalSize.height * (ui.size.width / ui.originalSize.width)) - ui.originalSize.height;
			else if (diffHeight !== 0)
				diffWidth = (ui.originalSize.width * (ui.size.height / ui.originalSize.height)) - ui.originalSize.width;
			diffTop 	= diffTop === 0 ? 0 : -diffHeight;
			diffLeft 	= diffLeft === 0 ? 0 : -diffWidth;
		}

		$('.ui-selected, .layoutElementsGroup', '#layoutArea').each(function () {
			var original	= getOriginalSizeAndPosition(this);
			var newWidth	= original.width + diffWidth;
			var newHeight	= original.height + diffHeight;
			var newLeft		= original.left + diffLeft;
			var newTop		= original.top + diffTop;
			
			$(this).css({
				width: Math.round((newWidth < boxMinSize.width) ? boxMinSize.width : newWidth),
				height: Math.round((newHeight < boxMinSize.height) ? boxMinSize.height : newHeight),
				left: Math.round(newLeft),
				top: Math.round(newTop)
			});
		});

		$('.layoutElementsGroup', '#layoutArea').each(function () {
			var groupId = parseInt($(this).attr('layoutelementsgroupid'));
			var curLayoutElements = Storyboard.LayoutDesigner.getLayoutElementsByGroup(groupId);
			var original			= getOriginalSizeAndPosition(this);
			var originalGroupWidth	= original.width;
			var originalGroupHeight	= original.height;
			var originalGroupLeft	= original.left;
			var originalGroupTop	= original.top;
			var newGroupWidth		= originalGroupWidth + diffWidth;
			var newGroupHeight		= originalGroupHeight + diffHeight;
			var newGroupLeft		= originalGroupLeft + diffLeft;
			var newGroupTop			= originalGroupTop + diffTop;

			curLayoutElements.forEach(function(curLayoutElement) {
				var el = $('#' + curLayoutElement.guid);
				var newWidth = (curLayoutElement.width * newGroupWidth) / originalGroupWidth;
				var newHeight = (curLayoutElement.height * newGroupHeight) / originalGroupHeight;
				var newLeft = (((curLayoutElement.xCoord - originalGroupLeft) * newGroupWidth) / originalGroupWidth) + newGroupLeft;
				var newTop = (((curLayoutElement.yCoord - originalGroupTop) * newGroupHeight) / originalGroupHeight) + newGroupTop;

				$(el).css({
					width: Math.round(newWidth),
					height: Math.round(newHeight),
					left: Math.round(newLeft),
					top: Math.round(newTop)
				});
			});
		});
	}

	function resizeStopHandler(evt, ui, stateObj) {
		var diffWidth	= parseInt(ui.size.width - ui.originalSize.width, 10);
		var diffHeight	= parseInt(ui.size.height - ui.originalSize.height, 10);
		var diffLeft	= parseInt(ui.position.left - ui.originalPosition.left, 10);
		var diffTop		= parseInt(ui.position.top - ui.originalPosition.top, 10);
		
		if ($(evt.target).resizable('option', 'aspectRatio') === true) {
			if (diffWidth !== 0)
				diffHeight = (ui.originalSize.height * (ui.size.width / ui.originalSize.width)) - ui.originalSize.height;
			else if (diffHeight !== 0)
				diffWidth = (ui.originalSize.width * (ui.size.height / ui.originalSize.height)) - ui.originalSize.width;
			diffTop		= diffTop === 0 ? 0 : -diffHeight;
			diffLeft	= diffLeft === 0 ? 0 : -diffWidth;
		}

		$('.ui-selected', '#layoutArea').each(function () {
			var curLayoutElement = Storyboard.LayoutDesigner.getLayoutElementByGuid($(this).attr('guid'));
			var original	= getOriginalSizeAndPosition(this);
			var newWidth	= original.width + diffWidth;
			var newHeight	= original.height + diffHeight;
			var newLeft		= original.left + diffLeft;
			var newTop		= original.top + diffTop;
			
			curLayoutElement.width  = Math.round(newWidth);
			curLayoutElement.height = Math.round(newHeight);
			curLayoutElement.xCoord = Math.round(newLeft);
			curLayoutElement.yCoord = Math.round(newTop);

			alignElementToGrid(curLayoutElement);

			Storyboard.LayoutDesigner.updateLayoutElement(curLayoutElement);
			Storyboard.GuiEvents.layoutElementResized(curLayoutElement);

			stateObj.eventElements.push({
				guid: curLayoutElement.guid,
				oldValues: {
					width: original.width,
					height: original.height,
					xCoord: original.left,
					yCoord: original.top
				},
				newValues: {
					width: curLayoutElement.width,
					height: curLayoutElement.height,
					xCoord: curLayoutElement.xCoord,
					yCoord: curLayoutElement.yCoord
				}
			});
		});

		$('.layoutElementsGroup', '#layoutArea').each(function () {
			var groupId = parseInt($(this).attr('layoutelementsgroupid'));
			var curLayoutElements = Storyboard.LayoutDesigner.getLayoutElementsByGroup(groupId);
			var original			= getOriginalSizeAndPosition(this);
			var originalGroupWidth	= original.width;
			var originalGroupHeight	= original.height;
			var originalGroupLeft	= original.left;
			var originalGroupTop	= original.top;
			var newGroupWidth		= originalGroupWidth + diffWidth;
			var newGroupHeight		= originalGroupHeight + diffHeight;
			var newGroupLeft		= originalGroupLeft + diffLeft;
			var newGroupTop			= originalGroupTop + diffTop;

			curLayoutElements.forEach(function(curLayoutElement) {
				var original = getOriginalSizeAndPosition($('#' + curLayoutElement.guid));
				var newWidth = (curLayoutElement.width * newGroupWidth) / originalGroupWidth;
				var newHeight = (curLayoutElement.height * newGroupHeight) / originalGroupHeight;
				var newLeft = (((curLayoutElement.xCoord - originalGroupLeft) * newGroupWidth) / originalGroupWidth) + newGroupLeft;
				var newTop = (((curLayoutElement.yCoord - originalGroupTop) * newGroupHeight) / originalGroupHeight) + newGroupTop;

				curLayoutElement.width  = Math.round(newWidth);
				curLayoutElement.height = Math.round(newHeight);
				curLayoutElement.xCoord = Math.round(newLeft);
				curLayoutElement.yCoord = Math.round(newTop);

				alignElementToGrid(curLayoutElement);

				Storyboard.LayoutDesigner.updateLayoutElement(curLayoutElement);
				Storyboard.GuiEvents.layoutElementResized(curLayoutElement);

				stateObj.eventElements.push({
					guid: curLayoutElement.guid,
					oldValues: {
						width: original.width,
						height: original.height,
						xCoord: original.left,
						yCoord: original.top
					},
					newValues: {
						width: curLayoutElement.width,
						height: curLayoutElement.height,
						xCoord: curLayoutElement.xCoord,
						yCoord: curLayoutElement.yCoord
					}
				});
			});
		});
	}

    function setupRTStyling(isRespTable, isCrossTable) {
        var panel = isCrossTable ? "#tableLayout_ct" : "#tableLayout";
        //move respondent table styling markup between the two placeholders, depending on which component is chosen
        if (!isRespTable && $('#respTableStylesWrapper').parent() != $(panel + ' #simpletableStylePlaceholder')) {
            $('#respTableStylesWrapper').appendTo(panel + ' #simpletableStylePlaceholder');
            var PH = $('#respTableStylesWrapper').find('#RespTableThemesTemplateList').empty();

            var themeArray = SimpleTableStyle.getTemplates();
            for (var index in themeArray)
                if (themeArray.hasOwnProperty(index)) {

                    var theme = $('<div class="ThemePreview"><img src="' + themeArray[index].theme.img + '" alt="' + themeArray[index].theme.name + '" title="' + themeArray[index].theme.name + '" themeID="' + index + '" /></div>')
                            .click(function (evt) {
                                evt.preventDefault();
                                evt.stopPropagation();
                                var TID = $(evt.target).attr('themeID');
                                $(themeArray[TID].theme.styles).each(function (index) {
                                    var keyval = this.split('|');
                                    var k = keyval[0];
                                    var v = keyval[1];

                                    var selector = '#rt_' + k;
                                    var elem = selector;
                                    if ($(elem).is('input:text') && v != '') {
                                        // Textbox
                                        $(elem).val(v);
                                        $(elem).css('background', '');
                                        var value = (v.toLowerCase().replace(/ /g, '').indexOf('(255,255,255,0') > -1) ? 'transparent' : v;
                                        $(elem).css('background-color', value);
                                        $(elem).attr('title', value);
                                        $(elem).change();
                                    }
                                    else if ($(elem).is('input:checkbox')) {
                                        // Checkbox
                                        if (k === 'cell_autowidth' || k === 'cell_autoheight') {
                                            $(elem).attr('checked', (v == 'False') ? 'checked' : '');
                                        } else
                                            $(elem).attr('checked', (v == 'True') ? 'checked' : '');
                                    }
                                    else if ($(elem).is('input:radio')) {
                                        // Radiobutton
                                        $(elem).attr('checked', (v == 'True') ? 'checked' : '');
                                        $(elem).change(); //for styled radiobutton set checked/unchecked
                                    }
                                    else if (($(elem).is('select') || $(elem).is('input:hidden')) && v != '') {
                                        // Dropdownlist or hidden field
                                        $(elem).val(v);
                                    }
                                    else if ($(elem).is('table')) {
                                        //check box list
                                        var cblist = $(elem).find('input:checkbox');
                                        var cbvalues = v.split(';');
                                        $.each(cbvalues, function () {
                                            if (this.indexOf(":") > 0) {
                                                var keyVal = this.split(':');
                                                cblist.filter('input:checkbox[value="' + keyVal[0] + '"]').attr('checked', (keyVal[1].toLowerCase() == 'true') ? 'checked' : '');
                                            }
                                        });
                                    }
                                    else if ($(elem).is('div') && v != '') {
                                        if ($(elem).hasClass('RTBorderStyle')) {
                                            $(elem).children('.ChartStyleDashStyleValue')
                                                .attr('data-value', v)
                                                .css('background-image', "url('images/respondenttable_templates/" + v + ".png')");
                                        }
                                    }
                                }); //for each
                                $("#rt_style_first_column").change(); //enable or disable first row and first column settings
                                $("#rt_style_first_row").change();


                            });
                    PH.append(theme);
                }
        }
        else if (isRespTable && $('#respTableStylesWrapper').parent() != $('#resptableStylePlaceholder')) {
            $('#respTableStylesWrapper').appendTo('#resptableStylePlaceholder');
        }

        //update various labels depending on which element type is selected
        $('#respTableStylesWrapper').find('.rtStyling_simpletable').toggle(!isRespTable);
        $('#respTableStylesWrapper').find('#rtStyling_firstRowHeader > span').text(isRespTable ? locale.get('First row') : locale.get('Row headers'));
        $('#respTableStylesWrapper').find('#rtStyling_firstColumnHeader > span').text(isRespTable ? locale.get('First column') : locale.get('Column headers'));

        $('#lblrtfirstrowbgcolor').text(isRespTable ? locale.get('Background color') : locale.get('Even row color'));
        $('#lblrtfirstrowunevenbgcolor').text(locale.get('Odd row color'));

        $('#lblrtfirstcolumnbgcolor').text(isRespTable ? locale.get('Background color') : locale.get('Even column color'));
        $('#lblrtfirstcolumnunevenbgcolor').text(locale.get('Odd column color'));

        $('#rt_style_first_row_label').text(isRespTable ? locale.get('Style first row') : locale.get('Style row headers'));
        $('#rt_style_first_column_label').text(isRespTable ? locale.get('Style first column') : locale.get('Style column headers'));
        $('#respTableStylingTitle > span').text(isRespTable ? locale.get('Respondent Table Layout') : locale.get('Table styling'));
        
        $('#minColumnWidth, #minRowHeight, #additionalInfoText').toggle(!isRespTable);
    }

    // fetches the version of table stored in session during the last getstoryboardtable call (either with or without cell formatting styles)
    // to be used when entering and exiting designer
    function getCachedStoryboardTable(layoutElement, formattingOption) {
        Helpers.perfJSonCall({
            method: 'getCachedStoryboardTable',
            data: { layoutElement: layoutElement, formattingOption: formattingOption },
            message: locale.get('Loading table'),
            successCallback: getCachedStoryboardTableCompleted
        });
    }

    // either initializes or closes the table designer, depending on current state and renders the fetched table
    function getCachedStoryboardTableCompleted(args) {
        if (args) {
            var tableLayoutElem = Storyboard.LayoutDesigner.getLayoutElementByIdOrGuid(args.layoutElementId);
            var tableElementItem = Storyboard.LayoutDesigner.getElementItemByType(itemTypes.TABLE, tableLayoutElem);

            var layoutGrid = $('#layoutArea');
            var el = $(".layoutElement[guid=" + tableLayoutElem.guid + "]", layoutGrid);

            if (tableLayoutElem && tableElementItem) {
                var tableLayoutElement = $('.layoutElementItem[guid="' + tableElementItem.guid + '"]', layoutGrid);
                $(tableLayoutElement).html(args.text);
                var layoutElement = $('.layoutElementAdmin[guid="' + tableLayoutElem.guid + '"]');

                if (!layoutElement.hasClass('table-design') || layoutElement.hasClass('clearing-design')) {
                    layoutElement.removeClass('clearing-design');
                    el.draggable("destroy");
                    el.resizable("destroy");
                    el.addClass('table-design layoutElementAdminFocused');
                    $(tableLayoutElement).css('overflow', 'visible');
                    $('.DUI-ST-EL-DIMENSION', el).hide();
                    $(layoutGrid).selectable('destroy');
                    showContextDUIButtons(tableLayoutElem);
                    $('.layoutElementItem[guid="' + tableElementItem.guid + '"] #grdCross', layoutGrid).DUItableDesigner();

                    $('.layoutElement[guid="' + tableLayoutElem.guid + '"]', layoutGrid)
                        .find('.saveEdit, .cancelEdit, .clearEdit').remove();

                    $('#DUI-TD-BTN-SYS-SAVE').unbind("click").bind("click", function (evt2) {
                        Storyboard.LayoutDesigner.saveDUITableDesign(tableElementItem,
                            $('.layoutElementItem[guid="' + tableElementItem.guid + '"] #grdCross', layoutGrid).DUItableDesigner('getstyle'));
                    });

                    $('#DUI-TD-BTN-SYS-CANCEL').unbind("click").bind("click", function (evt2) {
                        getCachedStoryboardTable(tableLayoutElem, Storyboard.Constants.CTRenderType.ALL_FORMATTING);
                    });

                    $('#DUI-TD-BTN-SYS-RESET').unbind("click").bind("click", function (evt2) {
                        $('.layoutElementAdmin[guid="' + tableLayoutElem.guid + '"]').addClass('clearing-design');
                        getCachedStoryboardTable(tableLayoutElem, Storyboard.Constants.CTRenderType.UNFORMATTED);
                    });

                }
                else {
                    showStandardDUIButtons(tableLayoutElem);
                    addDragableAndResizable(el);
                    el.removeClass('table-design layoutElementAdminFocused');
                    $(tableLayoutElement).css('overflow', 'hidden');
                    $('.DUI-ST-EL-DIMENSION', el).show();
                    $('.layoutElementItem[guid="' + tableElementItem.guid + '"] #grdCross', layoutGrid).DUItableDesigner('destroy');
                    $('.DUI-TableDesigner.DUI-TD-TB-LEFT').remove();
                    $('.DUI-TableDesigner.DUI-TD-TB-TOP').remove();
                    tableElementItem.content = $('.layoutElementItem[guid="' + tableElementItem.guid + '"]').html();
                }
            }
        }
    }

    function showContextDUIButtons(layoutElement) {
        var layoutGrid = $('#layoutArea');
        $('#' + layoutElement.guid + ' .standardButton', layoutGrid).css('display', 'none');
        $('#' + layoutElement.guid + ' .contextButton', layoutGrid).css('display', 'inline-block');
    }

    function showStandardDUIButtons(layoutElement) {
        var layoutGrid = $('#layoutArea');
        $('#' + layoutElement.guid + ' .standardButton', layoutGrid).css('display', 'inline-block');
        $('#' + layoutElement.guid + ' .contextButton', layoutGrid).css('display', 'none');
    }

	function addDragableAndResizable(element, gridSize) {
		gridSize = gridSize || 1;
		$(element)
			.draggable({
				scroll: true,
				stop: function (evt, ui) {
					Storyboard.LayoutDesigner.setState(true); //unsaved state
				}
			});

		$(element).resizable({
			handles: 'all',
			autoHide: true,
			zIndex: 1000,
			stop: function (evt, ui) {
				Storyboard.LayoutDesigner.setState(true); //unsaved state
			}
		});
	}

    function updateElementCoordsAndSizes(UIbox, ui) {
        if (!$(UIbox).hasClass('table-design') && !$(UIbox).hasClass('ui-group-selected')) {
            var layoutElement = Storyboard.LayoutDesigner.getLayoutElementByGuid($(UIbox).attr('guid'));

            var elem = {
                x: (ui && ui.position) ? Math.round(ui.position.left) : layoutElement.xCoord,
                y: (ui && ui.position) ? Math.round(ui.position.top) : layoutElement.yCoord,
                w: (ui && ui.size) ? Math.round(ui.size.width) : layoutElement.width,
                h: (ui && ui.size) ? Math.round(ui.size.height) : layoutElement.height,
                t: layoutElement.tags
            };

            $('.DUI-ST-EL-DIMENSION', $(UIbox)).remove();
            var divStart = '<div class="DUI-ST-EL-DIMENSION ';
            if (elem.w > 100 && elem.h > 40)
                $(UIbox).prepend(divStart + 'DUI-ST-EL-DIMENSION-COORD">X: ' + elem.x + '&nbsp;&nbsp;Y: ' + elem.y + '</div>');
            if (elem.w > 140 && elem.h > 40 && (elem.w * elem.h > 14000))
                $(UIbox).prepend(divStart + 'DUI-ST-EL-DIMENSION-WIDTH">' + elem.w + ' px</div>');
            if (elem.w > 140 && elem.h > 80)
                $(UIbox).prepend(divStart + 'DUI-ST-EL-DIMENSION-HEIGHT">' + elem.h + ' px</div>');
            if (elem.t != null && elem.t != "")
                $(UIbox).prepend(divStart + 'DUI-ST-EL-DIMENSION-TAGS">' + elem.t + '</div>');
            $(UIbox).toggleClass('layoutElementXS', (elem.w < 140 || elem.h < 20) || (elem.w * elem.h < 10000));
        }
    }

    function updateGroupCoordsAndSizes(groupElement, ui) {
        groupElement = $(groupElement);
        var position = groupElement.position();

        var group = {
            x: (ui && ui.position) ? Math.round(ui.position.left) : Math.round(position.left),
            y: (ui && ui.position) ? Math.round(ui.position.top) : Math.round(position.top),
            w: (ui && ui.size) ? Math.round(ui.size.width) : groupElement.outerWidth(),
            h: (ui && ui.size) ? Math.round(ui.size.height) : groupElement.outerHeight()
        };

        $('.DUI-ST-EL-DIMENSION', groupElement).remove();
        var divStart = '<div class="DUI-ST-EL-DIMENSION ';
        if (group.w > 100 && group.h > 40)
            groupElement.prepend(divStart + 'DUI-ST-EL-DIMENSION-COORD">X: ' + group.x + '&nbsp;&nbsp;Y: ' + group.y + '</div>');
        if (group.w > 140 && group.h > 40 && (group.w * group.h > 14000)) 
            groupElement.prepend(divStart + 'DUI-ST-EL-DIMENSION-WIDTH">' + group.w + ' px</div>');
        if (group.w > 140 && group.h > 80)
            groupElement.prepend(divStart + 'DUI-ST-EL-DIMENSION-HEIGHT">' + group.h + ' px</div>');

        groupElement.toggleClass('layoutElementXS', (group.w < 140 || group.h < 20) || (group.w * group.h < 10000));
    }

    function smartGuidesPrepare(layoutElement) {
        var currentSlide = Storyboard.LayoutDesigner.getSlideByLayoutElement(layoutElement);
        var allSlideElements = Storyboard.LayoutDesigner.getLayoutElementsBySlide(currentSlide);
        var smartGuidesCoord = {x: [], y: [], cx: [], cy: []};

        allSlideElements
            .filter(function (le) {
                return le.guid !== layoutElement.guid;
            }).forEach(function(le) {
                smartGuidesCoord.x.push(parseInt(le.xCoord));
                smartGuidesCoord.cx.push(parseInt(le.xCoord + parseInt(le.width / 2)));
                smartGuidesCoord.x.push(parseInt(le.xCoord + le.width));
                smartGuidesCoord.y.push(parseInt(le.yCoord));
                smartGuidesCoord.cy.push(parseInt(le.yCoord + parseInt(le.height / 2)));
                smartGuidesCoord.y.push(parseInt(le.yCoord + le.height));
            });
        
        $('#layoutArea').data('smartGuidesCoord', smartGuidesCoord);

        $('#' + currentSlide.guid).append('<div id="smartguideXleft" class="smartguide"></div>'+
            '<div id="smartguideXmiddle" class="smartguide"></div>'+
            '<div id="smartguideXright" class="smartguide"></div>'+
            '<div id="smartguideYtop" class="smartguide"></div>'+
            '<div id="smartguideYmiddle" class="smartguide"></div>'+
            '<div id="smartguideYbottom" class="smartguide"></div>');
    }

    function smartGuidesCheck(layoutElement, ui) {
        var smartGuidesCoord = $('#layoutArea').data('smartGuidesCoord');
        var currentSlide = Storyboard.LayoutDesigner.getSlideByLayoutElement(layoutElement);
        var allSlideElements = Storyboard.LayoutDesigner.getLayoutElementsBySlide(currentSlide);
        allSlideElements = allSlideElements.filter(function(le) { 
            return le.guid !== layoutElement.guid;
        });

        var top  = Math.round(ui.position.top);
        var left = Math.round(ui.position.left);

        $('#smartguideXleft, #smartguideXmiddle, #smartguideXright').css('left', '-9999px');
        $('#smartguideYtop, #smartguideYmiddle, #smartguideYbottom').css('top', '-9999px');

        var positionXSmartGuide = function(x, pos) {
            var alignedElement = allSlideElements.filter(function(le) {
                return (x === le.xCoord ||
                        x === le.xCoord + le.width ||
                        x === le.xCoord + parseInt(le.width / 2));
            });

            if (alignedElement.length > 0) {
                var positions = [
                    alignedElement[0].yCoord,
                    alignedElement[0].yCoord + alignedElement[0].height,
                    top,
                    top + ui.helper.height()
                ];

                $('#smartguideX' + pos).css({
                    left:   pos === 'left' ? x : --x,
                    top:    Math.min.apply(null, positions),
                    height: Math.max.apply(null, positions) - Math.min.apply(null, positions),
                    width: 1
                });
            }
        }

        var positionYSmartGuide = function(y, pos) {
            var alignedElement = allSlideElements.filter(function(le) { 
                return (y === le.yCoord || 
                        y === le.yCoord + le.height ||
                        y === le.yCoord + parseInt(le.height / 2));
            });

            if (alignedElement.length > 0) {
                var positions = [
                    alignedElement[0].xCoord, 
                    alignedElement[0].xCoord + alignedElement[0].width,
                    left,
                    left + ui.helper.width()
                ];

                $('#smartguideY' + pos).css({
                    top:   pos === 'top' ? y : --y,
                    left:  Math.min.apply(null, positions),
                    width: Math.max.apply(null, positions) - Math.min.apply(null, positions),
                    height: 1
                });
            }
        }
        
        if (~smartGuidesCoord.x.indexOf(left + ui.helper.width()) ||
            ~smartGuidesCoord.x.indexOf(left)) {
                if (~smartGuidesCoord.x.indexOf(left))
                    positionXSmartGuide(left, 'left');
                if (~smartGuidesCoord.x.indexOf(left + ui.helper.width()))
                    positionXSmartGuide(left + ui.helper.width(), 'right');
        } else if (~smartGuidesCoord.cx.indexOf(left + parseInt(ui.helper.width() / 2))) {
            positionXSmartGuide(left + parseInt(ui.helper.width() / 2), 'middle');
        }

        if (~smartGuidesCoord.y.indexOf(top) ||
            ~smartGuidesCoord.y.indexOf(top + ui.helper.height())) {
                if (~smartGuidesCoord.y.indexOf(top))
                    positionYSmartGuide(top, 'top');
                if (~smartGuidesCoord.y.indexOf(top + ui.helper.height()))
                    positionYSmartGuide(top + ui.helper.height(), 'bottom');
        } else if (~smartGuidesCoord.cy.indexOf(top + parseInt(ui.helper.height() / 2))) {
            positionYSmartGuide(top + parseInt(ui.helper.height() / 2), 'middle');
        }
    }

    function mousedownInContentbox(evt) {
        var targetEl = $(evt.target).closest(".layoutElementAdmin");
        var layoutElement = Storyboard.LayoutDesigner.getLayoutElementByGuid(targetEl.attr("guid"));
        
        $("#StorytellerObjectsToolbar input:focus").blur();
        
        // If layout element is part of group, forward event to the group
        if (layoutElement.groupId && (evt.which === 1 || evt.which === 0)) {
            var layoutElements = Storyboard.LayoutDesigner.getLayoutElements();
            var anySelectedFromSameGroup = layoutElements.some(function(le) { 
                return le.isSelected === true && le.groupId === layoutElement.groupId;
            })
            
            if (!evt.ctrlKey && !evt.metaKey && !anySelectedFromSameGroup) {
                deselectAllBoxes();
                deselectAllGroups();
            }

            if (!anySelectedFromSameGroup) {
                selectGroup(layoutElement.groupId);
                selectGroupsFromSelectedElements();
                var groupEl = $('#layoutelementsgroup-' + layoutElement.groupId);
                evt.type = "mousedown.draggable";
                evt.target = groupEl.get(0)
                groupEl.trigger(evt);
            }

            hideAllMenusAndPanels(evt);
            updateTemplatesMenu();
            Storyboard.LayoutDesigner.LayoutElementsPanel.closePanel();
            Storyboard.LayoutDesigner.LayoutElementsToolbar.updateToolbarState();
        }
    }

    function clickInContentbox(evt) {
		var clickTarget = $(evt.target).closest('.layoutElementAdmin');
		if (clickTarget.length < 1) return;

        var layoutElement = Storyboard.LayoutDesigner.getLayoutElementByGuid($(clickTarget).attr('guid'));
        var selected = clickTarget.hasClass('ui-selected');
        var groupSelected = clickTarget.hasClass('ui-group-selected');
        var layoutElements = Storyboard.LayoutDesigner.getLayoutElements();
        var anySelectedFromSameGroup = layoutElements.some(function(le) { 
            return le.isSelected === true && le.groupId === layoutElement.groupId;
        });

        if (evt.which === 1 || evt.which === 0) {
            if (evt.ctrlKey || evt.metaKey) {
                if (selected) {
                    deselectBox(clickTarget, layoutElement);
                } else {
                    selectBox(clickTarget, layoutElement);
                    if (!anySelectedFromSameGroup)
                        selectGroupsFromSelectedElements();
                }
            } else {
                if (layoutElement.groupId) {
                    if (selected) {
                        deselectAllBoxes();
                        deselectAllGroups();
                        selectGroup(layoutElement.groupId);
                    } else {
                        if (groupSelected || anySelectedFromSameGroup) {
                            deselectAllBoxes();
                            deselectAllGroups();
                            selectBox(clickTarget, layoutElement);

                            if (window.ContentType == Storyboard.Constants.itemTypes.CHART) {
                                ChartCreatorSetup.selectChartCreatorBox(clickTarget, layoutElement);
                            }
                        } else {
                            deselectAllBoxes();
                            deselectAllGroups();
                            selectGroup(layoutElement.groupId);
                        }
                    }
                } else {
                    if (!selected) {
                        deselectAllBoxes();
                        deselectAllGroups();
                        selectBox(clickTarget, layoutElement);
                    }
                    if (window.ContentType == Storyboard.Constants.itemTypes.CHART) {
                        ChartCreatorSetup.selectChartCreatorBox(clickTarget, layoutElement);
                    }
                    else if(window.IsStoryboard){
                        Storyboard.LayoutDesigner.handleObjectClick(evt, layoutElement)
                    }
                }
            }

            hideAllMenusAndPanels(evt);
            updateTemplatesMenu();
            Storyboard.LayoutDesigner.LayoutElementsPanel.closePanel();
            Storyboard.LayoutDesigner.LayoutElementsToolbar.updateToolbarState();
        }
    }

    function tableToolPostSave(layoutElement_guid_or_id) {
        Storyboard.GuiEvents.hideEditPanels();
        Storyboard.LayoutControls.hideLoadingBar();

        var items = [Storyboard.LayoutDesigner.getLayoutElementByIdOrGuid(layoutElement_guid_or_id)];
        Storyboard.LayoutDesigner.loadStorytellerContentForElements(items, true, false, 0, 0, layoutElement_guid_or_id);
    }

    function SetupEditMode(contentElement, layoutElement) {
        var type = Storyboard.LayoutDesigner.getLayoutElementType(layoutElement);
        setEditPanelTitle(type, layoutElement);
        switch (type) {
            case itemTypes.CHART:
                if (layoutElement.layoutElementId == 0)
                    deafultChartZoom(type, layoutElement);
                ChartSetupUI.maketabs();
                break;
            case itemTypes.SIMPLETABLE:
            case itemTypes.HEATMAP:
                ChartSetupUI.maketabs();
                break;
            case itemTypes.TABLE:
                var data;
                if (layoutElement.layoutElementId == 0) {
                    data = {
                        layoutElementID: layoutElement.guid,
                        hFilterIds: Storyboard.HFilterLayout.getSelectedIds("#hfilterTree")
                    };
                }
                else {
                    data = {
                        layoutElementID: layoutElement.layoutElementId,
                        hFilterIds: Storyboard.HFilterLayout.getSelectedIds("#hfilterTree")
                    };
                }
                Helpers.perfJSonCall({
                    method: 'GetCrosstabReportUrl',
                    data: data,
                    successCallback: updateiframesrc,
                    failCallback: showblankframe
                });
                break;
            case itemTypes.RESPONDENTTABLE:
                RespondentTableSetup.loadTabs();
                break;
            case itemTypes.DYNAMICIMAGE:
                DynamicImageSetup.loadTabs();
                break;
            case itemTypes.WORDCLOUD:
                WordCloudSetup.loadTabs();
                break;
            case itemTypes.DATAFIELD:
                DataFieldSetup.loadTabs();
                break;
            case itemTypes.EVENTCREATOR:
                EventCreatorSetup.loadTabs();
                break;
            case itemTypes.ICONSHAPE:
                IconShapeSetup.loadTabs();
                break;
            case itemTypes.DYNAMICICONSHAPE:
                DynamicIconShapeSetup.loadTabs();
                break;
            case itemTypes.SUMMARY:
                SummarySetup.loadTabs();
                break;
            case itemTypes.ADVANCEDANALYTICS:
                AdvancedAnalyticsSetup.loadTabs();
                break;
        }
    }

    function updateiframesrc(data) {
        Storyboard.LayoutControls.showLoadingBar(locale.get('Loading table lab'));
        $('#editCrosstab').load(function () {
            Storyboard.LayoutControls.hideLoadingBar();
            $('#setupCrosstab').show();
        });
        $('#editCrosstab').attr('src', data);

    }

    function showblankframe(data) {
        $('#editCrosstab').hide();
    }

    function setEditPanelTitle(type, elem) {
        var id = elem.layoutElementId;
        var titleItem = getHeaderDivForLayoutElement(elem);
        var title = HTMLHelpers.htmlEncode($(titleItem).text());
        var types = Storyboard.Constants.itemTypeClearNames;
        var panelTitle = types[type].charAt(0).toUpperCase() + types[type].slice(1) + ((id !== 0) ? ' box ' + id : '') + ((title.length > 0) ? ': \'' + title + '\'' : '');
        var elementItemName = elem.layoutElementItems[0].elementItemName;        
        if (elementItemName)
            $('#editPanelTitle').val(HTMLHelpers.htmlDecode(elementItemName).replace(/&amp;/g, '&').replace(/amp;/g, ''));
        else {
            $('#editPanelTitle').val(HTMLHelpers.htmlDecode(panelTitle).replace(/&amp;/g, '&').replace(/amp;/g, ''));

        }            
    }

    /* End area for layout elements */

    /* Area for dealing with layout grid stuff, resizing etc */
    function redrawLayoutGrid(layoutGrid) {
        if (!layoutGrid) {
            $(".layoutSlide, .layoutElement, .layoutElementsGroup, .layoutElementAdminUnlock").remove();
            return;
        }

        var divLayoutArea = $("#layoutArea");
        sb.LayoutDesigner.layoutAreaBackgroundImage = sb.LayoutDesigner.layoutAreaBackgroundImage || layoutGrid.background;

        if (sb.LayoutDesigner.isAdmin && !window.IsMyStories) {
            $('#StorytellerPagesizeViewport').addClass('StorytellerPagesizeViewportAdmin')
                .unbind('scroll').bind('scroll', function() { $(this).scrollTop(0); });
            divLayoutArea.addClass("layoutAreaAdmin");

			//if no size set, it's probably a newly created item and should receive default size
			if (!layoutGrid.width || !layoutGrid.height) {
				var size = getLayoutSizeSelection(layoutGrid);

				if (layoutGrid.layoutSlides.length < 1)
					layoutGrid.layoutSlides.push({
						slideId: 0,
						slideIndex: 1,
						slideName: "",
						width: size.width,
						height: size.height
					});

				setLayoutGridSize(size, true);
			}

            Storyboard.GuiEvents.bindTooltips('#StorytellerObjectsToolbar');
		}

		if (window.ContentType === Storyboard.Constants.itemTypes.CHART && layoutGrid.layoutSlides.length < 1)
			layoutGrid.layoutSlides.push({
				slideId: 0,
				slideIndex: 1,
				slideName: "",
				width: layoutGrid.width,
				height: layoutGrid.height
			});

        Storyboard.LayoutDesigner.setLayoutAreaSize();
		
        if (Storyboard.LayoutDesigner.isAdmin && !window.IsMyStories && !(window.ContentType > 0)) // !(>) covers undefined in Form
            addEventsToLayoutGrid(layoutGrid);

		if (window.ContentType === Storyboard.Constants.itemTypes.CHART)
			addEventsToLayoutGrid(layoutGrid);

        divLayoutArea.show();
    }

    function addEventsToLayoutGrid(layoutGrid) {
        /* limit resizing when using a fixed width layout */
        /* var resizeOptions = {
            grid: Storyboard.LayoutDesigner.gridSize,
            minWidth: (layoutGrid.layoutType > 0) ? layoutGrid.width : null,
            maxWidth: (layoutGrid.layoutType > 0) ? layoutGrid.width : null,
            minHeight: (layoutGrid.layoutType > 0) ? layoutGrid.height : null,
            maxHeight: (layoutGrid.layoutType > 0) ? layoutGrid.height : null
        };*/

    	// TODO: Natalia: this logic is not working properly, it makes elements events misbehave
    	/*if ($('#layoutArea').hasClass('layoutAreaAdmin') && layoutGrid.layoutType === Storyboard.Constants.documentFormats.CUSTOM.hash) {
            $('#layoutArea')
				.resizable(resizeOptions)
				.bind('resizestop', function (evt, ui) {
				    //todo: this fires for layoutelement sometimes. determine why
				    // ui does not work to use here for class check
				    var layoutGrid = Storyboard.LayoutDesigner.getLayoutGrid();
				    var documentFormat = Storyboard.GuiEvents.getLayoutSizeSelection(layoutGrid.layoutType);
				    var size = {
				        width: ui.size.width,
				        height: ui.size.height,
				        layoutType: documentFormat.layoutType,
				        pageCount: parseInt(layoutGrid.height / documentFormat.layoutType.height)
				    }
				    setLayoutGridSize(size, true);
				});
		} else {*/
			$('#layoutArea.ui-sortable').resizable('destroy');
			$('#layoutArea')
				.unbind('resizestop')
				.removeClass('layoutAreaAdmin')
				.addClass('layoutAreaAdmin');
		//}

		$('#layoutArea').unbind('contextmenu mousedown')
			.bind('contextmenu', function (evt) {
				//prevent default context menu and bubbling
				evt.preventDefault();
				evt.stopPropagation();
				hideAllMenusAndPanels(evt);

				if (window.ContentType === Storyboard.Constants.itemTypes.CHART) {
					ChartCreatorUI.showContextMenu(evt);
				} else {
					showContextMenu(evt);
				}
			}).bind('mousedown', function() {
				$('.DUIContextMenu input:focus').blur();
			});

		addLayoutAreaSelectable();
	}

    function addLayoutAreaSelectable() {
        $('#layoutArea.ui-selectable').selectable("destroy");
        $('#layoutArea').selectable({
            filter: '.layoutElementAdmin:not(.ui-locked)',
            tolerance: 'fit',
            cancel: '.ui-resizable-handle, .layoutElementAdmin, .layoutElementAdminUnlock, .layoutElementShortcutsMenu',
            start: function (evt, ui) {
                currentMouseCoords.posX = evt.pageX;
                currentMouseCoords.posY = evt.pageY;
                $("#StorytellerObjectsToolbar input:focus").blur();
                deselectAllGroups();
            },
            stop: function (evt, ui) {
                if (evt.pageX == currentMouseCoords.posX && evt.pageY == currentMouseCoords.posY)
                    hideAllMenusAndPanels(evt);
                else
                    selectGroupsFromSelectedElements();
                updateTemplatesMenu();
                Storyboard.LayoutDesigner.LayoutElementsToolbar.updateToolbarState();
            },
            selected: function (evt, ui) {
                var curLayoutElement = Storyboard.LayoutDesigner.getLayoutElementByGuid($(ui.selected).attr('guid'));
                if (curLayoutElement) curLayoutElement.isSelected = true;
            },
            unselected: function (evt, ui) {
                var curLayoutElement = Storyboard.LayoutDesigner.getLayoutElementByGuid($(ui.unselected).attr('guid'));
                if (curLayoutElement) curLayoutElement.isSelected = false;
                $(ui.unselected).find('.DUI-ST-EL-DIMENSION').remove();
            }
        });
    }

    function getLayoutSizeSelection() {
        var chosenFormat;
        var getDocumentFormatAsString = Storyboard.LayoutDesigner.getDocumentFormatAsString;

        if (arguments.length > 0 && typeof arguments[0] == 'object') {
            if (arguments[0].settings)
                chosenFormat = getDocumentFormatAsString(arguments[0].settings.layoutType);
            else
                chosenFormat = getDocumentFormatAsString(arguments[0].layoutType);
        }
        else if (arguments.length > 0 && typeof arguments[0] != 'undefined') {
            chosenFormat = getDocumentFormatAsString(arguments[0]);
        }
        else {
            chosenFormat = $('LI.ribbonItemChecked[id^="DUI_ST_R_DOCUMENTFORMAT_"]');
            if (chosenFormat.length > 0)
                chosenFormat = chosenFormat.attr('id').split('_').pop();
            else
                chosenFormat = 'PPTONLINE';
        }

        var documentFormat = Storyboard.LayoutDesigner.getDocumentFormatFromString(chosenFormat);
        var formats = Storyboard.Constants.documentFormats;
        var areaSize = getElementDimensions("#layoutArea");
        var pageCount = Storyboard.LayoutDesigner.getPageCount();
        var layoutGrid = Storyboard.LayoutDesigner.getLayoutGrid();

        var layoutSize = {
        	width: documentFormat.layoutWidth || layoutGrid.width || areaSize.width,
        	height: documentFormat.layoutHeight || layoutGrid.height || areaSize.height,
        	pageCount: pageCount,
        	layoutType: documentFormat.hash
        };

        if ((layoutSize.layoutType != formats.PPTONLINE.hash && layoutSize.layoutType != formats.PPT_16_9.hash) ||
            (window.ContentType === Storyboard.Constants.itemTypes.CHART && 
            ChartCreatorSetup.getLayoutTemplateEnabledType() === 'enableMasterSlideLayout')) {
                toggleBackground(false);
        }

        layoutGrid.layoutType = layoutSize.layoutType;

        updateViewPortSize(layoutSize);

        if (layoutSize.layoutType > 0) {
            Storyboard.LayoutDesigner.setSlideshowMode(!Storyboard.LayoutDesigner.slideShowMode, layoutSize.layoutType);
        } else {
            Storyboard.LayoutDesigner.setSlideshowMode(true, layoutSize.layoutType);
        }

        disableUIForDocumentFormat(layoutSize.layoutType);

        return layoutSize;
    }

    function updateViewPortSize(layoutSize) {
        // layoutSize is e.g. Storyboard.Constants.PPTONLINE here
        var formats = Storyboard.Constants.documentFormats;
        var width = ((!Helpers.isPreview() && layoutSize.width < 960) ? 960 : layoutSize.width);
        $('#StorytellerPagesizeViewport')
            .css('width', width + 'px')
            .css('height', (layoutSize.height) + 'px');

        if (layoutSize.layoutType == formats.A4LANDSCAPE.hash || 
            layoutSize.layoutType == formats.A4LANDSCAPE_LEGACY.hash) {
            $('#pageStoryTeller').css('width', width + 'px');
        }
        else {
            $('#pageStoryTeller').css('width', '');
        }

        if (self != top && window.name == "print-frame") // fix layout for print preview
            $("#storyboardContents, #reportWrapper, #contentWrapper").width('auto');
        
        if (Storyboard.LayoutDesigner.isAdmin || window.ContentType === Storyboard.Constants.itemTypes.CHART)
            $('#StorytellerObjectsToolbar').width(width + 'px');

        $(document).trigger('DAPI.updateViewPortSize');
    }

    function setLayoutGridSize(documentFormat, dontRedrawGrid) {
        var layoutGrid = Storyboard.LayoutDesigner.getLayoutGrid();
        Storyboard.LayoutDesigner.setPageSize(documentFormat);

        if (!dontRedrawGrid)
            Storyboard.LayoutDesigner.updateLayoutGrid(layoutGrid);

        return true;
    }

    // Called from layout size change callback 
    function setLayoutGridLayoutType(documentFormat) {
        if (setLayoutGridSize(documentFormat, false)) {
        	Storyboard.LayoutDesigner.setPageSize(documentFormat);
        	Storyboard.LayoutDesigner.setSlidesSize(documentFormat);
            updateViewPortSize(documentFormat);
        }
    }

    function setLayoutGridPageCount(pageCount) {
        var layoutSize = getLayoutSizeSelection();
        Storyboard.LayoutDesigner.setPageSize(layoutSize);
    }

    function toggleBackground(showimage) {
        if (showimage) {
            if (Storyboard.LayoutDesigner.layoutAreaBackgroundImage == '') {
                Storyboard.LayoutDesigner.getBackgroundImage(setLayoutBackground);
            } else {
                setLayoutBackground(Storyboard.LayoutDesigner.layoutAreaBackgroundImage);
            }
        } else {
            setLayoutBackground('');
        }
    }

    function setLayoutBackground(imageUrl) {
        Storyboard.LayoutDesigner.layoutAreaBackgroundImage = imageUrl;

        if (imageUrl != '') {
            $('#layoutArea').css('background-image', "url('" + imageUrl.replace("'", "\\'") + "')");
        } else {
            $('#layoutArea').css('background-image', 'none');
        }
        
        if (Storyboard.SlidesPanel && Storyboard.SlidesPanel.isOpen()) {
            Storyboard.SlidesPanel.renderThumbnailFromSVGs();
        }
    }

    function toggleGridlines(showGridlines) {
        if (Storyboard.LayoutDesigner.isAdmin && !Helpers.isPreview()) {
            Storyboard.LayoutDesigner.showGridlines = Boolean(showGridlines > 0);
            if ($('#GridOverlay').length === 0)
                $('#layoutArea').prepend('<div id="GridOverlay"></div>');
            $('#GridOverlay').css('visibility', (showGridlines > 0 ? 'visible' : 'hidden'));
            switch (showGridlines) {
                case 5:
                    $('#GridOverlay').css('background', "url('images/gridline_overlay_5.png') repeat left top");
                    break;

                case 10:
                    $('#GridOverlay').css('background', "url('images/gridline_overlay.png') repeat left top");
                    break;
                case 15:
                    $('#GridOverlay').css('background', "url('images/gridline_overlay_15.png') repeat left top");
                    break;
                default:
                    $('#GridOverlay').css('background', "url('images/gridline_overlay.png') repeat left top");
            }
        }
        updateMoveSnapp(showGridlines);
    }

    function toggleBorders(showBorders) {
        Storyboard.LayoutDesigner.showBorders = showBorders;
        $('#layoutArea').toggleClass('layoutAreaAdminHideBorders', !showBorders);
    }

    function toggleResultsTooltips(showResultsTooltips) {
        Storyboard.LayoutDesigner.showResultsTooltips = showResultsTooltips;
        $('#layoutArea').toggleClass('layoutAreaAdminHideResultsTooltips', !showResultsTooltips);
    }

    function hideSlideNavigation(hideSlideNavigation) {
        var isDesignMode = Storyboard.LayoutDesigner.isAdmin && !Helpers.isPreview();
        var isMyStoryMode = Storyboard.LayoutDesigner.isMyStoryMode();
        var isChartCreator = window.ContentType == Storyboard.Constants.itemTypes.CHART;
        var pageCount = Storyboard.LayoutDesigner.getPageCount();

        if ((isDesignMode && $(".bgSlideActive").length < 1) || isMyStoryMode)
			hideSlideNavigation = false;
		if (window.IsMyStories && $('#ddlMyStories option').length < 1)
			hideSlideNavigation = true;

        if (!Storyboard.LayoutDesigner.slideShowMode ||
            (pageCount < 2 && (isMyStoryMode || !isDesignMode || isChartCreator)) ||
            (self != top && window.name == "print-frame"))
                hideSlideNavigation = true;

        if (!hideSlideNavigation)
            $('#DUI_ST_NAVIGATOR').css('display', 'block');

        $('.DUI-ST-NAVHOLDER', '#DUI_ST_NAVIGATOR').css('display', (!hideSlideNavigation ? 'block': 'none'), 'important');
    }

    function updateMoveSnapp(snapSize) {
        Storyboard.LayoutDesigner.gridSize = snapSize;
        $(".layoutElement").each(function (i) {
            addDragableAndResizable($(this), snapSize);
        });
    }

    /* End area for layout grid */

    /* Util functions */
    function getElementDimensions(contentBox, searchContext) {
        var elem = searchContext ? $(contentBox, searchContext) : $(contentBox);
        var dim = {
            width: parseInt(elem.outerWidth()),
            height: parseInt(elem.outerHeight()),
            x: elem[0] ? elem[0].offsetLeft : 0,
            y: elem[0] ? elem[0].offsetTop : 0
        };

        // if slide is hidden outerHeight/outerWidth will return 0. gotta hack it =_=
        // things that do not work:
        // - using visibility:hidden instead of display:none - chart svg still shows up; 
        // - getComputedStyle will not return a number for auto values
        if (elem.closest(".layoutSlide.hidden").length > 0) {
            var clone = elem.clone().css("position", "absolute").css("top", "-9999px").appendTo("body");
            dim.height = parseInt(clone.outerHeight());
            dim.width = parseInt(clone.outerWidth());
            clone.remove();
        }
        return dim;
    }

    function centerObjectVertical(obj) {
        obj.css("position", "fixed");
        obj.css("top", (($(window).height() - obj.outerHeight()) / 2) + "px");
        return obj;
    }

    function getContextMenuSection(key) {
        var contextMenuSections = {
            arrange: '<li class="DUIContextMenuPositioning arrangeLayers">' +
                        '<i id="DUI-ST-CM-MOVETOFRONT" data-tooltip="Bring to front"></i>' +
                        '<i id="DUI-ST-CM-MOVEFORWARD" data-tooltip="Bring forward"></i>' +
                        '<i id="DUI-ST-CM-MOVEBACKWARD" data-tooltip="Send backward"></i>' +
                        '<i id="DUI-ST-CM-MOVETOBACK" data-tooltip="Send to back"></i>' +
                        '<i class="DUIContextMenuHDivider"></i>' +
                        '<i id="DUI-ST-CM-LOCK" data-tooltip="Lock"></i>' +
                        '<i id="DUI-ST-CM-HIDE" data-tooltip="Hide"></i>' +
                    '</li>',
            align:  '<li class="DUIContextMenuPositioning alignElements">' +
                        '<i id="DUI-ST-CM-ALIGNLEFT" data-tooltip="Align left"></i>' +
                        '<i id="DUI-ST-CM-ALIGNHCENTER" data-tooltip="Align horizontal center"></i>' +
                        '<i id="DUI-ST-CM-ALIGNRIGHT" data-tooltip="Align right"></i>' +
                        '<i id="DUI-ST-CM-ALIGNTOP" data-tooltip="Align top"></i>' +
                        '<i id="DUI-ST-CM-ALIGNVCENTER" data-tooltip="Align vertical center"></i>' +
                        '<i id="DUI-ST-CM-ALIGNBOTTOM" data-tooltip="Align bottom"></i>' +
                    '</li>',
            distribute:  '<li class="DUIContextMenuPositioning distributeElements">' +
                            '<i id="DUI-ST-CM-DISTRIBUTEVERTICAL" data-tooltip="Distribute vertical"></i>' +
                            '<i id="DUI-ST-CM-DISTRIBUTEHORIZONTAL" data-tooltip="Distribute horizontal"></i>' +
                        '</li>',
            coordinates: '<li class="DUIContextMenuPositioning elementsCoords">' +
                            '<input type="text" id="DUI-ST-CM-COORD-X"/>' +
                            '<input type="text" id="DUI-ST-CM-COORD-Y"/>' +
                        '</li>',
            size: '<li class="DUIContextMenuPositioning elementsDimension">' +
                        '<input type="text" id="DUI-ST-CM-WIDTH"/>' +
                        '<i id="DUI-ST-CM-ASPECT-RATIO" data-tooltip="Maintain aspect ratio"></i>' +
                        '<input type="text" id="DUI-ST-CM-HEIGHT"/>' +
                    '</li>',
            undoSizePosition: '<li><span id="DUI-ST-CM-UNDO"><em>'+locale.get('Undo size/position')+'</em></span></li>',
            swapPositions: '<li><span id="DUI-ST-CC-SWAP"><em>'+locale.get('Swap object positions')+'</em></span></li>',
            divider: '<li class="DUIContextMenuDivider"></li>'
        };

        return contextMenuSections[key] || '';
    }

    function showContextMenu(evt) {
        var m = [], layoutElement, type, group;
        var layoutElementsSelected = $('#layoutArea .ui-selected');
        var groupsSelected = $('#layoutArea .layoutElementsGroup');
        var pendingElements = $('.layoutElementAdminPendingCut, .layoutElementAdminPendingCopy', '#layoutArea').length > 0;

        if ($(evt.currentTarget).is('.menu, .layoutElementAdmin, .le') ||
            $(evt.currentTarget).parent().is('.menu, .layoutElementAdmin, .le')) {
            // Clicked inside a contentbox, check if it was on chart Div,
            // on the menu option in the box's toolbar
            // or the actual layoutElement Div and get guid from correct Div
            var guid = $(evt.currentTarget).closest('.layoutElementAdmin').attr('guid');

            if (!guid)
                guid = $(evt.currentTarget).closest('.DUIContextMenu').attr('id') ||
                        $(evt.currentTarget).closest('.le').attr('data-guid');

            layoutElement = Storyboard.LayoutDesigner.getLayoutElementByGuid(guid);
            type = Storyboard.LayoutDesigner.getLayoutElementType(layoutElement);
            
            if (layoutElement.groupId)
                group = Storyboard.LayoutDesigner.getLayoutElementsGroup(layoutElement.groupId);

            m.push('<ul id="' + guid + '" class="DUIContextMenu">');

            if (type == itemTypes.IMAGE) {
                m.push('<li><span id="DUI-ST-CM-DEFAULT"><em>'+locale.get('Restore default size')+'</em></span></li>');
            } else {
                if (type == itemTypes.EMPTYCHARTCREATOR) {
                    m.push('<li class="DUIContextMenuParent"><span><em>'+locale.get('Edit content')+'</em></span>');
                    m.push('<ul class="DUIContextMenu DUIContextMenuNewObject storytellerCreatorContextMenu">');
                    m.push(Storyboard.LayoutDesigner.getObjectTypesHTML());
                    m.push('</ul>');
                    m.push('</li>');
                } else {
                    m.push('<li><span id="DUI-ST-CM-EDITBOXCONTENT"><em>'+locale.get('Edit content')+'</em></span></li>');
                }
            }
            
            // ARRANGE LAYERS
            m.push(getContextMenuSection('divider'));
            m.push(getContextMenuSection('arrange'));
            
            // CUT,COPY,PASTE COMMANDS

            if (m.length > 1) 
                m.push(getContextMenuSection('divider'));
            
            m.push('<li><span id="DUI-ST-CM-COPY"><em>'+locale.get('Copy')+'</em></span></li>');
            m.push('<li><span id="DUI-ST-CM-CUT"><em>'+locale.get('Cut')+'</em></span></li>');

            if (pendingElements) {
                m.push('<li><span id="DUI-ST-CM-PASTE"><em>'+locale.get('Paste')+'</em></span></li>');
                m.push('<li><span id="DUI-ST-CM-PASTE-HERE"><em>'+locale.get('Paste here')+'</em></span></li>');
            }
            if (window.IsStoryboard && pendingElements && Storyboard.LayoutDesigner.slideShowMode && !$(".bgSlideActive").length > 0)
                m.push('<li><span id="DUI-ST-CM-PASTE-TO-ALL-SLIDES"><em>'+locale.get('Paste into all slides')+'</em></span></li>');
            
            if (layoutElementsSelected.length > 1 && !layoutElement.groupId) {
                m.push(getContextMenuSection('divider'));
                m.push('<li><span id="DUI-ST-CM-GROUP"><em>'+locale.get('Group')+'</em></span></li>');
            }
            
            if (!group || group.layoutElementsSizePosition === true) {
                // ALIGN COMMANDS
                m.push(getContextMenuSection('divider'));
                m.push(getContextMenuSection('align'));
                
                if (layoutElementsSelected.length + groupsSelected.length > 2) {
                    m.push(getContextMenuSection('distribute'));
                }
                
                m.push(getContextMenuSection('divider'));
                m.push('<li class="DUIContextMenuParent"><span><em>'+locale.get('Size and position')+'</em></span>');
                m.push('<ul class="DUIContextMenu">');
                    if (type === itemTypes.ICONSHAPE || type === itemTypes.DYNAMICICONSHAPE) {
                        m.push('<li><span id="DUI-ST-CM-FULLSIZE"><em>'+locale.get('Full size')+'</em></span></li>');
                        m.push(getContextMenuSection('divider'));
                    }
                    if (Storyboard.LayoutDesigner.history.length() > 0) {
                        m.push(getContextMenuSection('undoSizePosition'));
                        m.push(getContextMenuSection('divider'));
                    }
                    m.push(
                        getContextMenuSection('coordinates') +
                        getContextMenuSection('size') +
                        getContextMenuSection('divider')
                    );
                m.push('</ul>');
                m.push('</li>');
                m.push(getContextMenuSection('divider'));
            } else if (Storyboard.LayoutDesigner.history.length() > 0) {
                m.push(getContextMenuSection('undoSizePosition'));
                m.push(getContextMenuSection('divider'));
            }

            if (type !== itemTypes.LINKEDCHART) {
                m.push('<li><span id="DUI-ST-CM-EDITTAGS"><em>' + locale.get('Edit Tags') + '</em></span></li>');
                m.push(getContextMenuSection('divider'));
            }
            if (type !== itemTypes.STATICTEXT && type !== itemTypes.LINKEDCHART) {
                m.push('<li><span id="DUI-ST-CM-EDITHEADERFOOTER"><em>'+locale.get('Edit Header/Footer')+'</em></span></li>');
                m.push(getContextMenuSection('divider'));
            }
            if (type == itemTypes.CHART) {
                m.push('<li><span id="DUI-ST-CM-EDITOPTIONALSETTINGS"><em>'+locale.get('Define Optional Chart settings')+'</em></span></li>');
                m.push(addChartLayoutElementOptionsToContextMenu(type))

                m.push(getContextMenuSection('divider'));
            }
            if (type == itemTypes.SIMPLETABLE || type == itemTypes.RESPONDENTTABLE || type == itemTypes.ICONSHAPE || type == itemTypes.DYNAMICICONSHAPE || type == itemTypes.IMAGE || type == itemTypes.DYNAMICIMAGE || type == itemTypes.STATICTEXT || type == itemTypes.TEXT || type == itemTypes.WORDCLOUD) {
                m.push(addChartLayoutElementOptionsToContextMenu(type))
            }

            if (layoutElementsSelected.length === 1 && type == itemTypes.ICONSHAPE) {
                    m.push('<li class="DUIContextMenuIconShape"><em>'+locale.get('Opacity')+'</em><input type="text" id="DUI-ST-CM-OPACITY"/></div></li>');
                    m.push('<li class="DUIContextMenuIconShape"><em>'+locale.get('Color')+'</em><div class="ColorPickers"><input type="text" id="DUI-ST-CM-COLOR" class="ColorTextbox"/></div></li>');
                    m.push('<li class="DUIContextMenuIconShape"><em>'+locale.get('Gradient')+'</em><div class="ColorPickers"><input type="text" id="DUI-ST-CM-GRADIENT-COLOR-1" class="ColorTextbox"/><input type="text" id="DUI-ST-CM-GRADIENT-COLOR-2" class="ColorTextbox"/></div></li>');
                    m.push('<li class="DUIContextMenuParent DUIContextMenuIconShape"><em>'+locale.get('Flip')+'</em></span>');
                        m.push('<ul class="DUIContextMenu">');
                        m.push('<li><span id="DUI-ST-CM-FLIPHORIZONTAL"><em>'+locale.get('Flip Horizontal')+'</em></span></li>');
                        m.push('<li><span id="DUI-ST-CM-FLIPVERTICAL"><em>'+locale.get('Flip Vertical')+'</em></span></li>');
                        m.push('</ul>');
                    m.push('</li>');
                    m.push(getContextMenuSection('divider'));
            }
            
            // DELETE BOX COMMAND
            if (layoutElementsSelected.length > 0) {
                m.push('<li><span id="DUI-ST-CM-DELETE"><em>Delete</em></span></li>');
            }
        } else if ($(evt.currentTarget).is('.layoutElementsGroup, .lg')) {
            // Clicked on layout elements group
            var id = $(evt.currentTarget).attr('layoutelementsgroupid') || $(evt.currentTarget).attr('data-group');
            group = Storyboard.LayoutDesigner.getLayoutElementsGroup(parseInt(id, 10));

            m.push('<ul layoutelementsgroupid="' + id + '" class="DUIContextMenu">');
                m.push('<li><span id="DUI-ST-CM-UNGROUP"><em>'+locale.get('Ungroup')+'</em></span></li>');
                if (groupsSelected.length === 1)
                    m.push('<li><span id="DUI-ST-CM-RENAMEGROUP"><em>'+locale.get('Rename Group')+'</em></span></li>');
                m.push(getContextMenuSection('divider'));
                m.push(getContextMenuSection('arrange'));
                if (group.layoutElementsSizePosition) {
                    m.push('<i id="DUI-ST-CM-SIZEPOSITIONUNLOCK" data-tooltip="Lock objects size and position" class="floatRight unlocked"></i>');
                } else {
                    m.push('<i id="DUI-ST-CM-SIZEPOSITIONUNLOCK" data-tooltip="Unlock objects size and position" class="floatRight"></i>');
                }
                m.push('</li>');
                m.push(getContextMenuSection('divider'));
                m.push('<li><span id="DUI-ST-CM-CUT"><em>'+locale.get('Cut')+'</em></span></li>');
                m.push('<li><span id="DUI-ST-CM-COPY"><em>'+locale.get('Copy')+'</em></span></li>');
                if (pendingElements) {
                    m.push('<li><span id="DUI-ST-CM-PASTE"><em>'+locale.get('Paste')+'</em></span></li>');
                    m.push('<li><span id="DUI-ST-CM-PASTE-HERE"><em>'+locale.get('Paste here')+'</em></span></li>');
                }
                if (window.IsStoryboard && pendingElements && Storyboard.LayoutDesigner.slideShowMode && !$(".bgSlideActive").length > 0)
                    m.push('<li><span id="DUI-ST-CM-PASTE-TO-ALL-SLIDES"><em>'+locale.get('Paste into all slides')+'</em></span></li>');
                m.push(getContextMenuSection('divider'));

                // ALIGN COMMANDS
                m.push(getContextMenuSection('align'));
                
                if (layoutElementsSelected.length + groupsSelected.length > 2) {
                    m.push(getContextMenuSection('distribute'));
                }

                m.push(getContextMenuSection('divider'));
                m.push('<li class="DUIContextMenuParent"><span><em>'+locale.get('Size and position')+'</em></span>');
                m.push('<ul class="DUIContextMenu">');
                    if (Storyboard.LayoutDesigner.history.length() > 0) {
                        m.push(getContextMenuSection('undoSizePosition'));
                        m.push(getContextMenuSection('divider'));
                    }
                    m.push(
                        getContextMenuSection('coordinates') +
                        getContextMenuSection('size') +
                        getContextMenuSection('divider')
                    );
                m.push('</ul>');
                m.push('</li>');
                m.push(getContextMenuSection('divider'));

                m.push('<li><span id="DUI-ST-CM-DELETE"><em>Delete</em></span></li>');
        } else if (pendingElements) {
            // Clicked on layoutArea
            m.push('<ul class="DUIContextMenu">');
            m.push('<li><span id="DUI-ST-CM-PASTE"><em>'+locale.get('Paste')+'</em></span></li>');
            m.push('<li><span id="DUI-ST-CM-PASTE-HERE"><em>'+locale.get('Paste here')+'</em></span></li>');
            if (window.IsStoryboard && pendingElements && Storyboard.LayoutDesigner.slideShowMode && !$(".bgSlideActive").length > 0)
                m.push('<li><span id="DUI-ST-CM-PASTE-TO-ALL-SLIDES"><em>'+locale.get('Paste into all slides')+'</em></span></li>');

            if (Storyboard.LayoutDesigner.history.length() > 0) {
                 m.push(getContextMenuSection('undoSizePosition'));
                 m.push(getContextMenuSection('divider'));
            }
        } else if (Storyboard.LayoutDesigner.history.length() > 0) {
            m.push('<ul class="DUIContextMenu">');
                m.push(getContextMenuSection('undoSizePosition'));
        }

        if (window.IsStoryboard) {
            if (m.length > 1)
                m.push(getContextMenuSection('divider'));
            else
                m.push('<ul class="DUIContextMenu">');

            if (Storyboard.LayoutDesigner.isUnsaved) {
                m.push('<li class="DUIContextMenuParent DUIContextMenuTemplates"><span disabled="disabled" title="Operation unavailable: layout has unsaved changes"><em>'+locale.get('Templates')+'</em></span></li>');
            } else {
                m.push('<li class="DUIContextMenuParent DUIContextMenuTemplates"><span><em>'+locale.get('Templates')+'</em></span>');
                m.push('<ul class="DUIContextMenu">');

                if ($(".bgSlideActive").length < 1) {
                    if (layoutElementsSelected.length === 1 && groupsSelected.length === 0)
                        m.push("<li><span id='DUI-ST-CM-SAVEELEMENTTEMPLATE'><em>" + locale.get("Save element as template") + "</em></span></li>");
                    else if (layoutElementsSelected.length === 0 && groupsSelected.length === 1)
                        m.push("<li><span id='DUI-ST-CM-SAVEGROUPTEMPLATE'><em>" + locale.get("Save group as template") + "</em></span></li>");

                    m.push("<li><span id='DUI_ST_CM_SAVESLIDETEMPLATE'><em>" + locale.get("Save slide as template") + "</em></span></li>");
                    m.push("<li><span id='DUI_ST_CM_SAVEREPORTTEMPLATE'><em>" + locale.get("Save report as template") + "</em></span></li>");
                    var currentSlide = Storyboard.LayoutDesigner.getCurrentSlide();
                    var disabled = currentSlide.isToplineCompatible ? '' : ' disabled = "disabled"';
                    m.push(getContextMenuSection('divider'));
                    m.push("<li><span id='DUI_ST_CM_SAVESLIDETOTEMPLATESET' " + disabled + "><em>" + locale.get("Save slide to Autogeneration template set") + "</em></span></li>");

                } else
                    m.push("<li><span id='DUI_ST_CM_SAVESLIDETEMPLATE'><em>" + locale.get("Save background as template") + "</em></span></li>");

                m.push('</ul>');
                m.push('</li>');
            }
        }

        m.push('</ul>');

        // Add menu to body
        if (m.length > 2)
            $('body').append(m.join(''));

        positionContextMenu(evt);
        bindTooltips('.DUIContextMenu');
        
        Storyboard.LayoutDesigner.updatePositioningValues();
        Storyboard.LayoutDesigner.addEventsToContextMenu();

        if (layoutElementsSelected.length === 1 && 
            Storyboard.LayoutDesigner.getLayoutElementType(layoutElement) == itemTypes.ICONSHAPE)
                IconShapeSetup.setupContextMenu(layoutElement);
    }

    function addChartLayoutElementOptionsToContextMenu (objectType) {
        var removeText = '';
        var dividerHTML = '<li class="DUIContextMenuDivider"></li>';
        
        if(objectType === itemTypes.SIMPLETABLE || objectType == itemTypes.RESPONDENTTABLE || objectType == itemTypes.TABLE)
            removeText = locale.get('Remove table');
        
        if(objectType === itemTypes.CHART || objectType == itemTypes.LINKEDCHART || objectType == itemTypes.HEATMAP)
            removeText = locale.get('Remove chart');

        if(objectType === itemTypes.ICONSHAPE || objectType == itemTypes.DYNAMICICONSHAPE)
            removeText = locale.get('Remove icon/shape');
        
        if(objectType === itemTypes.IMAGE || objectType == itemTypes.DYNAMICIMAGE)
            removeText = locale.get('Remove image');
        
        if(objectType === itemTypes.STATICTEXT || objectType == itemTypes.TEXT)
            removeText = locale.get('Remove text');

        if(objectType === itemTypes.WORDCLOUD)
            removeText = locale.get('Remove word cloud');
        
        var removeHTML = '<li id="DUI-CC-CM-REMOVE-CHART"><span><em>' + removeText + '</em></span></li>';

        return dividerHTML + removeHTML;
    }

    function positionContextMenu(evt) {
        var using = function (obj) {
            var element = $(this);
            element
                .addClass(function() {
                    return (($(window).width() - evt.pageX) < (element.width() * 2)) ?
                            'flippedHorizontal' : '';
                })
                .css({
                    left: (obj.left + 2) + 'px',
                    top: (obj.top + 2) + 'px'
                });
        };

        var options = {
            my: 'left top',
            at: 'left top',
            of: evt,
            using: using
        };

        if ($(evt.currentTarget).is('.DUIButton.menu.cssArw'))
            options.of = evt.currentTarget;
        
        if ($(evt.currentTarget).is('.le') || $(evt.currentTarget).is('.lg')) {
            options.my = 'right top';
            options.at = 'left top';
            options.of = evt.currentTarget;
        }

        $('body > .DUIContextMenu')
            .data('position', {pageX: evt.pageX, pageY: evt.pageY})
            .position(options);
    }

    function bindTooltips(containerEl) {
        var tooltip = null;
        $(containerEl).find('[data-tooltip], [data-dui-tooltip]').unbind('mouseenter mouseleave')
        .bind('mouseenter', function () {
            var that = this;
            tooltip = setTimeout(function () {
                $('<div/>', {
                    text: locale.get($(that).attr('data-tooltip') || $(that).attr('data-dui-tooltip')),
                    'class': 'DUIContextMenu-tooltip',
                    css: {
                        'left': (that.offsetLeft - 50) + 'px'
                    }
                }).insertAfter($(that));
            }, 400);
        }).bind('mouseleave', function () {
            clearTimeout(tooltip);
            $(this).next('.DUIContextMenu-tooltip').remove();
        });
    }
    
    function showTemplatesPanel() {
        $("html").addClass("DUISetup-lock");
        $("#templatesHolder").show();
    }

    function hideTemplatesPanel() {
        $("#templatesHolder").hide(0, function () {
            $("html").removeClass("DUISetup-lock");
        });
    }

    function showComputesPanel() {
        $("html").addClass("DUISetup-lock");
        $("#computesHolder").show();
    }

    function hideComputesPanel() {
        $("#computesHolder").hide(0, function () {
            $("html").removeClass("DUISetup-lock");
        });
    }

    function setupSingleObjectMode(objectType) {
        var settings;

        switch (objectType) {
            case itemTypes.CROSSTABLE:
                settings = $("#tabholder_ct").detach();
                $("#singleObjectSetupPanel").append(settings);
                CrossTable2Setup.setupCrossTabSettingsPanel();
                break;
            case itemTypes.CHART:
                ChartCreatorSetup.setupReportSettings();
                break;
        }
    }

    function showEditPanel(contentElement, layoutElement, mainSeriesType) {
        var elementType = Storyboard.LayoutDesigner.getLayoutElementType(layoutElement);
        var curEditBox = $(".layoutElement[guid='" + layoutElement.guid + "']");
        layoutElement.zIndex = parseInt(curEditBox.get(0).style.zIndex, 10);
        curEditBox.addClass('layoutElementAdminFocused');
        $("#DUI-ST-MULTIEDIT").hide();

        $('#setupHolder').click(function (evt) {
            Storyboard.GuiEvents.hideAllMenusAndPanels(evt);
        });

        // Display the edit panel
        DUIWindowScrollbar.setScrollbar();
        $('html').addClass('DUISetup-lock');
        SetupEditMode(contentElement, layoutElement);
        // Move it to the top of the browser viewport
        $('#setupHolder').show();
        switch (parseInt(elementType)) {
            case parseInt(itemTypes.CHART, 0):
                $("#DUI-ST-MULTIEDIT").show();
                if (layoutElement.layoutElementId === 0) {
                    $('#DUI-ST-MULTIEDIT').attr("disabled", true);
                    $('#DUI-ST-MULTIEDIT').attr("title", "The chart needs to be saved before this function can be used. To save the chart use Save Layout.");
                } else {
                    $('#DUI-ST-MULTIEDIT').attr("disabled", false);
                    $('#DUI-ST-MULTIEDIT').attr("title", "");
                }
            // eslint-disable-next-line no-fallthrough
            case parseInt(itemTypes.SIMPLETABLE, 0):
            case parseInt(itemTypes.HEATMAP, 0):
                $("#tabholder").tabs("select", 0);
                $('#setupChart').show();
                $('#setupHolder').addClass('setupChart');
                
                $('.ColorTextbox:not(.colorpicker-target)').DUIColorPicker({
                    layout: 'template'
                });
                $('.ColorTextboxNoTransparent:not(.colorpicker-target)').DUIColorPicker({
                    layout: 'template',
                    'transparent': false
                });
                if (parseInt(itemTypes.CHART, 0) == parseInt(elementType)
                    && mainSeriesType != Storyboard.Constants.SeriesTypes.HEATMAP) {
                    $('#ddlBenchmarkAxis option[value=1]').text(locale.get('Legend'));
                    $('#ddlBenchmarkAxis option[value=2]').text(locale.get('Axis'));
                }
                else {
                    $('#ddlBenchmarkAxis option[value=1]').text(locale.get('Columns'));
                    $('#ddlBenchmarkAxis option[value=2]').text(locale.get('Rows'));
                }
                if (layoutElement.isImportedTemplate && (parseInt(itemTypes.HEATMAP, 0) !== parseInt(elementType)))
                    ChartSetupUI.initWizard(layoutElement.templateId);
                    
                window.changeHelpIDs(parseInt(elementType));
                break;
            case parseInt(itemTypes.DATAFIELD, 0):
                $('#setupDataField').show();
                break;
            case parseInt(itemTypes.EVENTCREATOR, 0):
                $('#setupEventCreatorTab').show();
                break;
            case parseInt(itemTypes.TEXT, 0):
                $('#setupText').show();
                $('#setupHolder').addClass('setupText');
                var editorInstance = tinyMCE.get("txtTextMediaContent");
                if (editorInstance) editorInstance.focus();
                break;
            case parseInt(itemTypes.TABLE, 0):
                $('#setupCrosstab').show();
                $('#setupHolder').addClass('setupCrosstab');
                break;
            case parseInt(itemTypes.RESPONDENTTABLE, 0):
                RespondentTableSetup.loadTabs();
                if (layoutElement.isImportedTemplate) RespondentTableSetup.initWizard(layoutElement.templateId);
                $('#setupRespondentTab').show();
                break;
            case parseInt(itemTypes.LINKEDCHART, 0):
                $('#setupLinked').show();
                $('#setupHolder').addClass('setupLinked');
                break;
            case parseInt(itemTypes.DYNAMICIMAGE, 0):
                DynamicImageSetup.loadTabs();
                $('#setupDynamicImageTab').show();
                $('#setupHolder').addClass('setupDynamicImage');
                break;
            case parseInt(itemTypes.WORDCLOUD, 0):
                WordCloudSetup.loadTabs();
                if (layoutElement.isImportedTemplate) WordCloudSetup.initWizard(layoutElement.templateId);
                $('#setupWordCloudTab').show();
                break;
            case parseInt(itemTypes.STATICTEXT, 0):
                $('#setupHolder').hide();
                break;
            case parseInt(itemTypes.ICONSHAPE, 0):
                $('#setupIconShapeTab').show();
                break;
            case parseInt(itemTypes.DYNAMICICONSHAPE, 0):
                if (layoutElement.isImportedTemplate) DynamicIconShapeSetup.initWizard(layoutElement.templateId);
                $("#setupDynamicIconShapeTab").show();
                break;
            case parseInt(itemTypes.SUMMARY, 0):
                SummarySetup.loadTabs();
                if (layoutElement.isImportedTemplate) SummarySetup.initWizard(layoutElement.templateId);
                $('#setupSummaryTab').show();
                break;
            case parseInt(itemTypes.ADVANCEDANALYTICS, 0):
                AdvancedAnalyticsSetup.loadTabs();
                $('#setupAdvancedAnalyticsTab').show();
                break;
        }
    }

    // Hiding of panel, menus, popups, etc...
    function hideEditPanel(type) {
        $('.layoutElementAdminFocused').removeClass('layoutElementAdminFocused');
        if (type == itemTypes.CHART || type == itemTypes.SIMPLETABLE)
            $('#setupChart').hide();
        else if (type == itemTypes.TABLE)
            $('#setupCrosstab').hide();
        else if (type == itemTypes.RESPONDENTTABLE)
            $('#setupRespondentTab').hide();
        else if (type == itemTypes.LINKEDCHART)
            $('#setupLinked').hide();
        else if (type == itemTypes.TEXT)
            $('#setupText').hide();
        else if (type == itemTypes.DYNAMICIMAGE)
            $('#setupDynamicImageTab').hide();
        else if (type == itemTypes.WORDCLOUD)
            $('#setupWordCloudTab').hide();
        else if (type == itemTypes.DATAFIELD)
            $('#setupDataField').hide();
        else if (type == itemTypes.EVENTCREATOR)
            $('#setupEventCreatorTab').hide();
        else if (type == itemTypes.ICONSHAPE)
            $('#setupIconShapeTab').hide();
        else if (type == itemTypes.DYNAMICICONSHAPE)
            $("#setupDynamicIconShapeTab").hide();
        else if (type == itemTypes.CROSSTABLE)
            $("#setupCrossTable2").hide();
        else if (type == itemTypes.SUMMARY)
            $('#setupSummaryTab').hide();
        else if (type == itemTypes.ADVANCEDANALYTICS)
            $('#setupAdvancedAnalyticsTab').hide();
    }

    function hideEditPanels(evt) {
        if (IconShapeSetup.libraryEdit) {
            IconShapeSetup.closeLibraryEdit();
            return;
        }

        var curEditBox = $('.layoutElementAdminFocused');
        if (curEditBox != null) {
            var layoutElement = Storyboard.LayoutDesigner.getLayoutElementByGuid(curEditBox.attr('guid'));
            var type = Storyboard.LayoutDesigner.getLayoutElementType(layoutElement);
            if (type == itemTypes.ICONSHAPE) {
                updateIconShape(layoutElement);
                IconShapeUI.clearPreview(true);
            }
            if (type == itemTypes.CHART || type == itemTypes.SIMPLETABLE) ChartSetupUI.removeWizard();
            else if (type == itemTypes.DYNAMICICONSHAPE) DynamicIconShapeSetup.removeWizard();
            else if (type == itemTypes.RESPONDENTTABLE) RespondentTableSetup.clearEditPanel();
            else if (type == itemTypes.ADVANCEDANALYTICS) AdvancedAnalyticsSetup.clearEditPanel();
            else if (type == itemTypes.WORDCLOUD) WordCloudSetup.removeWizard();
            $('.layoutElementAdminFocused').removeClass('layoutElementAdminFocused');
            $('#setupHolder').hide(0, function () {
                $('html').removeClass('DUISetup-lock');
                DUIWindowScrollbar.resetScrollbar();
                deselectAllBoxes();
                $(this).removeClass().addClass('DUISetupOuter DUISetupOverlay');
                var toHide = ['#setupChart', '#setupCrosstab', "#setupDynamicIconShapeTab", '#setupLinked', '#setupText', '#setupRespondentTab',
                    '#setupDynamicImageTab', '#setupWordCloudTab', '#setupDataField', '#setupEventCreatorTab', '#setupIconShapeTab', "#setupCrossTable2",
                    "#setupChartCreator", '#setupSummaryTab', '#setupAdvancedAnalyticsTab'];
                $(toHide.join(',')).hide();
            });
        }
        if (evt) {
            evt.preventDefault();
            evt.stopPropagation();
            hideAllMenusAndPanels(evt);
        }
    }

    function deselectAndHideAll(evt) {
        deselectAllBoxes();
        deselectAllGroups();
        hideAllMenusAndPanels(evt);
    }

    function deselectAllBoxes() {
        $("#StorytellerObjectsToolbar input:focus").blur();
        $('#layoutArea .ui-selected').removeClass('ui-selected').blur()
            .find('.DUI-ST-EL-DIMENSION').remove();
        var layoutElements = Storyboard.LayoutDesigner.getLayoutElements();
        for (var i in layoutElements)
            if (layoutElements.hasOwnProperty(i)) {
                layoutElements[i].isSelected = false;
            }
    }

    function deselectAllGroups() {
        var layoutGrid = Storyboard.LayoutDesigner.getLayoutGrid();
        var layoutElementGroups = layoutGrid && layoutGrid.layoutElementGroups ? layoutGrid.layoutElementGroups : [];

        for (var g = 0; g < layoutElementGroups.length; g++) {
            if (layoutElementGroups[g].isSelected) {
                layoutElementGroups[g].isSelected = false;
                $('#layoutelementsgroup-' + layoutElementGroups[g].groupId).remove();
                for (var l = 0; l < layoutElementGroups[g].layoutElements.length; l++) {
                    $('#' + layoutElementGroups[g].layoutElements[l].guid).removeClass('ui-group-selected');
                }
            }
        }
    }

    function hideAllMenusAndPanels(evt) {
        $('body > .ChartStyleDashStyleList, body > .DUIContextMenu, body > .colorpicker').remove();
        $('.ChartStyleDashStyleActive').removeClass('ChartStyleDashStyleActive');

        /* only hide #LayoutElementsPanel if the event isn't originating from a descendant control */
        if ($('#LayoutElementsPanel').length > 0) {
            if ((!evt || !evt.target) || $(evt.target).parents('#LayoutElementsPanel').length === 0 || evt.target.nodeName === 'EM') {
                Storyboard.LayoutDesigner.LayoutElementsPanel.closePanel();
            } else {
                Storyboard.LayoutDesigner.LayoutElementsPanel.refreshListSelections();
            }
        }

        var selectBoxContainer = $('.DUIslideNavigator_SelectBoxContainer')
            .filter(function() { return this.style.display === 'block'; });

        if (selectBoxContainer.length > 0) {
            selectBoxContainer.siblings('.DUIslideNavigator_SingleButton').click();
        }

        var exportmenu = $('.highcharts-container > .highcharts-export-menu:visible')
            .filter(function() { return this.style.display === 'block'; });

        if (exportmenu.length > 0) {
            $(exportmenu).css({
                'left': 'auto',
                'right': '-14px',
                'top': '-2px',
                'display': 'none'
            });
        }

        // close any active colorpickers
        $('.colorpicker-target.active').DUIColorPicker('hide');

        // close any open filters
        $('#pnlSettingsPanel .ui-multiselect.ui-state-active').prev('select').multiselect('close');

        $('#layoutArea .layoutElementShortcutsOptionsList').remove();

        Storyboard.EventBus.emit(Storyboard.Constants.Events.CLOSE_MENUS);
    }

    function disableUIForDocumentFormat(layoutType) {
        var formats = Storyboard.Constants.documentFormats;
        var disableItems = [];
        var availableDisableItems = [
            '#btnDownloadCharts',
            '#DUI_ST_R_ADDCOMPONENT_RICHCONTENT',
            '#DUI_ST_R_ADDCOMPONENT_STATICTEXT',
            '#DUI_ST_R_ADDCOMPONENT_CHART',
            '#DUI_ST_R_ADDCOMPONENT_IMAGE',
            '#DUI_ST_R_ADDCOMPONENT_IMAGE_SPAN',
            '#DUI_ST_R_ADDCOMPONENT_RESPONDENTTABLE',
            '#DUI_ST_R_ADDCOMPONENT_DYNAMICIMAGE',
            '#DUI_ST_R_SHOWPPTTEMPLATE',
            '#DUI_ST_R_ADDCOMPONENT_WORDCLOUD'
        ];
        // Things inside iframe for image component
        if (window.frames['editImage']) {
            var icufd = window.frames['editImage'].document;
            var uploader = $('#uploader', icufd);
            var icufd_div = $(uploader).parent();
        }
        // ----------------------------------------

        switch (layoutType) {
            case formats.A4LANDSCAPE_LEGACY.hash:
                // let this one bleed through for now, Landscape and Portrait use the same settings.
            case formats.A4PORTRAIT_LEGACY.hash:
                disableItems = [0, 1, 2, 3, 4, 5, 6, 7, 8, 10];
                break;
            case formats.PPTONLINE.hash:
                // let it bleed through
            case formats.CUSTOM.hash:
                disableItems = [0];
                break;
        }
        $(availableDisableItems.join(',')).removeAttr('disabled');
        if (window.frames['editImage']) {
            uploader.removeAttr('disabled');
            $(icufd_div).removeAttr('disabled');
        }
        for (var index in disableItems)
            if (disableItems.hasOwnProperty(index)) {

                $(availableDisableItems[disableItems[index]]).attr('disabled', 'disabled');
                if (index == 6 && window.frames['editImage']) {
                    // Disable iframe for Image component
                    $(uploader).attr('disabled', 'disabled');
                    $(icufd_div).attr('disabled', 'disabled');
                }
            }
    }
    // End hiding panels,menus,etc stuff

    function isElementDisabled(element) {
        return $(element).attr('disabled');
    }

    function saveSettings(evt) {
        // validation
        if ($('#chkPercentile').attr('checked')) {
            var start = $('#startPercentile').val();
            var leastPercentile = Math.min.apply(Math, $('.percentileRow').find('.percentilePercentile')
              .map(function () { return $(this).attr("value"); }).get());

            if (start > leastPercentile) {
                Storyboard.LayoutControls.showError(locale.get('Please select the same or lower value for "Start percentile" than that of your lowest percentile.'));
                $('#startPercentile').addClass('DUIerror');
                return false;
            }
            else
                $('#startPercentile').removeClass('DUIerror');
        }

        var curEditBox = $('.layoutElementAdminFocused');
        var layoutElement = Storyboard.LayoutDesigner.getLayoutElementByGuid(curEditBox.attr('guid'));
        var chartElem = Storyboard.LayoutDesigner.getElementItemByType(itemTypes.CHART, itemTypes.SIMPLETABLE, itemTypes.HEATMAP, layoutElement);
        var textEditorElem = Storyboard.LayoutDesigner.getElementItemByType(itemTypes.TEXT, layoutElement);
        var tableElem = Storyboard.LayoutDesigner.getElementItemByType(itemTypes.TABLE, layoutElement);
        var respondentTableElem = Storyboard.LayoutDesigner.getElementItemByType(itemTypes.RESPONDENTTABLE, layoutElement);
        var dynamicImageElem = Storyboard.LayoutDesigner.getElementItemByType(itemTypes.DYNAMICIMAGE, layoutElement);
        var linkedChartElem = Storyboard.LayoutDesigner.getElementItemByType(itemTypes.LINKEDCHART, layoutElement);
        var staticTextElem = Storyboard.LayoutDesigner.getElementItemByType(itemTypes.STATICTEXT, layoutElement);
        var imageElem = Storyboard.LayoutDesigner.getElementItemByType(itemTypes.IMAGE, layoutElement);
        var wordCloudElem = Storyboard.LayoutDesigner.getElementItemByType(itemTypes.WORDCLOUD, layoutElement);
        var dataFieldElem = Storyboard.LayoutDesigner.getElementItemByType(itemTypes.DATAFIELD, layoutElement);
        var eventCreatorElem = Storyboard.LayoutDesigner.getElementItemByType(itemTypes.EVENTCREATOR, layoutElement);
        var iconShapeElem = Storyboard.LayoutDesigner.getElementItemByType(itemTypes.ICONSHAPE, layoutElement);
        var dynamicIconShapeElem = Storyboard.LayoutDesigner.getElementItemByType(itemTypes.DYNAMICICONSHAPE, layoutElement);
        var summaryElem = Storyboard.LayoutDesigner.getElementItemByType(itemTypes.SUMMARY, layoutElement);
        var advancedAnalyticsElem = Storyboard.LayoutDesigner.getElementItemByType(itemTypes.ADVANCEDANALYTICS, layoutElement);

        var layoutElementName = $('#editPanelTitle').val();
        if (layoutElementName != layoutElement.layoutElementItems[0].elementItemName) {
            sb.LayoutDesigner.saveLayoutElementName(layoutElement, layoutElementName);
            layoutElement.layoutElementItems[0].elementItemName = HTMLHelpers.htmlEncode(layoutElementName);
        }
        
        if (!chartElem) {
            layoutElement.isValid = true;
            sb.LayoutDesigner.saveLayoutElementState(layoutElement);
        }

        var closePanel = true;
        var finishedSavingDeffered = $.Deferred();
        var titleItem

        if (chartElem) {
            if (chartElem.guid !== sb.GuiEvents.DataGroupEdit.getEditedChartElement().guid) {
                Storyboard.LayoutControls.showError(locale.get('Could not save chart since it\'s assigned to another layout element'));
            }
            else {
                if (!sb.GuiEvents.DataGroupEdit)     /* if DataGroupEdit is null, the data group hasn't been setup for editing and shouldn't be saved */
                    return;
                sb.GuiEvents.DataGroupEdit.storeCurrentDataGroup();
                var dataGroups = sb.GuiEvents.DataGroupEdit.getOrderedDataGroups();
                var deletedGroups = sb.GuiEvents.DataGroupEdit.getDeletedDataGroups();

                if (sb.GuiEvents.DataGroupEdit.validateDataGroups()) {
                    var elementType = Storyboard.LayoutDesigner.getLayoutElementType(layoutElement);
                    var message = elementType === itemTypes.SIMPLETABLE ? "Saving simple table settings" : "Saving chart settings";
                    var loadingBar = Storyboard.LayoutControls.showLoadingBar(locale.get(message));

                    ChartSetupDataCom.SaveDataGroups(dataGroups, deletedGroups, chartElem, function (res) {
                        function afterFinishedSaving() {
                            Storyboard.LayoutControls.hideLoadingBar(loadingBar);
                            layoutElement.isValid = true;
                            sb.LayoutDesigner.saveLayoutElementState(layoutElement);
                            curEditBox.removeClass('ui-invalid');

                            if (res.status === 'QUEUED') {
                                if (elementType === itemTypes.SIMPLETABLE) {
                                    Storyboard.LayoutControls.showMessage(locale.get('Simple table settings will be saved when the layout is saved'));
                                } else {
                                    Storyboard.LayoutControls.showMessage(locale.get('Chart settings will be saved when the layout is saved'));
                                }
                            } else {
                                var titleItem = getHeaderDivForLayoutElement(layoutElement);
                                var title = $(titleItem).text();
                                var titleText = (title.length > 0) ? ' - ' + title + ': ' : ': ';
                                if (elementType === itemTypes.SIMPLETABLE) {
                                    Storyboard.LayoutControls.showMessage('Tablebox ' + layoutElement.layoutElementId + titleText + locale.get('The simple table has been saved.'));
                                } else {
                                    Storyboard.LayoutControls.showMessage('Chartbox ' + layoutElement.layoutElementId + titleText + locale.get('The chart has been saved.'));
                                }

                                if (!Storyboard.LayoutDesigner.isUnsaved)
                                    Storyboard.LayoutDesigner.refreshSlideToplineCompatibility();
                            }
                            sb.GuiEvents.DataGroupEdit.clearDataGroups();
                            var items = [layoutElement];
                            Storyboard.LayoutDesigner.loadStorytellerContentForElements(items, true, false, 0, 0, layoutElement.guid);
                            if (typeof evt.data !== 'undefined' && evt.data.closePopUp == 'false') {
                                MultiEdit.ApplySettings();
                            }

                            finishedSavingDeffered.resolve();
                        }
                        
                        if (chartElem.itemType == itemTypes.CHART) {
                            Storyboard.HighchartsWrapper.Helpers.setTheme(ChartSetupUIObj.GetChartStyles(), layoutElement);
                            afterFinishedSaving();
                        } else
                            RespondentTableSetup.saveStylesForLayoutElement(layoutElement, function () { afterFinishedSaving(); });
                    });
                }
                else
                    closePanel = false;
            }
        }
        else if (textEditorElem) {
            titleItem = getHeaderDivForLayoutElement(layoutElement);
            var content = tinyMCE.get('txtTextMediaContent').getContent();
            var reg = new RegExp(/ src="([^"]+)/g);
            var matches = content.match(reg);

            $(matches).each(function () {
                var original = this;
                var fixed = original.replace(new RegExp(/\.\.\//g), "").replace("Storyboard/", "");
                content = content.replace(original, fixed);
            });

            Storyboard.Html.saveHtml(content, layoutElement.layoutElementId, layoutElement.guid, textEditorElem, $(titleItem).text());
            Storyboard.LayoutDesigner.updateLayoutElement(layoutElement);
        }
        else if (dataFieldElem) {
            if (DataFieldSetup.saveSetup(dataFieldElem)) {
                Storyboard.LayoutDesigner.updateLayoutElement(layoutElement);
                Storyboard.LayoutControls.hideLoadingBar();
            } else closePanel = false;
        }
        else if (tableElem) {
            Storyboard.LayoutControls.showLoadingBar(locale.get("Saving table setup"));
            $('#editCrosstab').contents().find('input[id$="btnSaveSettings"]').click();
        }
        else if (respondentTableElem) {
            Storyboard.LayoutControls.showLoadingBar(locale.get("Saving respondent table setup"));
            RespondentTableSetup.saveSetup(respondentTableElem);
            Storyboard.LayoutDesigner.updateLayoutElement(layoutElement);
            Storyboard.LayoutControls.hideLoadingBar();
        }
        else if (eventCreatorElem) {
            Storyboard.LayoutControls.showLoadingBar(locale.get("Saving event creator setup"));
            EventCreatorSetup.saveSetup(eventCreatorElem);
            Storyboard.LayoutDesigner.updateLayoutElement(layoutElement);
            Storyboard.LayoutControls.hideLoadingBar();
        }
        else if (iconShapeElem) {
            Storyboard.LayoutControls.showLoadingBar(locale.get("Saving icon/shape setup"));
            IconShapeSetup.saveSetup(iconShapeElem);
            Storyboard.LayoutControls.hideLoadingBar();
        }
        else if (dynamicIconShapeElem) {
            Storyboard.LayoutControls.showLoadingBar(locale.get("Saving dynamic icon/shape setup"));
            if (DynamicIconShapeSetup.saveSetup(dynamicIconShapeElem)) {
                Storyboard.LayoutControls.hideLoadingBar();
            } else closePanel = false;
        }
        else if (dynamicImageElem) {
            Storyboard.LayoutControls.showLoadingBar(locale.get("Saving dynamic image setup"));
            DynamicImageSetup.saveSetup(dynamicImageElem);
            Storyboard.LayoutDesigner.updateLayoutElement(layoutElement);
            Storyboard.LayoutControls.hideLoadingBar();
        }
        else if (summaryElem) {
            Storyboard.LayoutControls.showLoadingBar(locale.get("Saving summary setup"));
            if (SummarySetup.saveSetup(summaryElem)) {
                Storyboard.LayoutDesigner.updateLayoutElement(layoutElement);
                Storyboard.LayoutControls.hideLoadingBar();
            } else closePanel = false;
        }
        else if (advancedAnalyticsElem) {
            Storyboard.LayoutControls.showLoadingBar(locale.get("Saving advanced analytics setup"));
            if (AdvancedAnalyticsSetup.saveSetup(advancedAnalyticsElem)) {
                Storyboard.LayoutDesigner.updateLayoutElement(layoutElement);
                Storyboard.LayoutControls.hideLoadingBar();
            } else closePanel = false;
        }
        else if (wordCloudElem) {
            Storyboard.LayoutControls.showLoadingBar(locale.get("Saving word cloud setup"));
            WordCloudSetup.saveSetup(wordCloudElem);
            Storyboard.LayoutDesigner.updateLayoutElement(layoutElement);
            Storyboard.LayoutControls.hideLoadingBar();
        }
        else if (linkedChartElem) {
            Storyboard.LayoutControls.showLoadingBar(locale.get('Saving linked chart to contentbox. Please wait...'));
            if (LinkedChartSetup.validateInput()) {
                LinkedChartSetup.saveMapping(linkedChartElem, function (res) {
                    if (res.status === 'QUEUED')
                        Storyboard.LayoutControls.showMessage(locale.get('Linked chart settings will be saved when the layout is saved'));
                    else {
                        var titleItem = getHeaderDivForLayoutElement(layoutElement);
                        var title = $(titleItem).text();
                        var titleText = (title.length > 0) ? ' - ' + title + ': ' : ': ';
                        Storyboard.LayoutControls.showMessage('Chartbox ' + layoutElement.layoutElementId + titleText + locale.get('The chart has been saved.'));
                    }
                });
            }
            else {
                Storyboard.LayoutControls.showError(locale.get('Please define source chart.'));
            }
        }
        else if (imageElem) {
            Storyboard.LayoutDesigner.updateLayoutElement(layoutElement);
        }
        else if (staticTextElem) {
            titleItem = getHeaderDivForLayoutElement(layoutElement);
            Storyboard.Html.saveHtml($('.layoutElementItem[guid="' + staticTextElem.guid + '"]').html(), staticTextElem.layoutElementId, staticTextElem.guid, staticTextElem, $(titleItem).text());
            Storyboard.LayoutDesigner.updateLayoutElement(layoutElement);
        }
        if (typeof evt.data !== 'undefined' && evt.data.closePopUp == 'false') {
            closePanel = false;
        }
        if (evt.preventDefault) evt.preventDefault();

        if (closePanel) {
            if (chartElem) {
                $.when(finishedSavingDeffered).then(function () {
                    hideEditPanels(evt);
                    setTimeout(Storyboard.LayoutControls.hideLoadingBar, 2000);
                });
            } else {
                hideEditPanels(evt);
                setTimeout(Storyboard.LayoutControls.hideLoadingBar, 2000);
            }
        }
    }

    function showEnlargedChart(chart) {
        var serIx;
        var options = $.extend(true, {}, chart.options);
        options.chart.guid = 'largeChart';
        var chartDiv = $('#largeChartContainer')[0];
        options.chart.renderTo = chartDiv;

        // temporary solution for enlarged font in popup chart
        if (typeof (sbPopupChartFontSize) != 'undefined') {
            options.xAxis[0].labels.style.fontSize = sbPopupChartFontSize;
            options.yAxis[0].labels.style.fontSize = sbPopupChartFontSize;
            options.legend.itemStyle.fontSize = sbPopupChartFontSize;
        }

        if (typeof (sbPopupChartSeriesFontSize) != 'undefined') {
            for (serIx in options.series)
                options.series[serIx].dataLabels.style.fontSize = sbPopupChartSeriesFontSize;
        }

        $("#largeChart").dialog({
            position: 'center',
            width: 800,
            height: 600,
            closeOnEscape: true,
            modal: true,
            zIndex: 10001,
            resizeStop: function () { Storyboard.HighchartsWrapper.produceChart(chartDiv, options); }
        });

        Storyboard.HighchartsWrapper.produceChart(chartDiv, options);

    	// if series are hidden their labels will still show up in large chart. hide them properly
        var largeChart = $(chartDiv).highcharts();
        for (serIx in largeChart.series)
        	if (!largeChart.series[serIx].visible)
        		largeChart.series[serIx].hide();
    }

    function bindDrilldownAnswers(qaSelections) {
        $("#ddlDrilldownSelection > option").remove();
        $.each(qaSelections, function () {
            var li = $('<option value="' + this.drillDownId + '">' + this.text + '</option>');
            $("#ddlDrilldownSelection").append(li);
        });

        $("#ddlDrilldownSelection").bind("change", function () {
            if (dTable) {
                dTable.prevDrilldownSelection = dTable.drilldownSelection;
                dTable.drilldownSelection = $(this).val();
                dTable.fnDraw();
            }
        });
    }

    function displayDetailTable(guid, tableId, meta) {
        Helpers.fixDotnetCasing(meta);
        bindDrilldownAnswers(meta.qaSelections);


        //Data Tables can't destruct itself properly, we apply it on a element that can be deleted
        var dtGrid = $(".detailTableGridTemplate").clone().addClass("detailTableGrid").removeClass("detailTableGridTemplate");
        $("#detailTable").append(dtGrid);
        dTable = $(".detailTableGrid").dataTable({
            bJQueryUI: true,
            sPaginationType: "full_numbers",
            bServerSide: true,
            wAutoWidth: true,
            iDisplayLength: meta.defaultPageSize || 10,
            aLengthMenu: $.map(Array(20), function (e, i) { return (i + 1) * 5; }),
            aoColumns: meta.columns,
            fnServerData: function (sSource, aoData, fnCallback) {
                aoData[aoData.length] = { name: 'tableId', value: tableId };
                if (dTable && dTable.drilldownSelection && dTable.prevDrilldownSelection != dTable.drilldownSelection)
                    aoData[aoData.length] = { name: 'drilldownSelection', value: dTable.drilldownSelection };
                Storyboard.LayoutDesigner.getDetailTableData(aoData, function (data) {
                    /* reset drilldown parameter, since it only needs to be set when a new drilldown db call is needed */
                    !!dTable && delete dTable.drilldownSelection;
                    fnCallback(data);
                });
            }
        });


        $("#detailTable").show().dialog({
            position: 'center',
            width: 800,
            closeOnEscape: true,
            modal: true,
            close: function () {
                dTable.fnClearTable();
                dTable.fnDestroy();
                $(".detailTableGrid").remove();
                dTable = null;
            }

        });
    }

    function showDetailTable(tableId, guid) {
        var generalSettings = GeneralSettings.getSelectedSettings();
        Storyboard.LayoutDesigner.getDetailTable(tableId, guid, function (meta) {
            displayDetailTable(guid, tableId, meta);
        }, generalSettings);
    }

    function bindOptionalFilters(filterArray, filterBoxId, filterBoxTemplateClass, filterWrapper) {
        //remove all filterbox divs, except for the template

        $("#" + filterBoxId + " > div:not('." + filterBoxTemplateClass + "')").remove();
        $(filterArray).each(function () {
            var filter = $("." + filterBoxTemplateClass).clone();
            var inputId = filterBoxId + this.filterId;
            filter.removeClass(filterBoxTemplateClass);

            filter.find("input#chkOptFilter").attr('id', inputId);
            filter.find("label[for='chkOptFilter']").attr('for', inputId).append(": " + this.filterText);
            filter.find("#hidOptFilterId").val(this.filterId);
            filter.find('#hidOptQuestionId').val(this.questionId);
            $("#" + filterBoxId).append(filter);
        });
    }

    function bindOptionalFiltersCheckAll(filterBoxId) {
        var optionalFilterSettings = $('#' + filterBoxId).parent('.optionalFilterSettings');
        var checkAllEl = optionalFilterSettings.prev('.optionalFilterSettingsCheckAll').find('input[type="checkbox"]');

        checkAllEl.unbind('change.checkAll').bind('change.checkAll', function(evt) {
            var checkAll = $(this).is(':checked');

            optionalFilterSettings
                .find('input[type="checkbox"]')
                .filter(function() { return $(this).attr('id') !== 'chkOptFilter'; })
                .attr('checked', checkAll);
            });

        optionalFilterSettings
            .undelegate('checkAll')
            .delegate('input[type="checkbox"]', 'change.checkAll', function() {
                var allChecked = optionalFilterSettings
                    .find('input[type="checkbox"]')
                    .filter(function() { return $(this).attr('id') !== 'chkOptFilter'; })
                    .filter(function() { return !$(this).is(':checked'); })
                    .length === 0;

                checkAllEl.attr('checked', allChecked);
            });
    }

    function bindFilters(filterArray, filterBoxId, filterBoxTemplateClass, isUseFilterComparsion) {
        //remove all filterbox divs, except for the template

        $("#" + filterBoxId + " > .settingItemBlock:not('." + filterBoxTemplateClass + "')").remove();
        $(filterArray).each(function () {
            var isHidden = $(this)[0].isHidden;

            var filter = $("." + filterBoxTemplateClass).clone();
            filter.removeClass(filterBoxTemplateClass);

			filter.attr('loopImportId', this.loopImportId);
			filter.attr('isLoopIterator', this.isLoopIterator);
            filter.find("h3").append(this.filterText);
            filter.find("#hidFilterId").val(this.filterId);
            filter.find('#hidQuestionId').val(this.questionId);
            filter.find('#hidIsConnectedToWeights').val(this.isConnectedToWeights);

            if (isUseFilterComparsion) {
                filter.find("#chkCompare").change(function () { ChartSetupUI.addFilterToGrouping(this); });
                filter.find("select").change(function () { ChartSetupUI.filterNoSelection(this); ChartSetupUI.updateCompareFilterWeightSelections();  });
            }

            filter.find("#chkCompare").change(function () { ChartSetupUI.updateCompareFilterWeightSelections(); });
            filter.find("#chkUseDynamicWeighting").change(function () { ChartSetupUI.updateCompareFilterWeightSelections(); });
            
            var allItems = [];
            allItems.push({ answerId: "all", answerText: "--All--" });
            allItems = allItems.concat(this.answers);
            HTMLHelpers.bindSelect(filter.find("select"), allItems, 'answerId', 'answerText', 'No Selection', "null", "0", true);
            HTMLHelpers.setSelectedValues(filter.find('select'), 0);

            $("#" + filterBoxId).append(filter);
            if (isUseFilterComparsion) {
                ChartSetupUI.filterNoSelection(filter.find("select"), true);
            }

            if (isHidden) {
                filter.addClass('hiddenFilter');
            }
        });
        if (isUseFilterComparsion) {
            $("#" + filterBoxId + " > .floatClear").detach().appendTo("#" + filterBoxId);
        }
    }

    function deafultChartZoom(type, layoutElement) {
        if (type == Storyboard.Constants.itemTypes.CHART && layoutElement.layoutElementId == 0) {
            Storyboard.Dependency.start('CHARTSETUP', 'ZoomDefaultSetting');
            ChartSetupProxy.GetAllowZoomDefaultSetting(function (data) {
                var defaultSetting = data;
                if (defaultSetting)
                    $("#hiddenZoom").val("1");
                Storyboard.Dependency.complete('CHARTSETUP', 'ZoomDefaultSetting');
            });
        }
    }

    function deafultDecimalSeparator() {
        ChartSetupProxy.GetDecimalOperator(function (data) {
            $("#decimalSeparator").val(data.DecimalSeparator);
            $("#thousandSeparator").val(data.ThousandSeparator);
        });

    }

    function selectBox(divLayoutElement, layoutElement) {
        $(divLayoutElement).addClass('ui-selected').focus();
        layoutElement.isSelected = true;
        Storyboard.EventBus.emit(Storyboard.Constants.Events.LAYOUT_ELEMENT_SELECTED, layoutElement);
    }

    function deselectBox(divLayoutElement, layoutElement) {
        $(divLayoutElement).removeClass('ui-selected').blur();
        layoutElement.isSelected = false;
        Storyboard.EventBus.emit(Storyboard.Constants.Events.LAYOUT_ELEMENT_DESELECTED, layoutElement);
    }

    function selectGroupsFromSelectedElements() {
        var layoutElements = Storyboard.LayoutDesigner.getLayoutElements();
        var groupIDs = layoutElements.reduce(function(acc, curr) {
            if (curr.isSelected === true && curr.groupId && acc.indexOf(curr.groupId) === -1) {
                acc.push(curr.groupId);
                return acc;
            }
            return acc;
        }, []);

        groupIDs.forEach(function (id) {
            selectGroup(id);
        });
    }

    function selectGroup(groupId) {
        var layoutGrid = $('#layoutArea');
        var layoutElementsGroup = Storyboard.LayoutDesigner.getLayoutElementsGroup(groupId);

        if (!layoutElementsGroup ||
             layoutElementsGroup.layoutElements.length === 0 ||
             layoutElementsGroup.isSelected) return;

        var layoutElements = layoutElementsGroup.layoutElements;
        var guids = [], zIndex = [], slide, $slide, $layoutElements, cancelClick;

        for (var i in layoutElements)
            if (layoutElements.hasOwnProperty(i)) {
                layoutElements[i].isSelected = false;
                guids.push(layoutElements[i].guid);
                zIndex.push(layoutElements[i].zIndex);
            }

        layoutElementsGroup.isSelected = true;
        $layoutElements = $('#' + guids.join(', #')).not('.ui-locked');
        slide = Storyboard.LayoutDesigner.getSlideByLayoutElement(layoutElements[0]);
        $slide = $('#' + slide.guid, layoutGrid);

        $layoutElements.removeClass('ui-selected')
            .addClass('ui-group-selected').trigger('mouseleave')
            .children('.DUI-ST-EL-DIMENSION').remove();

        var groupElement = $('<div/>', {
            'class': 'layoutElementsGroup',
            'id': 'layoutelementsgroup-' + layoutElementsGroup.groupId,
            'layoutelementsgroupid': + layoutElementsGroup.groupId,
            'data-groupname': layoutElementsGroup.groupName === '' ? 
                                locale.get('Group ') + layoutElementsGroup.groupId :
                                layoutElementsGroup.groupName,
            'html': uiBorders
        })
        .css({ 'z-index': Math.max.apply(null, zIndex) })
        .attr({ 'tabindex': 0 })
        .appendTo($slide);

        Storyboard.GuiEvents.positionGroupBoundaries(groupId, layoutElements);

        groupElement
            .bind("click", function (evt) {
                evt.preventDefault();
                if (cancelClick) {
                    cancelClick = false;
                    return false;
                }
                if (evt.ctrlKey || evt.metaKey) {
                    deselectGroup(groupId)
                    updateTemplatesMenu();
                    Storyboard.LayoutDesigner.LayoutElementsToolbar.updateToolbarState();
                    evt.stopPropagation();
                } else {
                    groupElement.hide();
                    $(document.elementFromPoint(evt.clientX, evt.clientY)).closest('.layoutElement').trigger(evt);
                }
            })

            .bind("contextmenu", function (evt) {
                evt.preventDefault();
                evt.stopPropagation();
                Storyboard.GuiEvents.hideAllMenusAndPanels(evt);

                if (window.ContentType === itemTypes.CHART) {
                    ChartCreatorUI.closeAllMenus();
                    ChartCreatorUI.showContextMenu(evt);
                } else {
                    Storyboard.GuiEvents.showContextMenu(evt);
                }
            })
            
            .bind("keydown", function(evt) {
                if ($(evt.target).hasClass('layoutElementsGroup') &&
                    (evt.keyCode >= 37 && evt.keyCode <= 40 || evt.which >= 37 &&
                    evt.which <= 40 || evt.keyCode === 9 || evt.which === 9)) {
                        evt.preventDefault();
                }

                if (evt.ctrlKey || evt.metaKey || evt.altKey) return;

                layoutElementItemManipulation.move(evt);
            })

            .hover(
                function (evt) {
                    Storyboard.GuiEvents.updateGroupCoordsAndSizes(this);
                    $(this).addClass('ui-hover');
                },
                function (evt) {
                    $(this).removeClass('ui-hover').children('.DUI-ST-EL-DIMENSION').remove();
                }
            )
            .focus();

        if (!Storyboard.LayoutDesigner.lockPositions) {
            groupElement.draggable({
                scroll: true
            });

            groupElement
                .bind("dragstart", function(evt, ui) {
                    $('.ui-selected, .ui-group-selected, .layoutElementsGroup', layoutGrid).each(setOriginalSizeAndPosition);
                    Storyboard.GuiEvents.hideAllMenusAndPanels(evt);
                    
                    if (evt.ctrlKey || evt.altKey) {
                        createDraggingCloneElements();
                    }

					if (ui) {
						bindCopyCursorEvents(evt);
					}
                })
                
                .bind("drag", function(evt, ui) {
                    dragHandler(evt, ui);
                    Storyboard.GuiEvents.updateGroupCoordsAndSizes(groupElement, ui);
                })
                
                .bind("dragstop", function (evt, ui) {
                    var stateObj = {eventName: "move", eventElements : []};

                    unbindCopyCursorEvents(evt);
                    removeDraggingCloneElements();

                    moveOrDuplicate(evt, ui, stateObj);

                    Storyboard.GuiEvents.updateGroupCoordsAndSizes(groupElement);
                    Storyboard.LayoutDesigner.layoutElementsSizeOrCoordChanged(stateObj);
                    cancelClick = true;
                });
            }

        if (!Storyboard.LayoutDesigner.lockSizes) {
            groupElement.resizable({
                handles: 'all',
                autoHide: true,
                zIndex: 1000,
            });

            groupElement
                .bind("resizestart", function(evt, ui) {
                    $('.ui-selected, .ui-group-selected, .layoutElementsGroup', layoutGrid).each(setOriginalSizeAndPosition);
                    $(this).resizable('option', 'aspectRatio', $('#DUI-ST-TB-ASPECT-RATIO').hasClass('locked'));
                     Storyboard.GuiEvents.hideAllMenusAndPanels(evt);
                })

                .bind("resize", function(evt, ui) {
                    if (typeof ui !== 'object') return;

                    resizeHandler(evt, ui);
                    Storyboard.GuiEvents.updateGroupCoordsAndSizes(groupElement, ui);
                })

                .bind("resizestop", function (evt, ui) {
                    var stateObj = {eventName: "resize", eventElements : []};
                    
                    resizeStopHandler(evt, ui, stateObj);

                    Storyboard.GuiEvents.updateGroupCoordsAndSizes(groupElement);
                    Storyboard.LayoutDesigner.layoutElementsSizeOrCoordChanged(stateObj);
                    cancelClick = true;
                });
            }
    }

    function deselectGroup(groupId) {
        var layoutElementsGroup = Storyboard.LayoutDesigner.getLayoutElementsGroup(groupId);
        var layoutElements = layoutElementsGroup.layoutElements;

        for (var i in layoutElements)
            if (layoutElements.hasOwnProperty(i))
                $('#' + layoutElements[i].guid).removeClass('ui-group-selected');

        layoutElementsGroup.isSelected = false;
        $('#layoutelementsgroup-' + groupId).remove();
    }

    function getElementsBoundingRect(layoutElements) {
        var rect = {top: [], left: [], width: [], height: []};

        for (var i in layoutElements)
            if (layoutElements.hasOwnProperty(i)) {
                rect.top.push(layoutElements[i].yCoord);
                rect.left.push(layoutElements[i].xCoord);
                rect.width.push(layoutElements[i].xCoord + layoutElements[i].width);
                rect.height.push(layoutElements[i].yCoord + layoutElements[i].height);
            }

        rect.top = Math.min.apply(null, rect.top);
        rect.left = Math.min.apply(null, rect.left);
        rect.width = Math.max.apply(null, rect.width) - rect.left;
        rect.height = Math.max.apply(null, rect.height) - rect.top;

        return rect;
    }

    function positionGroupBoundaries(groupId, layoutElements) {
        layoutElements = layoutElements || Storyboard.LayoutDesigner.getLayoutElementsByGroup(groupId);
        var groupCoords = getElementsBoundingRect(layoutElements);

        $('#layoutelementsgroup-' + groupId).css({
            top:     groupCoords.top,
            left:    groupCoords.left,
            width:   groupCoords.width,
            height:  groupCoords.height
        });
    }

    function positionGroupsBoundaries() {
        $('.layoutElementsGroup', '#layoutArea').each(function() {
            var groupId = parseInt($(this).attr('layoutelementsgroupid'));
            var curLayoutElements = Storyboard.LayoutDesigner.getLayoutElementsByGroup(groupId);
            Storyboard.GuiEvents.positionGroupBoundaries(groupId, curLayoutElements);
        });
    }

    function renameGroup(groupId) {
        var groupElement = $('#layoutelementsgroup-' + groupId);
        
        var renameGroup = function() {
            groupId = parseInt(groupId, 10);
            var layoutElementsGroup = Storyboard.LayoutDesigner.getLayoutElementsGroup(groupId);
            
            if (layoutElementsGroup) {
                layoutElementsGroup.groupName = $('#groupNewName').val();
                groupElement.attr('data-groupname', layoutElementsGroup.groupName);
                Storyboard.LayoutDesigner.setState(true); //unsaved state
            }
        };

        new DUIwindow2({
            title: '<h2>Rename group</h2>',
            width: 400,
            buttons: [
                { text: 'Cancel', closeWindow: true },
                { text: 'Rename', focused: true, onClick: renameGroup }
            ],
            html: '<div class="settingItem">'+
                    '<label for="groupNewName" class="settingLabel">New group name:</label>' +
                    '<input id="groupNewName" class="settingControl textbox"></input>' +
                  '</div>',
            afterShow: function () {
                $('#groupNewName').focus();
            }
        });
    }

    function disableOperationsInBgSlide(disable) {
        var operations = $([
            ".DUI-ST-R-ADDSLIDE",
            "#DUI-ST-R-RESIZESLIDE",
            "#DUI-ST-R-COPYSLIDE",
            "#DUI-ST-R-ARRANGESLIDE",
            "#DUI_ST_R_DOCUMENTFORMATSETUP",
            "#DUI-ST-R-SHOWFILTERPANEL",
            "#DUI-ST-R-SHOWHFILTERSSETUP",
			"#DUI-ST-R-EXCLUDESLIDES",
			"#DUI_ST_R_REFERENCEDATASETUP",
            "#DUI_ST_R_AUTOUPDATESETTINGS",
            "#DUI_ST_R_AUTOUPDATESETTINGS_ON",
            "#DUI_ST_R_AUTOUPDATESETTINGS_OFF",
            "#DUI-ST-R-SHOWCHARTLABSETUP",
            "#DUI_ST_R_FAVORIESETTINGS",
            "#DUI-ST-R-ACTIVATE_EVENTSERVER",
            "#DUI_ST_R_FAVORITESETTINGS_ON",
            "#DUI_ST_R_FAVORITESETTINGS_OFF"
        ].join(","));

        if (disable)
            operations.attr("disabled", "disabled");
        else
            operations.removeAttr("disabled");

        Storyboard.GuiEvents.disableDeleteSlide();
        Storyboard.GuiEvents.updateTemplatesMenu();
        Storyboard.GuiEvents.hideSlideNavigation(disable);
    }

    function disableDeleteSlide() {
        var bgSlide = $(".bgSlideActive").length > 0;
        var separateSlides = Storyboard.LayoutDesigner.slideShowMode;

        if ($(".layoutSlide:not(.bgSlide)").length <= 1 || bgSlide || !separateSlides) {
            $("#DUI-ST-R-DELETESLIDE, #removeSlide_cc, #slidesPanel .slides-panel-remove").attr("disabled", "disabled");
        } else {
            $("#DUI-ST-R-DELETESLIDE, #removeSlide_cc, #slidesPanel .slides-panel-remove").removeAttr("disabled");
        }
	}

    function updateTemplatesMenu() {
        if (!window.IsStoryboard || window.IsMyStories || window.ContentType > -1 || 
            !Storyboard.LayoutDesigner.isAdmin || Helpers.isPreview()) {
                return false;
            }

        var allSelector = `
            #DUI_ST_R_SAVEELEMENTTEMPLATE,
            #DUI_ST_R_SAVEGROUPTEMPLATE,
            #DUI_ST_R_SAVESLIDETEMPLATE,
            #DUI_ST_R_SAVEREPORTTEMPLATE,
            #DUI_ST_R_SAVESLIDETOTEMPLATESET
        `;

        var bgSlideActive = $('#layoutArea .bgSlideActive').length > 0;
        var layoutElementsSelected = $('#layoutArea .ui-selected').length === 1;
        var groupsSelected = $('#layoutArea .layoutElementsGroup').length === 1;

        if (Storyboard.LayoutDesigner.isUnsaved) {
            $(allSelector)
                .attr({
                    disabled: 'disabled',
                    title: 'Templates cannot be saved until the layout is saved',
                });

        } else {
            $(allSelector)
                .removeAttr('disabled')
                .removeAttr('title');

            $('#DUI_ST_R_SAVEELEMENTTEMPLATE').attr('disabled', bgSlideActive || !(layoutElementsSelected && !groupsSelected));
            $('#DUI_ST_R_SAVEGROUPTEMPLATE').attr('disabled', bgSlideActive || !(!layoutElementsSelected && groupsSelected));
            
            $('#DUI_ST_R_SAVESLIDETEMPLATE').find('span em').text(bgSlideActive ? locale.get("Save background as template") : locale.get("Save slide as template"));

            var currentSlide = Storyboard.LayoutDesigner.getCurrentSlide();
            if (bgSlideActive || !(currentSlide && currentSlide.isToplineCompatible)) {
                $('#DUI_ST_R_SAVESLIDETOTEMPLATESET').attr('disabled', 'disabled');
            } else {
                $('#DUI_ST_R_SAVESLIDETOTEMPLATESET').removeAttr('disabled');
            }
            $('#DUI_ST_R_SAVESLIDETOTEMPLATESET').attr('title', (currentSlide && currentSlide.isToplineCompatible) ? '' : locale.get('This slide cannot be saved into a Template set'));
        }

        Storyboard.EventBus.emit(Storyboard.Constants.Events.SET_TEMPLATE_OPTIONS);
    }

    // Make events public access
    sb.GuiEvents.saveSettings = saveSettings;
    sb.GuiEvents.addEventsToLayoutElement = addEventsToLayoutElement;
    sb.GuiEvents.addEventsToLayoutGrid = addEventsToLayoutGrid;
    sb.GuiEvents.redrawLayoutElement = redrawLayoutElement;
    sb.GuiEvents.DeleteDOMElement = DeleteDOMElement;
    sb.GuiEvents.redrawLayoutGrid = redrawLayoutGrid;
    sb.GuiEvents.updateChart = updateChart;
    sb.GuiEvents.updateSimpleTable = updateSimpleTable;
    sb.GuiEvents.updateDynamicText = updateDynamicText;
    sb.GuiEvents.updateLayoutTitles = updateLayoutTitles;
    sb.GuiEvents.getHeaderDivForLayoutElement = getHeaderDivForLayoutElement;
    sb.GuiEvents.getChartDivForLayoutElement = getChartDivForLayoutElement;
    sb.GuiEvents.getFooterDivForLayoutElement = getFooterDivForLayoutElement;
    sb.GuiEvents.setSBLink = setSBLink;
    sb.GuiEvents.getLayoutSizeSelection = getLayoutSizeSelection;
    sb.GuiEvents.setLayoutGridLayoutType = setLayoutGridLayoutType;
    sb.GuiEvents.setLayoutGridPageCount = setLayoutGridPageCount;
    sb.GuiEvents.getHeaderDivForLayoutElement = getHeaderDivForLayoutElement;
    sb.GuiEvents.getFooterDivForLayoutElement = getFooterDivForLayoutElement;
    sb.GuiEvents.disableUIForDocumentFormat = disableUIForDocumentFormat;
    sb.GuiEvents.isElementDisabled = isElementDisabled;
    sb.GuiEvents.clickInContentbox = clickInContentbox;
    sb.GuiEvents.showContextMenu = showContextMenu;
    sb.GuiEvents.getContextMenuSection = getContextMenuSection;
    sb.GuiEvents.bindTooltips = bindTooltips;
    sb.GuiEvents.showContextDUIButtons = showContextDUIButtons;
    sb.GuiEvents.showStandardDUIButtons = showStandardDUIButtons;
    sb.GuiEvents.setupEditMode = SetupEditMode;
    sb.GuiEvents.showEditPanel = showEditPanel;
    sb.GuiEvents.hideEditPanel = hideEditPanel;
    sb.GuiEvents.deselectAndHideAll = deselectAndHideAll;
    sb.GuiEvents.deselectAllBoxes = deselectAllBoxes;
    sb.GuiEvents.deselectAllGroups = deselectAllGroups;
    sb.GuiEvents.hideAllMenusAndPanels = hideAllMenusAndPanels;
    sb.GuiEvents.hideEditPanels = hideEditPanels;
    sb.GuiEvents.toggleBackground = toggleBackground;
    sb.GuiEvents.setLayoutBackground = setLayoutBackground;
    sb.GuiEvents.toggleGridlines = toggleGridlines;
    sb.GuiEvents.toggleBorders = toggleBorders;
    sb.GuiEvents.toggleResultsTooltips = toggleResultsTooltips;
    sb.GuiEvents.showEnlargedChart = showEnlargedChart;
    sb.GuiEvents.showDetailTable = showDetailTable;
    sb.GuiEvents.centerObjectVertical = centerObjectVertical;
    sb.GuiEvents.zIndexBase = zIndexBase;
    sb.GuiEvents.arrangeElements = arrangeElements;
    sb.GuiEvents.arrangeElementToIndex = arrangeElementToIndex;
    sb.GuiEvents.setElementsCoord = setElementsCoord;
    sb.GuiEvents.setElementsSize = setElementsSize;
    sb.GuiEvents.setElementsFullSize = setElementsFullSize;
    sb.GuiEvents.alignElementToGrid = alignElementToGrid;
    sb.GuiEvents.setLayoutElementHidden = setLayoutElementHidden;
    sb.GuiEvents.setLayoutElementLocked = setLayoutElementLocked;
    sb.GuiEvents.layoutElementResized = layoutElementResized;
    sb.GuiEvents.tableToolPostSave = tableToolPostSave;
    sb.GuiEvents.updateElementCoordsAndSizes = updateElementCoordsAndSizes;
    sb.GuiEvents.switchPlacesBetweenLayoutElements = switchPlacesBetweenLayoutElements;
    sb.GuiEvents.getCachedStoryboardTableCompleted = getCachedStoryboardTableCompleted;
    sb.GuiEvents.bindOptionalFilters = bindOptionalFilters;
    sb.GuiEvents.bindOptionalFiltersCheckAll = bindOptionalFiltersCheckAll;
    sb.GuiEvents.bindFilters = bindFilters;
    sb.GuiEvents.deafultDecimalSeparator = deafultDecimalSeparator;
    sb.GuiEvents.hideSlideNavigation = hideSlideNavigation;
    sb.GuiEvents.selectGroup = selectGroup;
    sb.GuiEvents.deselectGroup = deselectGroup;
    sb.GuiEvents.renameGroup = renameGroup;
    sb.GuiEvents.updateGroupCoordsAndSizes = updateGroupCoordsAndSizes;
    sb.GuiEvents.positionGroupBoundaries = positionGroupBoundaries;
    sb.GuiEvents.positionGroupsBoundaries = positionGroupsBoundaries;
    sb.GuiEvents.showTemplatesPanel = showTemplatesPanel;
    sb.GuiEvents.hideTemplatesPanel = hideTemplatesPanel;
    sb.GuiEvents.setupSingleObjectMode = setupSingleObjectMode;
    sb.GuiEvents.setupRTStyling = setupRTStyling;
    sb.GuiEvents.showComputesPanel = showComputesPanel;
    sb.GuiEvents.hideComputesPanel = hideComputesPanel;
    sb.GuiEvents.disableOperationsInBgSlide = disableOperationsInBgSlide;
    sb.GuiEvents.disableDeleteSlide = disableDeleteSlide;
    sb.GuiEvents.updateTemplatesMenu = updateTemplatesMenu;
	sb.GuiEvents.renderExcelExportOption = renderExcelExportOption;
	sb.GuiEvents.exportObjectToExcel = exportObjectToExcel;
    sb.GuiEvents.exportObjectToImage = exportObjectToImage;
	sb.GuiEvents.selectBox = selectBox;
    sb.GuiEvents.deselectBox = deselectBox;
	sb.GuiEvents.createObjectTypeControls = createObjectTypeControls;
    sb.GuiEvents.createShapeTypeControls = createShapeTypeControls;
	sb.GuiEvents.positionContextMenu = positionContextMenu;
	// slides operations
    sb.GuiEvents.redrawLayoutSlide = redrawLayoutSlide;
})(window.Storyboard = (window.Storyboard || {}));

$(document).ready(function () {
    $showBaseSelOptions = $("#ddlShowBase > option").clone();
    $trimLowBaseOtions = $("#ddlTrimLowBase > option").clone();
    $warnLowBaseOptions = $("#ddlWarnLowBase > option").clone();
    $sigTestLimitBaseOptions = $("#ddlSigTestLimitBase > option").clone();

    var calculationType = $("#ddlCalculationType").val() || "";
    var elementsToHide;

    if (calculationType == "2" && $("#hdnExclAverage").val() == "1") {
        $('#ddlShowBase').empty().append($showBaseSelOptions);
        $('#ddlTrimLowBase').empty().append($trimLowBaseOtions);
        $('#ddlWarnLowBase').empty().append($warnLowBaseOptions);
        $('#ddlSigTestLimitBase').empty().append($sigTestLimitBaseOptions);
    } else {
        $('#ddlShowBase').empty().append($showBaseSelOptions.filter('.nonavg'));
        $('#ddlTrimLowBase').empty().append($trimLowBaseOtions.filter('.nonavg'));
        $('#ddlWarnLowBase').empty().append($warnLowBaseOptions.filter('.nonavg'));
        $('#ddlSigTestLimitBase').empty().append($sigTestLimitBaseOptions.filter('.nonavg'));
    }

    if (window.IsStoryboard && self != top && window.name == "print-frame") { // form is in iframe, hide some controls
        elementsToHide = ['#header',
            '#pnlSettingsPanel',
            '#updGeneralSettings',
            '#reportNav div',
            '#pageStoryTellerToolbar',
            '#StorytellerObjectsToolbar',
            '#DUI_ST_NAVIGATOR',
            '#ADMIN_RH_PREVIEWMODE_PANEL',
            '#poweredby',
            '#largeChart',
            '#respTableFullScreen',
            '#reportTabStripWrapper',
            '#presentationControls',
            '#adminToolbar'];
        $('#reportNav').css('height', '0');
        $('#reportNav').css('background', 'none');
        $(elementsToHide.join(',')).hide();
        $("#printLinkPanel").show();
        //translate controls
        $("#btnFormPrint").text(locale.get('Print'));
        $("#btnFormCancel").text(locale.get('Cancel'));
        $("#layoutArea").append("<div class='printOverlay'></div>");
        $("#pageWrapper").css("padding", "0px");
        $("#btnPrintPreviewClose").click(function() {
            $('.DUI-WINDOW-CLOSE', window.parent.document).click();
        });
    }

    if (window.IsMyStories == undefined) {
        $("#fsDocFormatSharing").remove();
    }

	if ((window.IsFormReport || window.IsDrilldown) && self != top) { // form is in iframe, hide some controls
        elementsToHide = ['#header',
            '#divFormSettings',
            '#poweredby',
            '#pageStoryTellerToolbar span:not(.btnPrintStory)',
            '#ADMIN_RH_PREVIEWMODE_PANEL',
            '#presentationControls',
            '#adminToolbar'];

        if (window.name == "print-frame") {
            elementsToHide.push('#updGeneralSettings');
            elementsToHide.push('#reportNav');
            elementsToHide.push('#pnlSettingsPanel');
            elementsToHide.push('#pageStoryTellerToolbar');
            elementsToHide.push('#StorytellerObjectsToolbar');
            elementsToHide.push('#siteNav ul');
            elementsToHide.push('#reportTabStripWrapper');
            elementsToHide.push('#adminToolbar');
            $("#printLinkPanel").show();
            //translate controls
            $("#btnFormPrint").text(locale.get('Print'));
            $("#btnFormCancel").text(locale.get('Cancel'));
            $("#layoutArea").append("<div class='printOverlay'></div>");

            window.parent.$(".DUI-WINDOW-CLOSE").hide();
            $("#btnPrintPreviewClose").click(function() {
                var formReportIFrame = $('iframe.formReport', parent.document).last();
                if (formReportIFrame.length > 0) {
                    var width = formReportIFrame.closest(".DUI-WINDOW-2").width();
                    var height = formReportIFrame.closest(".DUI-WINDOW-BODY").height();
                    formReportIFrame.closest(".DUI-WINDOW-2").width(width - 150);
                    formReportIFrame.closest(".DUI-WINDOW-BODY").height(height - 100);
                }
                $('.DUI-WINDOW-CLOSE', window.parent.document).click();
            });
        } else {
            $("#form1, #pageWrapper, #reportWrapper, #contentWrapper").css("height", "100%");
        }

        $("#pageWrapper").css("padding", "0px");
        $("html").removeClass("admin");
        $(elementsToHide.join(',')).hide();
    }

    if ($('#lMsg').text() === "Updated the data model") {
        $('#lMsg').empty();
        Storyboard.LayoutControls.showMessage("Updated the data model");
    }

    if (window.useNewStoryTellerLayout) {
        $('html').addClass('new-storyteller-layout');
    }
});

/* Storyboard asynchronous dependency load tracking */
(function (sb) {

var DependencyHub = function() {
    
    var dependencies = {};
    var listeners = {};

    var dependencyList = function() {
        return new function() {
            var dependencies = [];

            return {
                define: function(dependencyName) {
                    if (!dependencies.includes(dependencyName)) dependencies.push(dependencyName);
                },
                resolve: function(dependencyName) {
                    if (dependencies.includes(dependencyName)) dependencies.splice(dependencies.indexOf(dependencyName), 1);
                },
                isResolved: function() {
                    return dependencies.length === 0;
                }
            }
        };
    };

    return {
        
        // Storyboard.Dependency.start(['CHARTSETUP', 'SIMPLETABLESETUP'], 'icons');
        start: function(types, dependencyNames) {
            if (typeof types === 'string') types = [types];
            if (typeof dependencyNames === 'string') dependencyNames = [dependencyNames];
            
            types.forEach(function(type) {
                if (!dependencies[type])
                    dependencies[type] = new dependencyList();
                
                dependencyNames.forEach(function(dependencyName) {
                    dependencies[type].define(dependencyName);
                });

                if (typeof listeners[type] === 'object') {
                    listeners[type].start.forEach(function(fn) {
                        if (typeof fn === 'function') fn(type);
                    });
                }
            });
        },

        // Storyboard.Dependency.complete(['CHARTSETUP', 'SIMPLETABLESETUP'], 'icons');
        complete: function(types, dependencyNames) {
            if (typeof types === 'string') types = [types];
            if (typeof dependencyNames === 'string') dependencyNames = [dependencyNames];

            types.forEach(function(type) {
                dependencyNames.forEach(function(dependencyName) {
                    if (typeof dependencies[type] !== 'object') return;

                    dependencies[type].resolve(dependencyName);

                    if (dependencies[type].isResolved()) {
                        if (typeof listeners[type] === 'object') {
                            listeners[type].complete.forEach(function(fn) {
                                fn(type);
                            });
                        }

                        delete dependencies[type];
                    }
                });
            });
        },

        on: function(event, types, handler) {
            if (typeof types === 'string') types = [types];
            types.forEach(function(type) {
               if (!listeners[type]) listeners[type] = { 'start': [], 'complete': [] };
               listeners[type][event].push(handler);
            });
        },
    }
};

sb.Dependency = new DependencyHub();

sb.Dependency.on('start', [
    'CHARTSETUP',
    'SIMPLETABLESETUP',
    'RESPONDENTTABLESETUP',
    'WORDCLOUDSETUP',
    'ICONSHAPESETUP',
    'DYNAMICICONSHAPESETUP'
    ], function(type) {
        $('#DUI-ST-SAVESETTINGS').attr('disabled', true);
});

sb.Dependency.on('complete', [
    'CHARTSETUP',
    'SIMPLETABLESETUP',
    'RESPONDENTTABLESETUP',
    'WORDCLOUDSETUP',
    'ICONSHAPESETUP',
    'DYNAMICICONSHAPESETUP'
    ], function(type) {
        $('#DUI-ST-SAVESETTINGS').attr('disabled', false);
});

sb.Dependency.on('start', ['CHARTSETUP', 'SIMPLETABLESETUP'], function(type) {
    $('#btnUpdateChart').attr('disabled', true);
});
sb.Dependency.on('complete', ['CHARTSETUP', 'SIMPLETABLESETUP'], function(type) {
    $('#btnUpdateChart').attr('disabled', false);
});

sb.Dependency.on('start', 'RESPONDENTTABLESETUP', function(type) {
    $('#DUI_RT_PREVIEW, #rtExcelExportPreview, #rtCSVExportPreview').attr('disabled', true);
});
sb.Dependency.on('complete', 'RESPONDENTTABLESETUP', function(type) {
    $('#DUI_RT_PREVIEW, #rtExcelExportPreview, #rtCSVExportPreview').attr('disabled', false);
});

sb.Dependency.on('start', 'WORDCLOUDSETUP', function(type) {
    $('#DUI_WC_PREVIEW').attr('disabled', true);
});
sb.Dependency.on('complete', 'WORDCLOUDSETUP', function(type) {
    $('#DUI_WC_PREVIEW').attr('disabled', false);
});

sb.Dependency.on('start', 'DYNAMICICONSHAPESETUP', function(type) {
    $('#btnUpdateDynamicIcon').attr('disabled', true);
});
sb.Dependency.on('complete', 'DYNAMICICONSHAPESETUP', function(type) {
    $('#btnUpdateDynamicIcon').attr('disabled', false);
});

sb.Dependency.on('start', ['CROSSTABLEREPORT'], function(type) {
    if (window.ContentType === Storyboard.Constants.itemTypes.CROSSTABLE) {
        if ($('.crosstable-loading-overlay').length === 0) {
            $('body').append('<div class="crosstable-loading-overlay"></div>');
        }
        Storyboard.LayoutControls.showLoadingBar('Loading...');
        Storyboard.LayoutControls.loadingBarDisabled = true;
    }
});

sb.Dependency.on('complete', ['CROSSTABLEREPORT'], function(type) {
    if (window.ContentType === Storyboard.Constants.itemTypes.CROSSTABLE) {
        $('.crosstable-loading-overlay').remove();
        Storyboard.LayoutControls.loadingBarDisabled = false;
        Storyboard.LayoutControls.hideLoadingBar();
    }
});

sb.Dependency.on('start', ['CROSSTABLESHEET'], function(type) {
    if (window.ContentType === Storyboard.Constants.itemTypes.CROSSTABLE) {
        if ($('.crosstable-loading-overlay').length === 0) {
            $('body').append('<div class="crosstable-loading-overlay"></div>');
        }
    }
});

sb.Dependency.on('complete', ['CROSSTABLESHEET'], function(type) {
    if (window.ContentType === Storyboard.Constants.itemTypes.CROSSTABLE) {
        var sheet = SheetsPanel.getSheetByGuid(CrossTable2Setup.getLoadedSheetGuid());
        if (sheet && !sheet.dataGroup) {
            CrossTable2Setup.setSheetDataGroupProperty();
        }
        if (sheet && !sheet.params) {
            sheet.params = JSON.parse(JSON.stringify(CrossTable2DataCom.GetPreviewTableParams()));
        }
        $('.crosstable-loading-overlay').remove();
    }
});

    sb.Dependency.on('complete', ['CROSSTABLESHEET'], function (type) {
        if (window.ContentType === Storyboard.Constants.itemTypes.CROSSTABLE) {             
            if (CrossTable2UIObj.GetIsGridView()) {
                if (sessionStorage.getItem("dataGroupLoaded") == "true") {
                    let groupPosition;
                    const groupedItems = window.CrossTable2UIObj.GetDatagroupFromGui().groupedItems;
                    const questionGroup = groupedItems.find(el => el.value === "question");
                    if (questionGroup) {
                        groupPosition = questionGroup.position;
                    }
                    const isWrongTranspose = parseInt(sessionStorage.getItem("gridPosition")) !== groupPosition;                    
                    if ($(".splits-dropzone:visible").length) {                    
                        $("html").removeClass("transpose-questions-answers");                        
                    }
                        if (!$("#groupingTable_ct").find("ul.rows-questions").length) {
                            CrossTable2UI.addRemoveTranspose(true);
                        } else {
                            CrossTable2UI.addRemoveTranspose(false);
                    } 
                    if (CrossTable2DataBinding.GetGroupingByValue("question").position === 1) {
                        $("html").addClass("transpose-questions-answers");
                    } else {
                        $("html").removeClass("transpose-questions-answers");
                    }
                    if (sessionStorage.getItem("gridTranspose") === "true" || isWrongTranspose) {
                        CrossTable2DataBinding.TransposeGridAnswers(false);
                        sessionStorage.removeItem("gridTranspose");
                    }                     
                    sessionStorage.removeItem("dataGroupLoaded"); 
                    
                }
            }
        }
    });

})(window.Storyboard = (window.Storyboard || {}));
/* end Storyboard asynchronous dependency load tracking */

window.ddlLng_OnSelectedIndexChanged = function () {
    Helpers.performJSonCall(
        'RHViewStoryboard.aspx/setGUILanguage',
        { sLng: $('#ddlLng').val() },
        function (result) {
            if (result.length > 0) {
                window.location.reload();
            }
        },
        function () { },
        true
    );
};

window.erq_ReportTreePanel = function () {
    if (window.ContentType > 0) { // single object mode
        $("#reportTreeNavigationLegend").html("Report navigation");
        $("#btnChangeStoryboard").html("Change Report");
        $("#txtChangeStorytellerButtonText").val("Change Report");
    }

    // Auto hide message label in reporttreepanel
    setTimeout("Storyboard.LayoutDesigner.endRequestReportTreePanel", 2500);

    //localize title
    $("#closeReportTreePanel").attr('title', locale.get('Close this panel'));

    // Close ReportTreePanel arrowimage
    $('#closeReportTreePanel').click(function (evt) {
        $(this).attr('title', locale.get('Close this panel'));
        evt.preventDefault();
        evt.stopPropagation();
        if (Storyboard.LayoutDesigner.isAdmin)
            Storyboard.LayoutDesigner.hideReportTreePanel(evt);
        else
            $('#reportbar').toggle();
    });
};

window.erq_RibbonMenu = function () {

    if (window.IsFormReport) {
        $(['#DUI_ST_R_ADDCOMPONENT_DYNAMICIMAGE',
            '#DUI_ST_R_ADDCOMPONENT_CHART',
            '#DUI_ST_R_ADDCOMPONENT_SIMPLETABLE',
            '#DUI_ST_R_ADDCOMPONENT_CROSSTABLE',
            '#DUI_ST_R_ADDCOMPONENT_WORDCLOUD',
            '#DUI_ST_R_ADDCOMPONENT_SUMMARY',
            '#DUI_ST_R_ADDCOMPONENT_ADVANCEDANALYTICS',
            '#DUI_ST_R_SLIDECOMMANDS',
            '#DUI_ST_R_IMAGEQUALITY',
            '#DUI_ST_R_ADDCOMPONENT_DYNAMICICONSHAPE',
            '#DUI_ST_R_TEMPLATES',
            '#DUI_ST_R_TEMPLATES',
            '#DUI_ST_R_TOPLINES',
            '#ribbonMenuContentItem_5',
            '#ribbonMenuContentItem_3',
            '#ribbonMenuTopItem_6',
            '#ribbonMenuTopItem_3',
        ].join(',')).remove();

        $(["#fsDocFormatNavigation",
			"#sfDocFormatImageQuality",
			"#fsHideOneReportPerFilter"
		].join(",")).hide();

        $(["#resptabholder a[href='#filters']",
            "#rtFullScreenMode",
            "#rtSorting",
            "#rtDisplayFilterInfo",
            "#btnChangeStoryboard"].join(",")).hide();

        $("#rtSortingContentPanel").detach().appendTo(".siCustomerSorting");
        $("#hdCustomerHistory").show();
    }
    else {
        $('#DUI_ST_R_ADDCOMPONENT_DATAFIELD').remove();
        $('#ribbonMenuContentItem_4').remove();
        $('#ribbonMenuTopItem_4').remove();
        $('#DUI_ST_R_FORMCONTENT').remove();
    }

    if (window.IsDrilldown) {
        $('#ribbonMenuTopItem_3, #btnMyStories').remove();

        $([
			'#fsDeviceLimitation',
			'#optionFilterSettingPanel',
			'#disOoptionFilterSettingPanel'
        ].join(',')).hide();
    }

    if ($('input[id$="hidUseNewColorTemplateLogic"]').val() !== 'True')
        $('#DUI_ST_R_COLORS').parent().remove();

    window.initRibbonMenu();
};

window.prefixAdded = false;

window.handleHelpIDsPrefix = function (addPrefix) {
    if (addPrefix) {
        var helpPrefix = "20";
        $('#setupHolder [data-docsapiid]').each(function () {
            $(this).attr('data-docsapiid', helpPrefix + $(this).attr('data-docsapiid'));
        });
        window.prefixAdded = true;
    }
    else {
        if (window.prefixAdded)
            $('#setupHolder [data-docsapiid]').each(function () {
                $(this).attr('data-docsapiid', String($(this).attr('data-docsapiid')).substring(2));
            });
        window.prefixAdded = false;
    }
};

window.changeHelpIDs = function (elementType) {
    switch (elementType) {
        case parseInt(Storyboard.Constants.itemTypes.CHART, 0):
            $('#setupHolder').removeClass('simpleTableSetup');
            window.handleHelpIDsPrefix(false);
            break;
        case parseInt(Storyboard.Constants.itemTypes.SIMPLETABLE, 0):
            $('#setupHolder').addClass('simpleTableSetup');
            window.handleHelpIDsPrefix(true);
            break;
    }
};
